/* eslint-disable */
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions =  {}
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  BigInt: any;
  Date: any;
  DateTime: any;
  /** SCALARS */
  JSON: any;
  UUID: any;
  Upload: any;
};

export type ApplePendingRenewalInfo = {
  __typename?: 'ApplePendingRenewalInfo';
  auto_renew_product_id: Scalars['String'];
  auto_renew_status?: Maybe<Scalars['String']>;
  is_in_billing_retry_period?: Maybe<Scalars['String']>;
  original_transaction_id: Scalars['String'];
  product_id: Scalars['String'];
};

export type AppleReceiptData = {
  __typename?: 'AppleReceiptData';
  expires_date: Scalars['String'];
  in_app_ownership_type: Scalars['String'];
  is_in_intro_offer_period: Scalars['String'];
  is_trial_period: Scalars['String'];
  original_transaction_id: Scalars['String'];
  pending_renewal_info?: Maybe<ApplePendingRenewalInfo>;
  product_id: Scalars['String'];
  purchase_date: Scalars['String'];
  subscription_group_identifier: Scalars['String'];
  transaction_id: Scalars['String'];
};

export type AuthResponse = {
  __typename?: 'AuthResponse';
  accessToken: Scalars['String'];
  refreshToken: Scalars['String'];
  user: User;
};

export type DefaultConnection = {
  cursor: Scalars['Int'];
  limit: Scalars['Int'];
  searchable?: Maybe<Array<Scalars['String']>>;
  sortable?: Maybe<Array<Scalars['String']>>;
  total?: Maybe<Scalars['Int']>;
};

export type DefaultQueryInput = {
  /** Выдывать все поля? */
  allFields?: Maybe<Scalars['Boolean']>;
  /** Получение только необходимых аттрибутов модели */
  attributes?: Maybe<Array<Scalars['String']>>;
  /** Пропуск элементов */
  cursor?: Maybe<Scalars['Int']>;
  filters?: Maybe<Array<FilterInput>>;
  /** Лимит выборки */
  limit?: Maybe<Scalars['Int']>;
  locale?: Maybe<Scalars['String']>;
  /** Строковый поиск */
  search?: Maybe<Scalars['String']>;
  /** Сортировка */
  sort?: Maybe<Array<Maybe<DefaultSortInput>>>;
};

/** Сортировка данных */
export type DefaultSortInput = {
  /** Направление сортировки */
  direction: SortingDirection;
  /** поле сортировки */
  field: Scalars['String'];
};

export type EntityDataInput = {
  key: Scalars['String'];
  type?: Maybe<EntityDataType>;
  value?: Maybe<Scalars['String']>;
};

export enum EntityDataType {
  ARRAY = 'ARRAY',
  BOOLEAN = 'BOOLEAN',
  ENUM = 'ENUM',
  FILES = 'FILES',
  JSON = 'JSON',
  NUMBER = 'NUMBER',
  STRING = 'STRING'
}

export type File = {
  bitrate?: Maybe<Scalars['Float']>;
  duration?: Maybe<Scalars['Float']>;
  height?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['ID']>;
  mimeType: LibraryFileMimeType;
  name: Scalars['String'];
  previewUrl: Scalars['String'];
  size?: Maybe<Scalars['Int']>;
  url: Scalars['String'];
  width?: Maybe<Scalars['Int']>;
};

export enum FilterDataType {
  ARRAY = 'ARRAY',
  BOOLEAN = 'BOOLEAN',
  DATE = 'DATE',
  ENUM = 'ENUM',
  NUMBER = 'NUMBER',
  STRING = 'STRING',
  TIME = 'TIME'
}

export type FilterInput = {
  dataType?: Maybe<FilterDataType>;
  field: Scalars['String'];
  isExclude?: Maybe<Scalars['Boolean']>;
  isRange?: Maybe<Scalars['Boolean']>;
  isSearch?: Maybe<Scalars['Boolean']>;
  value: Scalars['String'];
};

export type FilterItem = {
  __typename?: 'FilterItem';
  dataType: FilterDataType;
  field: Scalars['String'];
  isExcludAvailable: Scalars['Boolean'];
  isRangeAvailable: Scalars['Boolean'];
  max?: Maybe<Scalars['Int']>;
  min?: Maybe<Scalars['Int']>;
  options?: Maybe<Array<Maybe<FilterItemOption>>>;
  step?: Maybe<Scalars['Int']>;
  type: FilterType;
};

export type FilterItemOption = {
  __typename?: 'FilterItemOption';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export enum FilterType {
  CHECKBOX = 'CHECKBOX',
  INPUT = 'INPUT',
  RANGE = 'RANGE',
  SELECT = 'SELECT',
  SELECT_MULTIPLE = 'SELECT_MULTIPLE'
}

export type LibraryBackground = {
  __typename?: 'LibraryBackground';
  category?: Maybe<LibraryCategory>;
  categoryId?: Maybe<Scalars['Int']>;
  color?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  file?: Maybe<LibraryFile>;
  fileId?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
  ownerId: Scalars['Int'];
  sortIndex: Scalars['Int'];
  tagId?: Maybe<Scalars['Int']>;
  teamId: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
};

export type LibraryBackgroundConnection = DefaultConnection & {
  __typename?: 'LibraryBackgroundConnection';
  cursor: Scalars['Int'];
  edges: Array<LibraryBackground>;
  limit: Scalars['Int'];
  searchable?: Maybe<Array<Scalars['String']>>;
  sortable?: Maybe<Array<Scalars['String']>>;
  total: Scalars['Int'];
};

export type LibraryBackgroundCreateInput = {
  categoryId?: Maybe<Scalars['Int']>;
  color?: Maybe<Scalars['String']>;
  fileId?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  ownerId: Scalars['Int'];
  sortIndex?: Maybe<Scalars['Int']>;
  tagId?: Maybe<Scalars['Int']>;
  teamId: Scalars['Int'];
};

export type LibraryBackgroundUpdateInput = {
  categoryId?: Maybe<Scalars['Int']>;
  color?: Maybe<Scalars['String']>;
  fileId?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  ownerId?: Maybe<Scalars['Int']>;
  sortIndex?: Maybe<Scalars['Int']>;
  tagId?: Maybe<Scalars['Int']>;
  teamId?: Maybe<Scalars['Int']>;
};

export type LibraryCategory = {
  __typename?: 'LibraryCategory';
  color?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  entity: LibraryCategoryEntity;
  id: Scalars['Int'];
  isSystem: Scalars['Boolean'];
  itemsCount: Scalars['Int'];
  name: Scalars['String'];
  ownerId: Scalars['Int'];
  sortIndex: Scalars['Int'];
  tag?: Maybe<LibraryTag>;
  tagId?: Maybe<Scalars['Int']>;
  teamId: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
};

export type LibraryCategoryConnection = DefaultConnection & {
  __typename?: 'LibraryCategoryConnection';
  cursor: Scalars['Int'];
  edges: Array<LibraryCategory>;
  limit: Scalars['Int'];
  searchable?: Maybe<Array<Scalars['String']>>;
  sortable?: Maybe<Array<Scalars['String']>>;
  total: Scalars['Int'];
};

export type LibraryCategoryCreateInput = {
  color?: Maybe<Scalars['String']>;
  entity: LibraryCategoryEntity;
  isSystem?: Maybe<Scalars['Boolean']>;
  itemsCount?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  ownerId: Scalars['Int'];
  sortIndex?: Maybe<Scalars['Int']>;
  tagId?: Maybe<Scalars['Int']>;
  teamId: Scalars['Int'];
};

export enum LibraryCategoryEntity {
  BACKGROUND = 'BACKGROUND',
  COLOR = 'COLOR',
  FONT = 'FONT',
  LOGO = 'LOGO',
  SOUND = 'SOUND',
  STICKER = 'STICKER',
  TEXT_PRESET = 'TEXT_PRESET'
}

export type LibraryCategoryUpdateInput = {
  color?: Maybe<Scalars['String']>;
  entity?: Maybe<LibraryCategoryEntity>;
  isSystem?: Maybe<Scalars['Boolean']>;
  itemsCount?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  ownerId?: Maybe<Scalars['Int']>;
  sortIndex?: Maybe<Scalars['Int']>;
  tagId?: Maybe<Scalars['Int']>;
  teamId?: Maybe<Scalars['Int']>;
};

export type LibraryColor = {
  __typename?: 'LibraryColor';
  category?: Maybe<LibraryCategory>;
  categoryId?: Maybe<Scalars['Int']>;
  createdAt: Scalars['DateTime'];
  id: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
  ownerId: Scalars['Int'];
  sortIndex: Scalars['Int'];
  tagId?: Maybe<Scalars['Int']>;
  teamId: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
  value: Scalars['String'];
};

export type LibraryColorConnection = DefaultConnection & {
  __typename?: 'LibraryColorConnection';
  cursor: Scalars['Int'];
  edges: Array<LibraryColor>;
  limit: Scalars['Int'];
  searchable?: Maybe<Array<Scalars['String']>>;
  sortable?: Maybe<Array<Scalars['String']>>;
  total: Scalars['Int'];
};

export type LibraryColorCreateInput = {
  categoryId?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  ownerId: Scalars['Int'];
  sortIndex?: Maybe<Scalars['Int']>;
  tagId?: Maybe<Scalars['Int']>;
  teamId: Scalars['Int'];
  value: Scalars['String'];
};

export type LibraryColorUpdateInput = {
  categoryId?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  ownerId?: Maybe<Scalars['Int']>;
  sortIndex?: Maybe<Scalars['Int']>;
  tagId?: Maybe<Scalars['Int']>;
  teamId?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['String']>;
};

export type LibraryFile = {
  __typename?: 'LibraryFile';
  bitrate?: Maybe<Scalars['Int']>;
  createdAt: Scalars['DateTime'];
  duration?: Maybe<Scalars['Int']>;
  errors?: Maybe<Array<Scalars['String']>>;
  height?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  mimeType: LibraryFileMimeType;
  name: Scalars['String'];
  ownerId: Scalars['Int'];
  previewUrl?: Maybe<Scalars['String']>;
  ratio?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['DateTime'];
  url: Scalars['String'];
  warnings?: Maybe<Array<Scalars['String']>>;
  width?: Maybe<Scalars['Int']>;
};

export type LibraryFileConnection = DefaultConnection & {
  __typename?: 'LibraryFileConnection';
  cursor: Scalars['Int'];
  edges: Array<LibraryFile>;
  limit: Scalars['Int'];
  searchable?: Maybe<Array<Scalars['String']>>;
  sortable?: Maybe<Array<Scalars['String']>>;
  total: Scalars['Int'];
};

export type LibraryFileCreateInput = {
  bitrate?: Maybe<Scalars['Int']>;
  duration?: Maybe<Scalars['Int']>;
  height?: Maybe<Scalars['Int']>;
  mimeType: LibraryFileMimeType;
  name: Scalars['String'];
  ownerId: Scalars['Int'];
  previewUrl?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['Int']>;
  url: Scalars['String'];
  width?: Maybe<Scalars['Int']>;
};

export enum LibraryFileMimeType {
  AIFF = 'AIFF',
  GIF = 'GIF',
  JPEG = 'JPEG',
  JPG = 'JPG',
  MP3 = 'MP3',
  OTF = 'OTF',
  PNG = 'PNG',
  TTF = 'TTF',
  WAV = 'WAV'
}

export type LibraryFileUpdateInput = {
  bitrate?: Maybe<Scalars['Int']>;
  duration?: Maybe<Scalars['Int']>;
  height?: Maybe<Scalars['Int']>;
  mimeType?: Maybe<LibraryFileMimeType>;
  name?: Maybe<Scalars['String']>;
  ownerId?: Maybe<Scalars['Int']>;
  previewUrl?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['Int']>;
  url?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['Int']>;
};

export type LibraryFont = {
  __typename?: 'LibraryFont';
  category?: Maybe<LibraryCategory>;
  categoryId?: Maybe<Scalars['Int']>;
  createdAt: Scalars['DateTime'];
  file?: Maybe<LibraryFile>;
  fileId: Scalars['Int'];
  id: Scalars['Int'];
  name: Scalars['String'];
  ownerId: Scalars['Int'];
  sortIndex: Scalars['Int'];
  styles: Array<Scalars['String']>;
  teamId: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
};

export type LibraryFontConnection = DefaultConnection & {
  __typename?: 'LibraryFontConnection';
  cursor: Scalars['Int'];
  edges: Array<LibraryFont>;
  limit: Scalars['Int'];
  searchable?: Maybe<Array<Scalars['String']>>;
  sortable?: Maybe<Array<Scalars['String']>>;
  total: Scalars['Int'];
};

export type LibraryFontCreateInput = {
  categoryId?: Maybe<Scalars['Int']>;
  fileId: Scalars['Int'];
  name: Scalars['String'];
  ownerId: Scalars['Int'];
  sortIndex?: Maybe<Scalars['Int']>;
  styles?: Maybe<Array<Scalars['String']>>;
  teamId: Scalars['Int'];
};

export type LibraryFontUpdateInput = {
  categoryId?: Maybe<Scalars['Int']>;
  fileId?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  ownerId?: Maybe<Scalars['Int']>;
  sortIndex?: Maybe<Scalars['Int']>;
  styles?: Maybe<Array<Scalars['String']>>;
  teamId?: Maybe<Scalars['Int']>;
};

export type LibraryLogo = {
  __typename?: 'LibraryLogo';
  category?: Maybe<LibraryCategory>;
  categoryId?: Maybe<Scalars['Int']>;
  createdAt: Scalars['DateTime'];
  file?: Maybe<LibraryFile>;
  fileId: Scalars['Int'];
  id: Scalars['Int'];
  name: Scalars['String'];
  ownerId: Scalars['Int'];
  sortIndex: Scalars['Int'];
  teamId: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
};

export type LibraryLogoConnection = DefaultConnection & {
  __typename?: 'LibraryLogoConnection';
  cursor: Scalars['Int'];
  edges: Array<LibraryLogo>;
  limit: Scalars['Int'];
  searchable?: Maybe<Array<Scalars['String']>>;
  sortable?: Maybe<Array<Scalars['String']>>;
  total: Scalars['Int'];
};

export type LibraryLogoCreateInput = {
  categoryId?: Maybe<Scalars['Int']>;
  fileId: Scalars['Int'];
  name: Scalars['String'];
  ownerId: Scalars['Int'];
  sortIndex?: Maybe<Scalars['Int']>;
  teamId: Scalars['Int'];
};

export type LibraryLogoUpdateInput = {
  categoryId?: Maybe<Scalars['Int']>;
  fileId?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  ownerId?: Maybe<Scalars['Int']>;
  sortIndex?: Maybe<Scalars['Int']>;
  teamId?: Maybe<Scalars['Int']>;
};

export type LibrarySound = {
  __typename?: 'LibrarySound';
  category?: Maybe<LibraryCategory>;
  categoryId?: Maybe<Scalars['Int']>;
  createdAt: Scalars['DateTime'];
  file?: Maybe<LibraryFile>;
  fileId?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  name: Scalars['String'];
  ownerId: Scalars['Int'];
  sortIndex: Scalars['Int'];
  teamId: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
};

export type LibrarySoundConnection = DefaultConnection & {
  __typename?: 'LibrarySoundConnection';
  cursor: Scalars['Int'];
  edges: Array<LibrarySound>;
  limit: Scalars['Int'];
  searchable?: Maybe<Array<Scalars['String']>>;
  sortable?: Maybe<Array<Scalars['String']>>;
  total: Scalars['Int'];
};

export type LibrarySoundCreateInput = {
  categoryId?: Maybe<Scalars['Int']>;
  fileId?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  ownerId: Scalars['Int'];
  sortIndex?: Maybe<Scalars['Int']>;
  teamId: Scalars['Int'];
};

export type LibrarySoundUpdateInput = {
  categoryId?: Maybe<Scalars['Int']>;
  fileId?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  ownerId?: Maybe<Scalars['Int']>;
  sortIndex?: Maybe<Scalars['Int']>;
  teamId?: Maybe<Scalars['Int']>;
};

export type LibrarySticker = {
  __typename?: 'LibrarySticker';
  category?: Maybe<LibraryCategory>;
  categoryId?: Maybe<Scalars['Int']>;
  createdAt: Scalars['DateTime'];
  file?: Maybe<LibraryFile>;
  fileId: Scalars['Int'];
  id: Scalars['Int'];
  name: Scalars['String'];
  ownerId: Scalars['Int'];
  sortIndex: Scalars['Int'];
  teamId: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
};

export type LibraryStickerConnection = DefaultConnection & {
  __typename?: 'LibraryStickerConnection';
  cursor: Scalars['Int'];
  edges: Array<LibrarySticker>;
  limit: Scalars['Int'];
  searchable?: Maybe<Array<Scalars['String']>>;
  sortable?: Maybe<Array<Scalars['String']>>;
  total: Scalars['Int'];
};

export type LibraryStickerCreateInput = {
  categoryId?: Maybe<Scalars['Int']>;
  fileId: Scalars['Int'];
  name: Scalars['String'];
  ownerId: Scalars['Int'];
  sortIndex?: Maybe<Scalars['Int']>;
  teamId: Scalars['Int'];
};

export type LibraryStickerUpdateInput = {
  categoryId?: Maybe<Scalars['Int']>;
  fileId?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  ownerId?: Maybe<Scalars['Int']>;
  sortIndex?: Maybe<Scalars['Int']>;
  teamId?: Maybe<Scalars['Int']>;
};

export type LibraryTag = {
  __typename?: 'LibraryTag';
  color?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  id: Scalars['Int'];
  name: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type LibraryTagConnection = DefaultConnection & {
  __typename?: 'LibraryTagConnection';
  cursor: Scalars['Int'];
  edges: Array<LibraryTag>;
  limit: Scalars['Int'];
  searchable?: Maybe<Array<Scalars['String']>>;
  sortable?: Maybe<Array<Scalars['String']>>;
  total: Scalars['Int'];
};

export type LibraryTagCreateInput = {
  color?: Maybe<Scalars['String']>;
  name: Scalars['String'];
};

export type LibraryTagUpdateInput = {
  color?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type LibraryTextPreset = {
  __typename?: 'LibraryTextPreset';
  backgroundColor?: Maybe<LibraryBackground>;
  backgroundColorId?: Maybe<Scalars['Int']>;
  category?: Maybe<LibraryCategory>;
  categoryId?: Maybe<Scalars['Int']>;
  createdAt: Scalars['DateTime'];
  font?: Maybe<LibraryFont>;
  fontAlignment?: Maybe<LibraryTextPresetFontAlignment>;
  fontColor?: Maybe<LibraryColor>;
  fontColorId?: Maybe<Scalars['Int']>;
  fontId?: Maybe<Scalars['Int']>;
  fontSize?: Maybe<Scalars['Float']>;
  frameSize?: Maybe<LibraryTextPresetFrameSize>;
  id: Scalars['Int'];
  name: Scalars['String'];
  ownerId: Scalars['Int'];
  sortIndex: Scalars['Int'];
  teamId: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
};

export type LibraryTextPresetConnection = DefaultConnection & {
  __typename?: 'LibraryTextPresetConnection';
  cursor: Scalars['Int'];
  edges: Array<LibraryTextPreset>;
  limit: Scalars['Int'];
  searchable?: Maybe<Array<Scalars['String']>>;
  sortable?: Maybe<Array<Scalars['String']>>;
  total: Scalars['Int'];
};

export type LibraryTextPresetCreateInput = {
  backgroundColorId?: Maybe<Scalars['Int']>;
  categoryId?: Maybe<Scalars['Int']>;
  fontAlignment?: Maybe<LibraryTextPresetFontAlignment>;
  fontColorId?: Maybe<Scalars['Int']>;
  fontId?: Maybe<Scalars['Int']>;
  fontSize?: Maybe<Scalars['Float']>;
  frameSize?: Maybe<LibraryTextPresetFrameSize>;
  name: Scalars['String'];
  ownerId: Scalars['Int'];
  sortIndex?: Maybe<Scalars['Int']>;
  teamId: Scalars['Int'];
};

export enum LibraryTextPresetFontAlignment {
  CENTER = 'CENTER',
  JUSTIFY = 'JUSTIFY',
  LEFT = 'LEFT',
  RIGHT = 'RIGHT'
}

export enum LibraryTextPresetFrameSize {
  DEFAULT = 'DEFAULT',
  FULL_SIZE = 'FULL_SIZE'
}

export type LibraryTextPresetUpdateInput = {
  backgroundColorId?: Maybe<Scalars['Int']>;
  categoryId?: Maybe<Scalars['Int']>;
  fontAlignment?: Maybe<LibraryTextPresetFontAlignment>;
  fontColorId?: Maybe<Scalars['Int']>;
  fontId?: Maybe<Scalars['Int']>;
  fontSize?: Maybe<Scalars['Float']>;
  frameSize?: Maybe<LibraryTextPresetFrameSize>;
  name?: Maybe<Scalars['String']>;
  ownerId?: Maybe<Scalars['Int']>;
  sortIndex?: Maybe<Scalars['Int']>;
  teamId?: Maybe<Scalars['Int']>;
};

export type Locale = {
  __typename?: 'Locale';
  createdAt: Scalars['DateTime'];
  id: Scalars['Int'];
  iso: Scalars['String'];
  title: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export enum LocaleEnum {
  EN = 'EN',
  RU = 'RU'
}

export type LoginInput = {
  email: Scalars['String'];
  password: Scalars['String'];
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Принять приглашение в команду */
  acceptUserInvite: UserInvite;
  createLibraryBackground: LibraryBackground;
  createLibraryCategory: LibraryCategory;
  createLibraryColor: LibraryColor;
  createLibraryFile: LibraryFile;
  createLibraryFont: LibraryFont;
  createLibraryLogo: LibraryLogo;
  createLibrarySound: LibrarySound;
  createLibrarySticker: LibrarySticker;
  createLibraryTag: LibraryTag;
  createLibraryTextPreset: LibraryTextPreset;
  createSystemTranslation: SystemTranslation;
  createTemplate: Template;
  createTemplateCategory: TemplateCategory;
  createUserInvite: UserInvite;
  createUserRole: UserRole;
  createUserTeam: UserTeam;
  createUserTeamMember: UserTeamMember;
  /** Отклонить приглашение в команду */
  declineUserInvite: UserInvite;
  deleteLibraryBackground: LibraryBackground;
  deleteLibraryCategory: LibraryCategory;
  deleteLibraryColor: LibraryColor;
  deleteLibraryFile: LibraryFile;
  deleteLibraryFont: LibraryFont;
  deleteLibraryLogo: LibraryLogo;
  deleteLibrarySound: LibrarySound;
  deleteLibrarySticker: LibrarySticker;
  deleteLibraryTag: LibraryTag;
  deleteLibraryTextPreset: LibraryTextPreset;
  deleteSystemTranslation: SystemTranslation;
  deleteTemplate: Template;
  deleteTemplateCategory: TemplateCategory;
  deleteUserInvite: UserInvite;
  deleteUserProfile: Scalars['Boolean'];
  deleteUserRole: UserRole;
  deleteUserTeam: UserTeam;
  deleteUserTeamMember: UserTeamMember;
  /** Удаление подписки или понижение тарифа */
  downgradeTier: User;
  /** Заморозка подписки */
  freezeTier: User;
  /** Логин */
  login: AuthResponse;
  /** Регистрация */
  register: AuthResponse;
  /** Сброс пароля */
  resetUserPassword: Scalars['Boolean'];
  /**
   * Сохранение новых переводов в массиве.
   * Если перевод с таким ключом, локалью и ID клиента присутствует, он будет обновлен.
   * Если отсутствует - создан.
   */
  saveSystemTranslations: Array<SystemTranslation>;
  sortLibraryBackgrounds: Scalars['Boolean'];
  /**
   * Для сортировки передаем массив сущностей. Порядок в массиве и будет записан в базе.
   * Поле sortIndex будет проигнорировано!
   */
  sortLibraryColors: Scalars['Boolean'];
  sortLibraryFonts: Scalars['Boolean'];
  sortLibraryLogos: Scalars['Boolean'];
  sortLibrarySounds: Scalars['Boolean'];
  sortLibraryStickers: Scalars['Boolean'];
  sortLibraryTextPresets: Scalars['Boolean'];
  sortTemplateCategories: Scalars['Boolean'];
  /**
   * Для сортировки передаем массив сущностей. Порядок в массиве и будет записан в базе.
   * Поле sortIndex будет проигнорировано!
   */
  sortTemplates: Scalars['Boolean'];
  test?: Maybe<Scalars['String']>;
  updateLibraryBackground: LibraryBackground;
  updateLibraryCategory: LibraryCategory;
  updateLibraryColor: LibraryColor;
  updateLibraryFile: LibraryFile;
  updateLibraryFont: LibraryFont;
  updateLibraryLogo: LibraryLogo;
  updateLibrarySound: LibrarySound;
  updateLibrarySticker: LibrarySticker;
  updateLibraryTag: LibraryTag;
  updateLibraryTextPreset: LibraryTextPreset;
  updateSystemTranslation: SystemTranslation;
  updateTemplate: Template;
  updateTemplateCategory: TemplateCategory;
  updateUserInvite: UserInvite;
  /** Редактирование профиля пользователя */
  updateUserProfile: User;
  updateUserRole: UserRole;
  updateUserTeam: UserTeam;
  updateUserTeamMember: UserTeamMember;
  /** Добавление и обновление подписки */
  upgradeTier: User;
  /** Проверка всех активных и истекших подписок */
  verifyTiers: Scalars['Boolean'];
  /** Подверждение почты */
  verifyUserEmail: User;
};


export type MutationAcceptUserInviteArgs = {
  key: Scalars['String'];
};


export type MutationCreateLibraryBackgroundArgs = {
  data: LibraryBackgroundCreateInput;
};


export type MutationCreateLibraryCategoryArgs = {
  data: LibraryCategoryCreateInput;
};


export type MutationCreateLibraryColorArgs = {
  data: LibraryColorCreateInput;
};


export type MutationCreateLibraryFileArgs = {
  data: LibraryFileCreateInput;
};


export type MutationCreateLibraryFontArgs = {
  data: LibraryFontCreateInput;
};


export type MutationCreateLibraryLogoArgs = {
  data: LibraryLogoCreateInput;
};


export type MutationCreateLibrarySoundArgs = {
  data: LibrarySoundCreateInput;
};


export type MutationCreateLibraryStickerArgs = {
  data: LibraryStickerCreateInput;
};


export type MutationCreateLibraryTagArgs = {
  data: LibraryTagCreateInput;
};


export type MutationCreateLibraryTextPresetArgs = {
  data: LibraryTextPresetCreateInput;
};


export type MutationCreateSystemTranslationArgs = {
  data: SystemTranslationCreateInput;
};


export type MutationCreateTemplateArgs = {
  data: TemplateCreateInput;
};


export type MutationCreateTemplateCategoryArgs = {
  data: TemplateCategoryCreateInput;
};


export type MutationCreateUserInviteArgs = {
  data: UserInviteCreateInput;
};


export type MutationCreateUserRoleArgs = {
  data: UserRoleCreateInput;
};


export type MutationCreateUserTeamArgs = {
  data: UserTeamCreateInput;
};


export type MutationCreateUserTeamMemberArgs = {
  data: UserTeamMemberCreateInput;
};


export type MutationDeclineUserInviteArgs = {
  key: Scalars['String'];
};


export type MutationDeleteLibraryBackgroundArgs = {
  id: Scalars['Int'];
};


export type MutationDeleteLibraryCategoryArgs = {
  destinationCatgoryId?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
};


export type MutationDeleteLibraryColorArgs = {
  id: Scalars['Int'];
};


export type MutationDeleteLibraryFileArgs = {
  id: Scalars['Int'];
};


export type MutationDeleteLibraryFontArgs = {
  id: Scalars['Int'];
};


export type MutationDeleteLibraryLogoArgs = {
  id: Scalars['Int'];
};


export type MutationDeleteLibrarySoundArgs = {
  id: Scalars['Int'];
};


export type MutationDeleteLibraryStickerArgs = {
  id: Scalars['Int'];
};


export type MutationDeleteLibraryTagArgs = {
  id: Scalars['Int'];
};


export type MutationDeleteLibraryTextPresetArgs = {
  id: Scalars['Int'];
};


export type MutationDeleteSystemTranslationArgs = {
  id: Scalars['Int'];
};


export type MutationDeleteTemplateArgs = {
  id: Scalars['Int'];
};


export type MutationDeleteTemplateCategoryArgs = {
  destinationCatgoryId?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
};


export type MutationDeleteUserInviteArgs = {
  id: Scalars['Int'];
};


export type MutationDeleteUserRoleArgs = {
  id: Scalars['Int'];
};


export type MutationDeleteUserTeamArgs = {
  id: Scalars['Int'];
};


export type MutationDeleteUserTeamMemberArgs = {
  id: Scalars['Int'];
};


export type MutationFreezeTierArgs = {
  freezeFinishedAt: Scalars['Date'];
};


export type MutationLoginArgs = {
  data: LoginInput;
};


export type MutationRegisterArgs = {
  data: RegisterInput;
};


export type MutationResetUserPasswordArgs = {
  confirmationKey?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
};


export type MutationSaveSystemTranslationsArgs = {
  data: Array<SystemTranslationSaveInput>;
};


export type MutationSortLibraryBackgroundsArgs = {
  data: Array<SortInput>;
};


export type MutationSortLibraryColorsArgs = {
  data: Array<SortInput>;
};


export type MutationSortLibraryFontsArgs = {
  data: Array<SortInput>;
};


export type MutationSortLibraryLogosArgs = {
  data: Array<SortInput>;
};


export type MutationSortLibrarySoundsArgs = {
  data: Array<SortInput>;
};


export type MutationSortLibraryStickersArgs = {
  data: Array<SortInput>;
};


export type MutationSortLibraryTextPresetsArgs = {
  data: Array<SortInput>;
};


export type MutationSortTemplateCategoriesArgs = {
  data: Array<SortInput>;
};


export type MutationSortTemplatesArgs = {
  data: Array<SortInput>;
};


export type MutationUpdateLibraryBackgroundArgs = {
  data: LibraryBackgroundUpdateInput;
  id: Scalars['Int'];
};


export type MutationUpdateLibraryCategoryArgs = {
  data: LibraryCategoryUpdateInput;
  id: Scalars['Int'];
};


export type MutationUpdateLibraryColorArgs = {
  data: LibraryColorUpdateInput;
  id: Scalars['Int'];
};


export type MutationUpdateLibraryFileArgs = {
  data: LibraryFileUpdateInput;
  id: Scalars['Int'];
};


export type MutationUpdateLibraryFontArgs = {
  data: LibraryFontUpdateInput;
  id: Scalars['Int'];
};


export type MutationUpdateLibraryLogoArgs = {
  data: LibraryLogoUpdateInput;
  id: Scalars['Int'];
};


export type MutationUpdateLibrarySoundArgs = {
  data: LibrarySoundUpdateInput;
  id: Scalars['Int'];
};


export type MutationUpdateLibraryStickerArgs = {
  data: LibraryStickerUpdateInput;
  id: Scalars['Int'];
};


export type MutationUpdateLibraryTagArgs = {
  data: LibraryTagUpdateInput;
  id: Scalars['Int'];
};


export type MutationUpdateLibraryTextPresetArgs = {
  data: LibraryTextPresetUpdateInput;
  id: Scalars['Int'];
};


export type MutationUpdateSystemTranslationArgs = {
  data: SystemTranslationUpdateInput;
  id: Scalars['Int'];
};


export type MutationUpdateTemplateArgs = {
  data: TemplateUpdateInput;
  id: Scalars['Int'];
};


export type MutationUpdateTemplateCategoryArgs = {
  data: TemplateCategoryUpdateInput;
  id: Scalars['Int'];
};


export type MutationUpdateUserInviteArgs = {
  data: UserInviteUpdateInput;
  id: Scalars['Int'];
};


export type MutationUpdateUserProfileArgs = {
  data: UpdateUserProfileInput;
};


export type MutationUpdateUserRoleArgs = {
  data: UserRoleUpdateInput;
  id: Scalars['Int'];
};


export type MutationUpdateUserTeamArgs = {
  data: UserTeamUpdateInput;
  id: Scalars['Int'];
};


export type MutationUpdateUserTeamMemberArgs = {
  data: UserTeamMemberUpdateInput;
  id: Scalars['Int'];
};


export type MutationUpgradeTierArgs = {
  appleReceipt: Scalars['String'];
  price?: Maybe<Price>;
};


export type MutationVerifyUserEmailArgs = {
  key: Scalars['String'];
};

export type Price = {
  price: Scalars['Float'];
  priceLocale: Scalars['String'];
  productIdentifier: Scalars['String'];
};

export type Query = {
  __typename?: 'Query';
  allLibraryBackgrounds: LibraryBackgroundConnection;
  allLibraryCategories: LibraryCategoryConnection;
  allLibraryColors: LibraryColorConnection;
  allLibraryFiles: LibraryFileConnection;
  allLibraryFonts: LibraryFontConnection;
  allLibraryLogos: LibraryLogoConnection;
  allLibrarySounds: LibrarySoundConnection;
  allLibraryStickers: LibraryStickerConnection;
  allLibraryTags: LibraryTagConnection;
  allLibraryTextPresets: LibraryTextPresetConnection;
  /** История покупок */
  allMyUserTiers: UserUserTierConnection;
  allSystemTiers: SystemTierConnection;
  allSystemTranslations: SystemTranslationConnection;
  allTemplateCategories: TemplateCategoryConnection;
  allTemplates: TemplateConnection;
  allUserInvites: UserInviteConnection;
  allUserRoles: UserRoleConnection;
  allUserTeamMembers: UserTeamMemberConnection;
  allUserTeams: UserTeamConnection;
  allUserTransactions: UserTransactionConnection;
  allUsers: UserConnection;
  /** Получение метки времени последнего обновления перевода для веба */
  allWebTranslations: SystemTranslationConnection;
  apiVersion?: Maybe<Scalars['String']>;
  libraryBackground: LibraryBackground;
  libraryBackgrounds: Array<LibraryBackground>;
  libraryCategories: Array<LibraryCategory>;
  libraryCategory: LibraryCategory;
  libraryColor: LibraryColor;
  libraryColors: Array<LibraryColor>;
  libraryFile: LibraryFile;
  libraryFiles: Array<LibraryFile>;
  libraryFont: LibraryFont;
  libraryFonts: Array<LibraryFont>;
  libraryLogo: LibraryLogo;
  libraryLogos: Array<LibraryLogo>;
  librarySound: LibrarySound;
  librarySounds: Array<LibrarySound>;
  librarySticker: LibrarySticker;
  libraryStickers: Array<LibrarySticker>;
  libraryTag: LibraryTag;
  libraryTags: Array<LibraryTag>;
  libraryTextPreset: LibraryTextPreset;
  libraryTextPresets: Array<LibraryTextPreset>;
  /** Профиль */
  profile: User;
  systemLocales: Array<SystemLocale>;
  systemTranslation: SystemTranslation;
  systemTranslations: Array<SystemTranslation>;
  /** Получение метки времени последнего обновления перевода */
  systemTranslationsUpdatedAt: Scalars['DateTime'];
  template: Template;
  templateCategories: Array<TemplateCategory>;
  templateCategory: TemplateCategory;
  userInvite: UserInvite;
  userInvites: Array<UserInvite>;
  userRole: UserRole;
  userRoles: Array<UserRole>;
  userTeam: UserTeam;
  userTeamMember: UserTeamMember;
  userTeamMembers: Array<UserTeamMember>;
  userTeams: Array<UserTeam>;
  userTransaction: UserTransaction;
  userUserTier: UserUserTier;
  /** Получение метки времени последнего обновления перевода для веба */
  webTranslationsUpdatedAt: Scalars['DateTime'];
};


export type QueryAllLibraryBackgroundsArgs = {
  query?: Maybe<DefaultQueryInput>;
};


export type QueryAllLibraryCategoriesArgs = {
  query?: Maybe<DefaultQueryInput>;
};


export type QueryAllLibraryColorsArgs = {
  query?: Maybe<DefaultQueryInput>;
};


export type QueryAllLibraryFilesArgs = {
  query?: Maybe<DefaultQueryInput>;
};


export type QueryAllLibraryFontsArgs = {
  query?: Maybe<DefaultQueryInput>;
};


export type QueryAllLibraryLogosArgs = {
  query?: Maybe<DefaultQueryInput>;
};


export type QueryAllLibrarySoundsArgs = {
  query?: Maybe<DefaultQueryInput>;
};


export type QueryAllLibraryStickersArgs = {
  query?: Maybe<DefaultQueryInput>;
};


export type QueryAllLibraryTagsArgs = {
  query?: Maybe<DefaultQueryInput>;
};


export type QueryAllLibraryTextPresetsArgs = {
  query?: Maybe<DefaultQueryInput>;
};


export type QueryAllMyUserTiersArgs = {
  query?: Maybe<DefaultQueryInput>;
};


export type QueryAllSystemTiersArgs = {
  query?: Maybe<DefaultQueryInput>;
};


export type QueryAllSystemTranslationsArgs = {
  query?: Maybe<DefaultQueryInput>;
};


export type QueryAllTemplateCategoriesArgs = {
  query?: Maybe<DefaultQueryInput>;
};


export type QueryAllTemplatesArgs = {
  query?: Maybe<DefaultQueryInput>;
};


export type QueryAllUserInvitesArgs = {
  query?: Maybe<DefaultQueryInput>;
};


export type QueryAllUserRolesArgs = {
  query?: Maybe<DefaultQueryInput>;
};


export type QueryAllUserTeamMembersArgs = {
  query?: Maybe<DefaultQueryInput>;
};


export type QueryAllUserTeamsArgs = {
  query?: Maybe<DefaultQueryInput>;
};


export type QueryAllUserTransactionsArgs = {
  query?: Maybe<DefaultQueryInput>;
};


export type QueryAllUsersArgs = {
  query?: Maybe<DefaultQueryInput>;
};


export type QueryAllWebTranslationsArgs = {
  locale: Scalars['String'];
};


export type QueryLibraryBackgroundArgs = {
  id: Scalars['Int'];
};


export type QueryLibraryBackgroundsArgs = {
  query?: Maybe<DefaultQueryInput>;
};


export type QueryLibraryCategoriesArgs = {
  query?: Maybe<DefaultQueryInput>;
};


export type QueryLibraryCategoryArgs = {
  id: Scalars['Int'];
};


export type QueryLibraryColorArgs = {
  id: Scalars['Int'];
};


export type QueryLibraryColorsArgs = {
  query?: Maybe<DefaultQueryInput>;
};


export type QueryLibraryFileArgs = {
  id: Scalars['Int'];
};


export type QueryLibraryFilesArgs = {
  query?: Maybe<DefaultQueryInput>;
};


export type QueryLibraryFontArgs = {
  id: Scalars['Int'];
};


export type QueryLibraryFontsArgs = {
  query?: Maybe<DefaultQueryInput>;
};


export type QueryLibraryLogoArgs = {
  id: Scalars['Int'];
};


export type QueryLibraryLogosArgs = {
  query?: Maybe<DefaultQueryInput>;
};


export type QueryLibrarySoundArgs = {
  id: Scalars['Int'];
};


export type QueryLibrarySoundsArgs = {
  query?: Maybe<DefaultQueryInput>;
};


export type QueryLibraryStickerArgs = {
  id: Scalars['Int'];
};


export type QueryLibraryStickersArgs = {
  query?: Maybe<DefaultQueryInput>;
};


export type QueryLibraryTagArgs = {
  id: Scalars['Int'];
};


export type QueryLibraryTagsArgs = {
  query?: Maybe<DefaultQueryInput>;
};


export type QueryLibraryTextPresetArgs = {
  id: Scalars['Int'];
};


export type QueryLibraryTextPresetsArgs = {
  query?: Maybe<DefaultQueryInput>;
};


export type QuerySystemLocalesArgs = {
  query?: Maybe<DefaultQueryInput>;
};


export type QuerySystemTranslationArgs = {
  id: Scalars['Int'];
};


export type QuerySystemTranslationsArgs = {
  query?: Maybe<DefaultQueryInput>;
};


export type QuerySystemTranslationsUpdatedAtArgs = {
  channel?: Maybe<Scalars['String']>;
  localeId: Scalars['Int'];
};


export type QueryTemplateArgs = {
  id: Scalars['Int'];
};


export type QueryTemplateCategoriesArgs = {
  query?: Maybe<DefaultQueryInput>;
};


export type QueryTemplateCategoryArgs = {
  id: Scalars['Int'];
};


export type QueryUserInviteArgs = {
  id: Scalars['Int'];
};


export type QueryUserInvitesArgs = {
  query?: Maybe<DefaultQueryInput>;
};


export type QueryUserRoleArgs = {
  id: Scalars['Int'];
};


export type QueryUserRolesArgs = {
  query?: Maybe<DefaultQueryInput>;
};


export type QueryUserTeamArgs = {
  id: Scalars['Int'];
};


export type QueryUserTeamMemberArgs = {
  id: Scalars['Int'];
};


export type QueryUserTeamMembersArgs = {
  query?: Maybe<DefaultQueryInput>;
};


export type QueryUserTeamsArgs = {
  query?: Maybe<DefaultQueryInput>;
};


export type QueryUserTransactionArgs = {
  id: Scalars['Int'];
};


export type QueryUserUserTierArgs = {
  id: Scalars['Int'];
};


export type QueryWebTranslationsUpdatedAtArgs = {
  locale: Scalars['String'];
};

export type RegisterInput = {
  autoAcceptInvites?: Maybe<Scalars['Boolean']>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  password: Scalars['String'];
};

export type SortInput = {
  id: Scalars['Int'];
};

/** Направление сортировки */
export enum SortingDirection {
  ASC = 'ASC',
  DESC = 'DESC'
}

export type SystemLocale = {
  __typename?: 'SystemLocale';
  createdAt: Scalars['DateTime'];
  id: Scalars['Int'];
  iso: Scalars['String'];
  title: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type SystemTier = {
  __typename?: 'SystemTier';
  createdAt: Scalars['DateTime'];
  id: Scalars['Int'];
  name: Scalars['String'];
  settings?: Maybe<Scalars['JSON']>;
  subscriptionId: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type SystemTierConnection = DefaultConnection & {
  __typename?: 'SystemTierConnection';
  cursor: Scalars['Int'];
  edges: Array<SystemTier>;
  limit: Scalars['Int'];
  searchable?: Maybe<Array<Scalars['String']>>;
  sortable?: Maybe<Array<Scalars['String']>>;
  total: Scalars['Int'];
};

export type SystemTranslation = {
  __typename?: 'SystemTranslation';
  channel?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  id: Scalars['Int'];
  key: Scalars['String'];
  localeId: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
  value: Scalars['String'];
};

export type SystemTranslationConnection = DefaultConnection & {
  __typename?: 'SystemTranslationConnection';
  cursor: Scalars['Int'];
  edges: Array<SystemTranslation>;
  limit: Scalars['Int'];
  searchable?: Maybe<Array<Scalars['String']>>;
  sortable?: Maybe<Array<Scalars['String']>>;
  total: Scalars['Int'];
};

export type SystemTranslationCreateInput = {
  channel?: Maybe<Scalars['String']>;
  key: Scalars['String'];
  localeId: Scalars['Int'];
  value: Scalars['String'];
};

export type SystemTranslationSaveInput = {
  channel?: Maybe<Scalars['String']>;
  key: Scalars['String'];
  localeId: Scalars['Int'];
  value: Scalars['String'];
};

export type SystemTranslationUpdateInput = {
  channel?: Maybe<Scalars['String']>;
  key?: Maybe<Scalars['String']>;
  localeId?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['String']>;
};

export type Template = {
  __typename?: 'Template';
  category: TemplateCategory;
  categoryId: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  files?: Maybe<Array<LibraryFile>>;
  filesIdx?: Maybe<Array<Scalars['Int']>>;
  id: Scalars['Int'];
  images?: Maybe<TemplateImages>;
  name: Scalars['String'];
  ownerId: Scalars['Int'];
  settings?: Maybe<Scalars['String']>;
  sortIndex: Scalars['Int'];
  teamId: Scalars['Int'];
  textPresetId?: Maybe<Array<Scalars['Int']>>;
  textPresets?: Maybe<Array<LibraryTextPreset>>;
  updatedAt: Scalars['DateTime'];
};

export type TemplateCategory = {
  __typename?: 'TemplateCategory';
  color?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  id: Scalars['Int'];
  itemsCount: Scalars['Int'];
  name: Scalars['String'];
  ownerId: Scalars['Int'];
  sortIndex: Scalars['Int'];
  team: UserTeam;
  teamId: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
};

export type TemplateCategoryConnection = DefaultConnection & {
  __typename?: 'TemplateCategoryConnection';
  cursor: Scalars['Int'];
  edges: Array<TemplateCategory>;
  limit: Scalars['Int'];
  searchable?: Maybe<Array<Scalars['String']>>;
  sortable?: Maybe<Array<Scalars['String']>>;
  total: Scalars['Int'];
};

export type TemplateCategoryCreateInput = {
  color?: Maybe<Scalars['String']>;
  itemsCount?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  ownerId: Scalars['Int'];
  sortIndex?: Maybe<Scalars['Int']>;
  teamId: Scalars['Int'];
};

export type TemplateCategoryUpdateInput = {
  color?: Maybe<Scalars['String']>;
  itemsCount?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  ownerId?: Maybe<Scalars['Int']>;
  sortIndex?: Maybe<Scalars['Int']>;
  teamId?: Maybe<Scalars['Int']>;
};

export type TemplateConnection = DefaultConnection & {
  __typename?: 'TemplateConnection';
  cursor: Scalars['Int'];
  edges: Array<Template>;
  limit: Scalars['Int'];
  searchable?: Maybe<Array<Scalars['String']>>;
  sortable?: Maybe<Array<Scalars['String']>>;
  total: Scalars['Int'];
};

export type TemplateCreateInput = {
  categoryId: Scalars['Int'];
  files?: Maybe<Array<File>>;
  name: Scalars['String'];
  ownerId: Scalars['Int'];
  settings?: Maybe<Scalars['String']>;
  sortIndex?: Maybe<Scalars['Int']>;
  teamId: Scalars['Int'];
  textPresetId?: Maybe<Array<Scalars['Int']>>;
};

export type TemplateImages = {
  __typename?: 'TemplateImages';
  accepted?: Maybe<Array<LibraryFile>>;
  declined?: Maybe<Array<LibraryFile>>;
};

export type TemplateUpdateInput = {
  categoryId?: Maybe<Scalars['Int']>;
  files?: Maybe<Array<File>>;
  name?: Maybe<Scalars['String']>;
  ownerId?: Maybe<Scalars['Int']>;
  settings?: Maybe<Scalars['String']>;
  sortIndex?: Maybe<Scalars['Int']>;
  teamId?: Maybe<Scalars['Int']>;
  textPresetId?: Maybe<Array<Scalars['Int']>>;
};

export type UpdateUserProfileInput = {
  avatar?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
};

export type User = {
  __typename?: 'User';
  avatar?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  email: Scalars['String'];
  firstName: Scalars['String'];
  id: Scalars['Int'];
  isVerifiedEmail?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  password: Scalars['String'];
  refreshToken: Scalars['String'];
  state: UserState;
  teamMembership: Array<UserTeamMember>;
  teams: Array<UserTeam>;
  tier?: Maybe<UserUserTier>;
  updatedAt: Scalars['DateTime'];
  uuid: Scalars['UUID'];
};

export type UserConnection = DefaultConnection & {
  __typename?: 'UserConnection';
  cursor: Scalars['Int'];
  edges: Array<User>;
  limit: Scalars['Int'];
  searchable?: Maybe<Array<Scalars['String']>>;
  sortable?: Maybe<Array<Scalars['String']>>;
  total: Scalars['Int'];
};

export type UserInvite = {
  __typename?: 'UserInvite';
  createdAt: Scalars['DateTime'];
  id: Scalars['Int'];
  inviteeEmail: Scalars['String'];
  key: Scalars['String'];
  respondedAt?: Maybe<Scalars['DateTime']>;
  role: UserRole;
  roleId: Scalars['Int'];
  state: UserInviteState;
  updatedAt: Scalars['DateTime'];
  user: User;
  userId: Scalars['Int'];
};

export type UserInviteConnection = DefaultConnection & {
  __typename?: 'UserInviteConnection';
  cursor: Scalars['Int'];
  edges: Array<UserInvite>;
  limit: Scalars['Int'];
  searchable?: Maybe<Array<Scalars['String']>>;
  sortable?: Maybe<Array<Scalars['String']>>;
  total: Scalars['Int'];
};

export type UserInviteCreateInput = {
  inviteeEmail: Scalars['String'];
  key?: Maybe<Scalars['String']>;
  respondedAt?: Maybe<Scalars['DateTime']>;
  roleId: Scalars['Int'];
  state?: Maybe<UserInviteState>;
  userId: Scalars['Int'];
};

export enum UserInviteState {
  ACCEPTED = 'ACCEPTED',
  CANCELLED = 'CANCELLED',
  DECLINED = 'DECLINED',
  INVITED = 'INVITED'
}

export type UserInviteUpdateInput = {
  inviteeEmail?: Maybe<Scalars['String']>;
  key?: Maybe<Scalars['String']>;
  respondedAt?: Maybe<Scalars['DateTime']>;
  roleId?: Maybe<Scalars['Int']>;
  state?: Maybe<UserInviteState>;
  userId?: Maybe<Scalars['Int']>;
};

export type UserRole = {
  __typename?: 'UserRole';
  createdAt: Scalars['DateTime'];
  id: Scalars['Int'];
  isAdmin: Scalars['Boolean'];
  isOwner?: Maybe<Scalars['Boolean']>;
  libraryManagement?: Maybe<Array<Scalars['String']>>;
  name: Scalars['String'];
  team: UserTeam;
  teamId: Scalars['Int'];
  templateCategoryAccess?: Maybe<Array<Scalars['Int']>>;
  templatesAccess?: Maybe<Array<Scalars['Int']>>;
  templatesManagement?: Maybe<Array<Scalars['String']>>;
  updatedAt: Scalars['DateTime'];
  userManagment?: Maybe<Array<Scalars['String']>>;
};

export type UserRoleConnection = DefaultConnection & {
  __typename?: 'UserRoleConnection';
  cursor: Scalars['Int'];
  edges: Array<UserRole>;
  limit: Scalars['Int'];
  searchable?: Maybe<Array<Scalars['String']>>;
  sortable?: Maybe<Array<Scalars['String']>>;
  total: Scalars['Int'];
};

export type UserRoleCreateInput = {
  isAdmin: Scalars['Boolean'];
  libraryManagement?: Maybe<Array<Scalars['String']>>;
  name: Scalars['String'];
  teamId: Scalars['Int'];
  templateCategoryAccess?: Maybe<Array<Scalars['Int']>>;
  templatesAccess?: Maybe<Array<Scalars['Int']>>;
  templatesManagement?: Maybe<Array<Scalars['String']>>;
  userManagment?: Maybe<Array<Scalars['String']>>;
};

export type UserRoleUpdateInput = {
  isAdmin?: Maybe<Scalars['Boolean']>;
  libraryManagement?: Maybe<Array<Scalars['String']>>;
  name?: Maybe<Scalars['String']>;
  teamId?: Maybe<Scalars['Int']>;
  templateCategoryAccess?: Maybe<Array<Scalars['Int']>>;
  templatesAccess?: Maybe<Array<Scalars['Int']>>;
  templatesManagement?: Maybe<Array<Scalars['String']>>;
  userManagment?: Maybe<Array<Scalars['String']>>;
};

export enum UserState {
  ACTIVE = 'ACTIVE',
  BLOCKED = 'BLOCKED',
  DELETED = 'DELETED',
  INACTIVE = 'INACTIVE'
}

export type UserTeam = {
  __typename?: 'UserTeam';
  createdAt: Scalars['DateTime'];
  id: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
  owner: User;
  ownerId: Scalars['Int'];
  roles: Array<UserRole>;
  teamMembers: Array<UserTeamMember>;
  updatedAt: Scalars['DateTime'];
};

export type UserTeamConnection = DefaultConnection & {
  __typename?: 'UserTeamConnection';
  cursor: Scalars['Int'];
  edges: Array<UserTeam>;
  limit: Scalars['Int'];
  searchable?: Maybe<Array<Scalars['String']>>;
  sortable?: Maybe<Array<Scalars['String']>>;
  total: Scalars['Int'];
};

export type UserTeamCreateInput = {
  name?: Maybe<Scalars['String']>;
  ownerId: Scalars['Int'];
};

export type UserTeamMember = {
  __typename?: 'UserTeamMember';
  createdAt: Scalars['DateTime'];
  id: Scalars['Int'];
  role: UserRole;
  roleId: Scalars['Int'];
  team: UserTeam;
  teamId: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
  user: User;
  userId: Scalars['Int'];
};

export type UserTeamMemberConnection = DefaultConnection & {
  __typename?: 'UserTeamMemberConnection';
  cursor: Scalars['Int'];
  edges: Array<UserTeamMember>;
  limit: Scalars['Int'];
  searchable?: Maybe<Array<Scalars['String']>>;
  sortable?: Maybe<Array<Scalars['String']>>;
  total: Scalars['Int'];
};

export type UserTeamMemberCreateInput = {
  roleId: Scalars['Int'];
  teamId: Scalars['Int'];
  userId: Scalars['Int'];
};

export type UserTeamMemberUpdateInput = {
  roleId?: Maybe<Scalars['Int']>;
  teamId?: Maybe<Scalars['Int']>;
  userId?: Maybe<Scalars['Int']>;
};

export type UserTeamUpdateInput = {
  name?: Maybe<Scalars['String']>;
  ownerId?: Maybe<Scalars['Int']>;
};

export type UserTransaction = {
  __typename?: 'UserTransaction';
  createdAt: Scalars['DateTime'];
  id: Scalars['Int'];
  receipt?: Maybe<Scalars['JSON']>;
  receiptProductId?: Maybe<Scalars['String']>;
  receiptTransactionId?: Maybe<Scalars['String']>;
  state?: Maybe<UserTransactionState>;
  updatedAt: Scalars['DateTime'];
  userTierId: Scalars['Int'];
};

export type UserTransactionConnection = DefaultConnection & {
  __typename?: 'UserTransactionConnection';
  cursor: Scalars['Int'];
  edges: Array<UserTransaction>;
  limit: Scalars['Int'];
  searchable?: Maybe<Array<Scalars['String']>>;
  sortable?: Maybe<Array<Scalars['String']>>;
  total: Scalars['Int'];
};

export enum UserTransactionState {
  CANCELLED = 'CANCELLED',
  DONE = 'DONE'
}

export type UserUserTier = {
  __typename?: 'UserUserTier';
  appleReceiptData?: Maybe<AppleReceiptData>;
  createdAt: Scalars['DateTime'];
  expiredAt?: Maybe<Scalars['DateTime']>;
  frozenFinishedAt?: Maybe<Scalars['DateTime']>;
  frozenStartedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  isTrial: Scalars['Boolean'];
  price?: Maybe<Scalars['JSON']>;
  productId?: Maybe<Scalars['String']>;
  receipt?: Maybe<Scalars['JSON']>;
  state?: Maybe<UserUserTierState>;
  teamId: Scalars['Int'];
  tier: SystemTier;
  tierId: Scalars['Int'];
  transactionId?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  user: User;
  userId: Scalars['Int'];
};

export type UserUserTierConnection = DefaultConnection & {
  __typename?: 'UserUserTierConnection';
  cursor: Scalars['Int'];
  edges: Array<UserUserTier>;
  limit: Scalars['Int'];
  searchable?: Maybe<Array<Scalars['String']>>;
  sortable?: Maybe<Array<Scalars['String']>>;
  total: Scalars['Int'];
};

export enum UserUserTierState {
  ACTIVE = 'ACTIVE',
  EXPIRED = 'EXPIRED'
}

export type AuthResponseFragment = { __typename?: 'AuthResponse', refreshToken: string, accessToken: string, user: { __typename?: 'User', id: number, uuid: any, state: UserState, firstName: string, lastName: string, email: string, avatar?: Maybe<string>, teams: Array<{ __typename?: 'UserTeam', id: number, ownerId: number, name?: Maybe<string> }>, teamMembership: Array<{ __typename?: 'UserTeamMember', id: number, userId: number, roleId: number, team: { __typename?: 'UserTeam', id: number, ownerId: number, name?: Maybe<string>, owner: { __typename?: 'User', id: number, firstName: string, lastName: string } }, role: { __typename?: 'UserRole', name: string, isAdmin: boolean, userManagment?: Maybe<Array<string>>, libraryManagement?: Maybe<Array<string>>, templatesManagement?: Maybe<Array<string>>, templatesAccess?: Maybe<Array<number>>, templateCategoryAccess?: Maybe<Array<number>> } }>, tier?: Maybe<{ __typename?: 'UserUserTier', id: number, userId: number, tierId: number, transactionId?: Maybe<string>, state?: Maybe<UserUserTierState>, expiredAt?: Maybe<any>, productId?: Maybe<string>, price?: Maybe<any>, createdAt: any, updatedAt: any, isTrial: boolean, tier: { __typename?: 'SystemTier', id: number, name: string, settings?: Maybe<any> } }> } };

export type LibraryBackgroundFragment = { __typename?: 'LibraryBackground', id: number, name?: Maybe<string>, color?: Maybe<string>, categoryId?: Maybe<number>, sortIndex: number, fileId?: Maybe<number>, file?: Maybe<{ __typename?: 'LibraryFile', id: number, ownerId: number, name: string, url: string, previewUrl?: Maybe<string>, mimeType: LibraryFileMimeType, size?: Maybe<number>, width?: Maybe<number>, height?: Maybe<number>, duration?: Maybe<number>, bitrate?: Maybe<number>, ratio?: Maybe<string>, warnings?: Maybe<Array<string>>, errors?: Maybe<Array<string>> }> };

export type LibraryCategoryFragment = { __typename?: 'LibraryCategory', id: number, name: string, color?: Maybe<string>, entity: LibraryCategoryEntity, tagId?: Maybe<number>, itemsCount: number };

export type LibraryColorFragment = { __typename?: 'LibraryColor', id: number, name?: Maybe<string>, sortIndex: number, value: string, categoryId?: Maybe<number> };

export type LibraryFileFragment = { __typename?: 'LibraryFile', id: number, ownerId: number, name: string, url: string, previewUrl?: Maybe<string>, mimeType: LibraryFileMimeType, size?: Maybe<number>, width?: Maybe<number>, height?: Maybe<number>, duration?: Maybe<number>, bitrate?: Maybe<number>, ratio?: Maybe<string>, warnings?: Maybe<Array<string>>, errors?: Maybe<Array<string>> };

export type LibraryFontFragment = { __typename?: 'LibraryFont', id: number, name: string, ownerId: number, teamId: number, categoryId?: Maybe<number>, sortIndex: number, file?: Maybe<{ __typename?: 'LibraryFile', id: number, ownerId: number, name: string, url: string, previewUrl?: Maybe<string>, mimeType: LibraryFileMimeType, size?: Maybe<number>, width?: Maybe<number>, height?: Maybe<number>, duration?: Maybe<number>, bitrate?: Maybe<number>, ratio?: Maybe<string>, warnings?: Maybe<Array<string>>, errors?: Maybe<Array<string>> }> };

export type LibraryFontFlatFragment = { __typename?: 'LibraryFont', id: number, name: string, sortIndex: number, ownerId: number, teamId: number, categoryId?: Maybe<number> };

export type LibraryLogoFragment = { __typename?: 'LibraryLogo', id: number, name: string, ownerId: number, teamId: number, categoryId?: Maybe<number>, sortIndex: number, file?: Maybe<{ __typename?: 'LibraryFile', id: number, ownerId: number, name: string, url: string, previewUrl?: Maybe<string>, mimeType: LibraryFileMimeType, size?: Maybe<number>, width?: Maybe<number>, height?: Maybe<number>, duration?: Maybe<number>, bitrate?: Maybe<number>, ratio?: Maybe<string>, warnings?: Maybe<Array<string>>, errors?: Maybe<Array<string>> }> };

export type LibrarySoundFragment = { __typename?: 'LibrarySound', id: number, name: string, ownerId: number, teamId: number, categoryId?: Maybe<number>, sortIndex: number, file?: Maybe<{ __typename?: 'LibraryFile', id: number, ownerId: number, name: string, url: string, previewUrl?: Maybe<string>, mimeType: LibraryFileMimeType, size?: Maybe<number>, width?: Maybe<number>, height?: Maybe<number>, duration?: Maybe<number>, bitrate?: Maybe<number>, ratio?: Maybe<string>, warnings?: Maybe<Array<string>>, errors?: Maybe<Array<string>> }> };

export type LibraryStickerFragment = { __typename?: 'LibrarySticker', id: number, name: string, ownerId: number, teamId: number, categoryId?: Maybe<number>, sortIndex: number, file?: Maybe<{ __typename?: 'LibraryFile', id: number, ownerId: number, name: string, url: string, previewUrl?: Maybe<string>, mimeType: LibraryFileMimeType, size?: Maybe<number>, width?: Maybe<number>, height?: Maybe<number>, duration?: Maybe<number>, bitrate?: Maybe<number>, ratio?: Maybe<string>, warnings?: Maybe<Array<string>>, errors?: Maybe<Array<string>> }> };

export type LibraryTextPresetFragment = { __typename?: 'LibraryTextPreset', id: number, ownerId: number, teamId: number, categoryId?: Maybe<number>, name: string, fontId?: Maybe<number>, fontAlignment?: Maybe<LibraryTextPresetFontAlignment>, fontSize?: Maybe<number>, frameSize?: Maybe<LibraryTextPresetFrameSize>, fontColorId?: Maybe<number>, sortIndex: number, backgroundColor?: Maybe<{ __typename?: 'LibraryBackground', id: number, name?: Maybe<string>, color?: Maybe<string>, categoryId?: Maybe<number>, sortIndex: number, fileId?: Maybe<number>, file?: Maybe<{ __typename?: 'LibraryFile', id: number, ownerId: number, name: string, url: string, previewUrl?: Maybe<string>, mimeType: LibraryFileMimeType, size?: Maybe<number>, width?: Maybe<number>, height?: Maybe<number>, duration?: Maybe<number>, bitrate?: Maybe<number>, ratio?: Maybe<string>, warnings?: Maybe<Array<string>>, errors?: Maybe<Array<string>> }> }>, category?: Maybe<{ __typename?: 'LibraryCategory', id: number, name: string, color?: Maybe<string>, entity: LibraryCategoryEntity, tagId?: Maybe<number>, itemsCount: number }>, fontColor?: Maybe<{ __typename?: 'LibraryColor', id: number, name?: Maybe<string>, sortIndex: number, value: string, categoryId?: Maybe<number> }> };

export type LibraryTextPresetFlatFragment = { __typename?: 'LibraryTextPreset', id: number, ownerId: number, teamId: number, categoryId?: Maybe<number>, name: string, fontId?: Maybe<number>, fontAlignment?: Maybe<LibraryTextPresetFontAlignment>, fontSize?: Maybe<number>, frameSize?: Maybe<LibraryTextPresetFrameSize>, fontColorId?: Maybe<number>, backgroundColorId?: Maybe<number>, sortIndex: number };

export type LibraryTextPresetConnectionFragment = { __typename?: 'LibraryTextPresetConnection', total: number, limit: number, cursor: number, sortable?: Maybe<Array<string>>, edges: Array<{ __typename?: 'LibraryTextPreset', id: number, ownerId: number, teamId: number, categoryId?: Maybe<number>, name: string, fontId?: Maybe<number>, fontAlignment?: Maybe<LibraryTextPresetFontAlignment>, fontSize?: Maybe<number>, frameSize?: Maybe<LibraryTextPresetFrameSize>, fontColorId?: Maybe<number>, sortIndex: number, backgroundColor?: Maybe<{ __typename?: 'LibraryBackground', id: number, name?: Maybe<string>, color?: Maybe<string>, categoryId?: Maybe<number>, sortIndex: number, fileId?: Maybe<number>, file?: Maybe<{ __typename?: 'LibraryFile', id: number, ownerId: number, name: string, url: string, previewUrl?: Maybe<string>, mimeType: LibraryFileMimeType, size?: Maybe<number>, width?: Maybe<number>, height?: Maybe<number>, duration?: Maybe<number>, bitrate?: Maybe<number>, ratio?: Maybe<string>, warnings?: Maybe<Array<string>>, errors?: Maybe<Array<string>> }> }>, category?: Maybe<{ __typename?: 'LibraryCategory', id: number, name: string, color?: Maybe<string>, entity: LibraryCategoryEntity, tagId?: Maybe<number>, itemsCount: number }>, fontColor?: Maybe<{ __typename?: 'LibraryColor', id: number, name?: Maybe<string>, sortIndex: number, value: string, categoryId?: Maybe<number> }> }> };

export type LibraryTextPresetFlatConnectionFragment = { __typename?: 'LibraryTextPresetConnection', total: number, limit: number, cursor: number, sortable?: Maybe<Array<string>>, edges: Array<{ __typename?: 'LibraryTextPreset', id: number, ownerId: number, teamId: number, categoryId?: Maybe<number>, name: string, fontId?: Maybe<number>, fontAlignment?: Maybe<LibraryTextPresetFontAlignment>, fontSize?: Maybe<number>, frameSize?: Maybe<LibraryTextPresetFrameSize>, fontColorId?: Maybe<number>, backgroundColorId?: Maybe<number>, sortIndex: number }> };

export type SystemTranslationConnectionFragment = { __typename?: 'SystemTranslationConnection', total: number, edges: Array<{ __typename?: 'SystemTranslation', id: number, key: string, value: string, updatedAt: any }> };

export type TemplateFragment = { __typename?: 'Template', id: number, name: string, categoryId: number, textPresetId?: Maybe<Array<number>>, sortIndex: number, settings?: Maybe<string>, images?: Maybe<{ __typename?: 'TemplateImages', accepted?: Maybe<Array<{ __typename?: 'LibraryFile', id: number, ownerId: number, name: string, url: string, previewUrl?: Maybe<string>, mimeType: LibraryFileMimeType, size?: Maybe<number>, width?: Maybe<number>, height?: Maybe<number>, duration?: Maybe<number>, bitrate?: Maybe<number>, ratio?: Maybe<string>, warnings?: Maybe<Array<string>>, errors?: Maybe<Array<string>> }>>, declined?: Maybe<Array<{ __typename?: 'LibraryFile', id: number, ownerId: number, name: string, url: string, previewUrl?: Maybe<string>, mimeType: LibraryFileMimeType, size?: Maybe<number>, width?: Maybe<number>, height?: Maybe<number>, duration?: Maybe<number>, bitrate?: Maybe<number>, ratio?: Maybe<string>, warnings?: Maybe<Array<string>>, errors?: Maybe<Array<string>> }>> }> };

export type TemplateFullFragment = { __typename?: 'Template', id: number, name: string, categoryId: number, sortIndex: number, settings?: Maybe<string>, textPresets?: Maybe<Array<{ __typename?: 'LibraryTextPreset', id: number, ownerId: number, teamId: number, categoryId?: Maybe<number>, name: string, fontId?: Maybe<number>, fontAlignment?: Maybe<LibraryTextPresetFontAlignment>, fontSize?: Maybe<number>, frameSize?: Maybe<LibraryTextPresetFrameSize>, fontColorId?: Maybe<number>, sortIndex: number, backgroundColor?: Maybe<{ __typename?: 'LibraryBackground', id: number, name?: Maybe<string>, color?: Maybe<string>, categoryId?: Maybe<number>, sortIndex: number, fileId?: Maybe<number>, file?: Maybe<{ __typename?: 'LibraryFile', id: number, ownerId: number, name: string, url: string, previewUrl?: Maybe<string>, mimeType: LibraryFileMimeType, size?: Maybe<number>, width?: Maybe<number>, height?: Maybe<number>, duration?: Maybe<number>, bitrate?: Maybe<number>, ratio?: Maybe<string>, warnings?: Maybe<Array<string>>, errors?: Maybe<Array<string>> }> }>, category?: Maybe<{ __typename?: 'LibraryCategory', id: number, name: string, color?: Maybe<string>, entity: LibraryCategoryEntity, tagId?: Maybe<number>, itemsCount: number }>, fontColor?: Maybe<{ __typename?: 'LibraryColor', id: number, name?: Maybe<string>, sortIndex: number, value: string, categoryId?: Maybe<number> }> }>>, images?: Maybe<{ __typename?: 'TemplateImages', accepted?: Maybe<Array<{ __typename?: 'LibraryFile', id: number, ownerId: number, name: string, url: string, previewUrl?: Maybe<string>, mimeType: LibraryFileMimeType, size?: Maybe<number>, width?: Maybe<number>, height?: Maybe<number>, duration?: Maybe<number>, bitrate?: Maybe<number>, ratio?: Maybe<string>, warnings?: Maybe<Array<string>>, errors?: Maybe<Array<string>> }>>, declined?: Maybe<Array<{ __typename?: 'LibraryFile', id: number, ownerId: number, name: string, url: string, previewUrl?: Maybe<string>, mimeType: LibraryFileMimeType, size?: Maybe<number>, width?: Maybe<number>, height?: Maybe<number>, duration?: Maybe<number>, bitrate?: Maybe<number>, ratio?: Maybe<string>, warnings?: Maybe<Array<string>>, errors?: Maybe<Array<string>> }>> }> };

export type TemplateCategoryFragment = { __typename?: 'TemplateCategory', id: number, name: string, sortIndex: number };

export type TemplateConnectionFragment = { __typename?: 'TemplateConnection', total: number, limit: number, cursor: number, sortable?: Maybe<Array<string>>, edges: Array<{ __typename?: 'Template', id: number, name: string, categoryId: number, textPresetId?: Maybe<Array<number>>, sortIndex: number, settings?: Maybe<string>, images?: Maybe<{ __typename?: 'TemplateImages', accepted?: Maybe<Array<{ __typename?: 'LibraryFile', id: number, ownerId: number, name: string, url: string, previewUrl?: Maybe<string>, mimeType: LibraryFileMimeType, size?: Maybe<number>, width?: Maybe<number>, height?: Maybe<number>, duration?: Maybe<number>, bitrate?: Maybe<number>, ratio?: Maybe<string>, warnings?: Maybe<Array<string>>, errors?: Maybe<Array<string>> }>>, declined?: Maybe<Array<{ __typename?: 'LibraryFile', id: number, ownerId: number, name: string, url: string, previewUrl?: Maybe<string>, mimeType: LibraryFileMimeType, size?: Maybe<number>, width?: Maybe<number>, height?: Maybe<number>, duration?: Maybe<number>, bitrate?: Maybe<number>, ratio?: Maybe<string>, warnings?: Maybe<Array<string>>, errors?: Maybe<Array<string>> }>> }> }> };

export type SystemTranslationFragment = { __typename?: 'SystemTranslation', id: number, key: string, value: string, updatedAt: any };

export type UserFragment = { __typename?: 'User', id: number, uuid: any, state: UserState, firstName: string, lastName: string, email: string, avatar?: Maybe<string>, teams: Array<{ __typename?: 'UserTeam', id: number, ownerId: number, name?: Maybe<string> }>, teamMembership: Array<{ __typename?: 'UserTeamMember', id: number, userId: number, roleId: number, team: { __typename?: 'UserTeam', id: number, ownerId: number, name?: Maybe<string>, owner: { __typename?: 'User', id: number, firstName: string, lastName: string } }, role: { __typename?: 'UserRole', name: string, isAdmin: boolean, userManagment?: Maybe<Array<string>>, libraryManagement?: Maybe<Array<string>>, templatesManagement?: Maybe<Array<string>>, templatesAccess?: Maybe<Array<number>>, templateCategoryAccess?: Maybe<Array<number>> } }>, tier?: Maybe<{ __typename?: 'UserUserTier', id: number, userId: number, tierId: number, transactionId?: Maybe<string>, state?: Maybe<UserUserTierState>, expiredAt?: Maybe<any>, productId?: Maybe<string>, price?: Maybe<any>, createdAt: any, updatedAt: any, isTrial: boolean, tier: { __typename?: 'SystemTier', id: number, name: string, settings?: Maybe<any> } }> };

export type UserFlatFragment = { __typename?: 'User', id: number, uuid: any, state: UserState, firstName: string, lastName: string, email: string, avatar?: Maybe<string> };

export type UserRoleFragment = { __typename?: 'UserRole', id: number, name: string, isAdmin: boolean, teamId: number, userManagment?: Maybe<Array<string>>, libraryManagement?: Maybe<Array<string>>, templatesManagement?: Maybe<Array<string>>, templateCategoryAccess?: Maybe<Array<number>>, templatesAccess?: Maybe<Array<number>>, isOwner?: Maybe<boolean>, team: { __typename?: 'UserTeam', id: number, ownerId: number, name?: Maybe<string> } };

export type UserTeamFragment = { __typename?: 'UserTeam', id: number, ownerId: number, name?: Maybe<string> };

export type UserTeamMemberProfileFragment = { __typename?: 'UserTeamMember', id: number, userId: number, roleId: number, team: { __typename?: 'UserTeam', id: number, ownerId: number, name?: Maybe<string>, owner: { __typename?: 'User', id: number, firstName: string, lastName: string } }, role: { __typename?: 'UserRole', name: string, isAdmin: boolean, userManagment?: Maybe<Array<string>>, libraryManagement?: Maybe<Array<string>>, templatesManagement?: Maybe<Array<string>>, templatesAccess?: Maybe<Array<number>>, templateCategoryAccess?: Maybe<Array<number>> } };

export type UserTeamMemberSmallFragment = { __typename?: 'UserTeamMember', id: number, userId: number, roleId: number, role: { __typename?: 'UserRole', name: string, isAdmin: boolean }, user: { __typename?: 'User', id: number, uuid: any, state: UserState, firstName: string, lastName: string, email: string, avatar?: Maybe<string> } };

export type UserTransactionFragment = { __typename?: 'UserTransaction', id: number, state?: Maybe<UserTransactionState>, receipt?: Maybe<any>, receiptProductId?: Maybe<string>, receiptTransactionId?: Maybe<string> };

export type UserUserTierFragment = { __typename?: 'UserUserTier', id: number, userId: number, tierId: number, transactionId?: Maybe<string>, state?: Maybe<UserUserTierState>, expiredAt?: Maybe<any>, productId?: Maybe<string>, price?: Maybe<any>, createdAt: any, updatedAt: any, isTrial: boolean, tier: { __typename?: 'SystemTier', id: number, name: string } };

export type ProfileUserUserTierFragment = { __typename?: 'UserUserTier', id: number, userId: number, tierId: number, transactionId?: Maybe<string>, state?: Maybe<UserUserTierState>, expiredAt?: Maybe<any>, productId?: Maybe<string>, price?: Maybe<any>, createdAt: any, updatedAt: any, isTrial: boolean, tier: { __typename?: 'SystemTier', id: number, name: string, settings?: Maybe<any> } };

export type UserUserTierConnectionFragment = { __typename?: 'UserUserTierConnection', total: number, limit: number, cursor: number, sortable?: Maybe<Array<string>>, edges: Array<{ __typename?: 'UserUserTier', id: number, userId: number, tierId: number, transactionId?: Maybe<string>, state?: Maybe<UserUserTierState>, expiredAt?: Maybe<any>, productId?: Maybe<string>, price?: Maybe<any>, createdAt: any, updatedAt: any, isTrial: boolean, tier: { __typename?: 'SystemTier', id: number, name: string } }> };

export type AcceptUserInviteMutationVariables = Exact<{
  key: Scalars['String'];
}>;


export type AcceptUserInviteMutation = { __typename?: 'Mutation', acceptUserInvite: { __typename?: 'UserInvite', id: number } };

export type CreateLibraryBackgroundMutationVariables = Exact<{
  data: LibraryBackgroundCreateInput;
}>;


export type CreateLibraryBackgroundMutation = { __typename?: 'Mutation', createLibraryBackground: { __typename?: 'LibraryBackground', id: number, name?: Maybe<string>, color?: Maybe<string>, categoryId?: Maybe<number>, sortIndex: number, fileId?: Maybe<number>, file?: Maybe<{ __typename?: 'LibraryFile', id: number, ownerId: number, name: string, url: string, previewUrl?: Maybe<string>, mimeType: LibraryFileMimeType, size?: Maybe<number>, width?: Maybe<number>, height?: Maybe<number>, duration?: Maybe<number>, bitrate?: Maybe<number>, ratio?: Maybe<string>, warnings?: Maybe<Array<string>>, errors?: Maybe<Array<string>> }> } };

export type CreateLibraryCategoryMutationVariables = Exact<{
  data: LibraryCategoryCreateInput;
}>;


export type CreateLibraryCategoryMutation = { __typename?: 'Mutation', createLibraryCategory: { __typename?: 'LibraryCategory', id: number, name: string } };

export type CreateLibraryColorMutationVariables = Exact<{
  data: LibraryColorCreateInput;
}>;


export type CreateLibraryColorMutation = { __typename?: 'Mutation', createLibraryColor: { __typename?: 'LibraryColor', id: number, name?: Maybe<string>, sortIndex: number, value: string, categoryId?: Maybe<number> } };

export type CreateLibraryFileMutationVariables = Exact<{
  data: LibraryFileCreateInput;
}>;


export type CreateLibraryFileMutation = { __typename?: 'Mutation', createLibraryFile: { __typename?: 'LibraryFile', id: number, ownerId: number, name: string, url: string, previewUrl?: Maybe<string>, mimeType: LibraryFileMimeType, size?: Maybe<number>, width?: Maybe<number>, height?: Maybe<number>, duration?: Maybe<number>, bitrate?: Maybe<number> } };

export type CreateLibraryFontMutationVariables = Exact<{
  data: LibraryFontCreateInput;
}>;


export type CreateLibraryFontMutation = { __typename?: 'Mutation', createLibraryFont: { __typename?: 'LibraryFont', id: number, name: string, fileId: number, categoryId?: Maybe<number> } };

export type CreateLibraryLogoMutationVariables = Exact<{
  data: LibraryLogoCreateInput;
}>;


export type CreateLibraryLogoMutation = { __typename?: 'Mutation', createLibraryLogo: { __typename?: 'LibraryLogo', id: number, name: string, fileId: number, categoryId?: Maybe<number> } };

export type CreateLibrarySoundMutationVariables = Exact<{
  data: LibrarySoundCreateInput;
}>;


export type CreateLibrarySoundMutation = { __typename?: 'Mutation', createLibrarySound: { __typename?: 'LibrarySound', id: number, name: string, fileId?: Maybe<number>, categoryId?: Maybe<number> } };

export type CreateLibraryStickerMutationVariables = Exact<{
  data: LibraryStickerCreateInput;
}>;


export type CreateLibraryStickerMutation = { __typename?: 'Mutation', createLibrarySticker: { __typename?: 'LibrarySticker', id: number, name: string, fileId: number, categoryId?: Maybe<number> } };

export type CreateLibraryTextPresetMutationVariables = Exact<{
  data: LibraryTextPresetCreateInput;
}>;


export type CreateLibraryTextPresetMutation = { __typename?: 'Mutation', createLibraryTextPreset: { __typename?: 'LibraryTextPreset', id: number, ownerId: number, teamId: number, categoryId?: Maybe<number>, name: string, fontId?: Maybe<number>, fontAlignment?: Maybe<LibraryTextPresetFontAlignment>, fontSize?: Maybe<number>, frameSize?: Maybe<LibraryTextPresetFrameSize>, fontColorId?: Maybe<number>, sortIndex: number, backgroundColor?: Maybe<{ __typename?: 'LibraryBackground', id: number, name?: Maybe<string>, color?: Maybe<string>, categoryId?: Maybe<number>, sortIndex: number, fileId?: Maybe<number>, file?: Maybe<{ __typename?: 'LibraryFile', id: number, ownerId: number, name: string, url: string, previewUrl?: Maybe<string>, mimeType: LibraryFileMimeType, size?: Maybe<number>, width?: Maybe<number>, height?: Maybe<number>, duration?: Maybe<number>, bitrate?: Maybe<number>, ratio?: Maybe<string>, warnings?: Maybe<Array<string>>, errors?: Maybe<Array<string>> }> }>, category?: Maybe<{ __typename?: 'LibraryCategory', id: number, name: string, color?: Maybe<string>, entity: LibraryCategoryEntity, tagId?: Maybe<number>, itemsCount: number }>, fontColor?: Maybe<{ __typename?: 'LibraryColor', id: number, name?: Maybe<string>, sortIndex: number, value: string, categoryId?: Maybe<number> }> } };

export type CreateTemplateMutationVariables = Exact<{
  data: TemplateCreateInput;
}>;


export type CreateTemplateMutation = { __typename?: 'Mutation', createTemplate: { __typename?: 'Template', id: number, name: string, categoryId: number, textPresetId?: Maybe<Array<number>>, sortIndex: number, settings?: Maybe<string>, images?: Maybe<{ __typename?: 'TemplateImages', accepted?: Maybe<Array<{ __typename?: 'LibraryFile', id: number, ownerId: number, name: string, url: string, previewUrl?: Maybe<string>, mimeType: LibraryFileMimeType, size?: Maybe<number>, width?: Maybe<number>, height?: Maybe<number>, duration?: Maybe<number>, bitrate?: Maybe<number>, ratio?: Maybe<string>, warnings?: Maybe<Array<string>>, errors?: Maybe<Array<string>> }>>, declined?: Maybe<Array<{ __typename?: 'LibraryFile', id: number, ownerId: number, name: string, url: string, previewUrl?: Maybe<string>, mimeType: LibraryFileMimeType, size?: Maybe<number>, width?: Maybe<number>, height?: Maybe<number>, duration?: Maybe<number>, bitrate?: Maybe<number>, ratio?: Maybe<string>, warnings?: Maybe<Array<string>>, errors?: Maybe<Array<string>> }>> }> } };

export type CreateTemplateCategoryMutationVariables = Exact<{
  data: TemplateCategoryCreateInput;
}>;


export type CreateTemplateCategoryMutation = { __typename?: 'Mutation', createTemplateCategory: { __typename?: 'TemplateCategory', id: number, name: string } };

export type CreateUserInviteMutationVariables = Exact<{
  data: UserInviteCreateInput;
}>;


export type CreateUserInviteMutation = { __typename?: 'Mutation', createUserInvite: { __typename?: 'UserInvite', id: number } };

export type CreateUserRoleMutationVariables = Exact<{
  data: UserRoleCreateInput;
}>;


export type CreateUserRoleMutation = { __typename?: 'Mutation', createUserRole: { __typename?: 'UserRole', id: number } };

export type DeclineUserInviteMutationVariables = Exact<{
  key: Scalars['String'];
}>;


export type DeclineUserInviteMutation = { __typename?: 'Mutation', declineUserInvite: { __typename?: 'UserInvite', id: number } };

export type DeleteLibraryBackgroundMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeleteLibraryBackgroundMutation = { __typename?: 'Mutation', deleteLibraryBackground: { __typename?: 'LibraryBackground', id: number, categoryId?: Maybe<number>, name?: Maybe<string> } };

export type DeleteLibraryCategoryMutationVariables = Exact<{
  id: Scalars['Int'];
  destinationCatgoryId?: Maybe<Scalars['Int']>;
}>;


export type DeleteLibraryCategoryMutation = { __typename?: 'Mutation', deleteLibraryCategory: { __typename?: 'LibraryCategory', id: number } };

export type DeleteLibraryColorMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeleteLibraryColorMutation = { __typename?: 'Mutation', deleteLibraryColor: { __typename?: 'LibraryColor', id: number, name?: Maybe<string>, sortIndex: number, value: string, categoryId?: Maybe<number> } };

export type DeleteLibraryFontMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeleteLibraryFontMutation = { __typename?: 'Mutation', deleteLibraryFont: { __typename?: 'LibraryFont', id: number, categoryId?: Maybe<number>, name: string } };

export type DeleteLibraryLogoMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeleteLibraryLogoMutation = { __typename?: 'Mutation', deleteLibraryLogo: { __typename?: 'LibraryLogo', id: number, categoryId?: Maybe<number>, name: string } };

export type DeleteLibrarySoundMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeleteLibrarySoundMutation = { __typename?: 'Mutation', deleteLibrarySound: { __typename?: 'LibrarySound', id: number, categoryId?: Maybe<number>, name: string } };

export type DeleteLibraryStickerMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeleteLibraryStickerMutation = { __typename?: 'Mutation', deleteLibrarySticker: { __typename?: 'LibrarySticker', id: number, categoryId?: Maybe<number>, name: string } };

export type DeleteLibraryTextPresetMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeleteLibraryTextPresetMutation = { __typename?: 'Mutation', deleteLibraryTextPreset: { __typename?: 'LibraryTextPreset', id: number } };

export type DeleteTemplateMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeleteTemplateMutation = { __typename?: 'Mutation', deleteTemplate: { __typename?: 'Template', id: number, name: string, categoryId: number, textPresetId?: Maybe<Array<number>>, sortIndex: number, settings?: Maybe<string>, images?: Maybe<{ __typename?: 'TemplateImages', accepted?: Maybe<Array<{ __typename?: 'LibraryFile', id: number, ownerId: number, name: string, url: string, previewUrl?: Maybe<string>, mimeType: LibraryFileMimeType, size?: Maybe<number>, width?: Maybe<number>, height?: Maybe<number>, duration?: Maybe<number>, bitrate?: Maybe<number>, ratio?: Maybe<string>, warnings?: Maybe<Array<string>>, errors?: Maybe<Array<string>> }>>, declined?: Maybe<Array<{ __typename?: 'LibraryFile', id: number, ownerId: number, name: string, url: string, previewUrl?: Maybe<string>, mimeType: LibraryFileMimeType, size?: Maybe<number>, width?: Maybe<number>, height?: Maybe<number>, duration?: Maybe<number>, bitrate?: Maybe<number>, ratio?: Maybe<string>, warnings?: Maybe<Array<string>>, errors?: Maybe<Array<string>> }>> }> } };

export type DeleteTemplateCategoryMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeleteTemplateCategoryMutation = { __typename?: 'Mutation', deleteTemplateCategory: { __typename?: 'TemplateCategory', id: number, name: string } };

export type DeleteUserRoleMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeleteUserRoleMutation = { __typename?: 'Mutation', deleteUserRole: { __typename?: 'UserRole', id: number } };

export type DeleteUserTeamMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeleteUserTeamMutation = { __typename?: 'Mutation', deleteUserTeam: { __typename?: 'UserTeam', id: number } };

export type DeleteUserTeamMemberMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeleteUserTeamMemberMutation = { __typename?: 'Mutation', deleteUserTeamMember: { __typename?: 'UserTeamMember', id: number } };

export type LoginMutationVariables = Exact<{
  data: LoginInput;
}>;


export type LoginMutation = { __typename?: 'Mutation', login: { __typename?: 'AuthResponse', refreshToken: string, accessToken: string, user: { __typename?: 'User', id: number, uuid: any, state: UserState, firstName: string, lastName: string, email: string, avatar?: Maybe<string>, teams: Array<{ __typename?: 'UserTeam', id: number, ownerId: number, name?: Maybe<string> }>, teamMembership: Array<{ __typename?: 'UserTeamMember', id: number, userId: number, roleId: number, team: { __typename?: 'UserTeam', id: number, ownerId: number, name?: Maybe<string>, owner: { __typename?: 'User', id: number, firstName: string, lastName: string } }, role: { __typename?: 'UserRole', name: string, isAdmin: boolean, userManagment?: Maybe<Array<string>>, libraryManagement?: Maybe<Array<string>>, templatesManagement?: Maybe<Array<string>>, templatesAccess?: Maybe<Array<number>>, templateCategoryAccess?: Maybe<Array<number>> } }>, tier?: Maybe<{ __typename?: 'UserUserTier', id: number, userId: number, tierId: number, transactionId?: Maybe<string>, state?: Maybe<UserUserTierState>, expiredAt?: Maybe<any>, productId?: Maybe<string>, price?: Maybe<any>, createdAt: any, updatedAt: any, isTrial: boolean, tier: { __typename?: 'SystemTier', id: number, name: string, settings?: Maybe<any> } }> } } };

export type RegisterMutationVariables = Exact<{
  data: RegisterInput;
}>;


export type RegisterMutation = { __typename?: 'Mutation', register: { __typename?: 'AuthResponse', refreshToken: string, accessToken: string, user: { __typename?: 'User', id: number, uuid: any, state: UserState, firstName: string, lastName: string, email: string, avatar?: Maybe<string>, teams: Array<{ __typename?: 'UserTeam', id: number, ownerId: number, name?: Maybe<string> }>, teamMembership: Array<{ __typename?: 'UserTeamMember', id: number, userId: number, roleId: number, team: { __typename?: 'UserTeam', id: number, ownerId: number, name?: Maybe<string>, owner: { __typename?: 'User', id: number, firstName: string, lastName: string } }, role: { __typename?: 'UserRole', name: string, isAdmin: boolean, userManagment?: Maybe<Array<string>>, libraryManagement?: Maybe<Array<string>>, templatesManagement?: Maybe<Array<string>>, templatesAccess?: Maybe<Array<number>>, templateCategoryAccess?: Maybe<Array<number>> } }>, tier?: Maybe<{ __typename?: 'UserUserTier', id: number, userId: number, tierId: number, transactionId?: Maybe<string>, state?: Maybe<UserUserTierState>, expiredAt?: Maybe<any>, productId?: Maybe<string>, price?: Maybe<any>, createdAt: any, updatedAt: any, isTrial: boolean, tier: { __typename?: 'SystemTier', id: number, name: string, settings?: Maybe<any> } }> } } };

export type ResetUserPasswordMutationVariables = Exact<{
  email: Scalars['String'];
}>;


export type ResetUserPasswordMutation = { __typename?: 'Mutation', resetUserPassword: boolean };

export type SortLibraryBackgroundsMutationVariables = Exact<{
  data: Array<SortInput> | SortInput;
}>;


export type SortLibraryBackgroundsMutation = { __typename?: 'Mutation', sortLibraryBackgrounds: boolean };

export type SortLibraryColorsMutationVariables = Exact<{
  data: Array<SortInput> | SortInput;
}>;


export type SortLibraryColorsMutation = { __typename?: 'Mutation', sortLibraryColors: boolean };

export type SortLibraryFontsMutationVariables = Exact<{
  data: Array<SortInput> | SortInput;
}>;


export type SortLibraryFontsMutation = { __typename?: 'Mutation', sortLibraryFonts: boolean };

export type SortLibraryLogosMutationVariables = Exact<{
  data: Array<SortInput> | SortInput;
}>;


export type SortLibraryLogosMutation = { __typename?: 'Mutation', sortLibraryLogos: boolean };

export type SortLibrarySoundsMutationVariables = Exact<{
  data: Array<SortInput> | SortInput;
}>;


export type SortLibrarySoundsMutation = { __typename?: 'Mutation', sortLibrarySounds: boolean };

export type SortLibraryStickersMutationVariables = Exact<{
  data: Array<SortInput> | SortInput;
}>;


export type SortLibraryStickersMutation = { __typename?: 'Mutation', sortLibraryStickers: boolean };

export type SortLibraryTextPresetsMutationVariables = Exact<{
  data: Array<SortInput> | SortInput;
}>;


export type SortLibraryTextPresetsMutation = { __typename?: 'Mutation', sortLibraryTextPresets: boolean };

export type SortTemplateCategoriesMutationVariables = Exact<{
  data: Array<SortInput> | SortInput;
}>;


export type SortTemplateCategoriesMutation = { __typename?: 'Mutation', sortTemplateCategories: boolean };

export type SortTemplatesMutationVariables = Exact<{
  data: Array<SortInput> | SortInput;
}>;


export type SortTemplatesMutation = { __typename?: 'Mutation', sortTemplates: boolean };

export type UpdateLibraryCategoryMutationVariables = Exact<{
  id: Scalars['Int'];
  data: LibraryCategoryUpdateInput;
}>;


export type UpdateLibraryCategoryMutation = { __typename?: 'Mutation', updateLibraryCategory: { __typename?: 'LibraryCategory', id: number, name: string, color?: Maybe<string>, entity: LibraryCategoryEntity, tagId?: Maybe<number>, itemsCount: number } };

export type UpdateLibraryLogoMutationVariables = Exact<{
  id: Scalars['Int'];
  data: LibraryLogoUpdateInput;
}>;


export type UpdateLibraryLogoMutation = { __typename?: 'Mutation', updateLibraryLogo: { __typename?: 'LibraryLogo', id: number, name: string, ownerId: number, teamId: number, categoryId?: Maybe<number>, sortIndex: number, file?: Maybe<{ __typename?: 'LibraryFile', id: number, ownerId: number, name: string, url: string, previewUrl?: Maybe<string>, mimeType: LibraryFileMimeType, size?: Maybe<number>, width?: Maybe<number>, height?: Maybe<number>, duration?: Maybe<number>, bitrate?: Maybe<number>, ratio?: Maybe<string>, warnings?: Maybe<Array<string>>, errors?: Maybe<Array<string>> }> } };

export type UpdateLibraryStickerMutationVariables = Exact<{
  id: Scalars['Int'];
  data: LibraryStickerUpdateInput;
}>;


export type UpdateLibraryStickerMutation = { __typename?: 'Mutation', updateLibrarySticker: { __typename?: 'LibrarySticker', id: number, name: string, ownerId: number, teamId: number, categoryId?: Maybe<number>, sortIndex: number, file?: Maybe<{ __typename?: 'LibraryFile', id: number, ownerId: number, name: string, url: string, previewUrl?: Maybe<string>, mimeType: LibraryFileMimeType, size?: Maybe<number>, width?: Maybe<number>, height?: Maybe<number>, duration?: Maybe<number>, bitrate?: Maybe<number>, ratio?: Maybe<string>, warnings?: Maybe<Array<string>>, errors?: Maybe<Array<string>> }> } };

export type UpdateLibraryTextPresetMutationVariables = Exact<{
  id: Scalars['Int'];
  data: LibraryTextPresetUpdateInput;
}>;


export type UpdateLibraryTextPresetMutation = { __typename?: 'Mutation', updateLibraryTextPreset: { __typename?: 'LibraryTextPreset', id: number, ownerId: number, teamId: number, categoryId?: Maybe<number>, name: string, fontId?: Maybe<number>, fontAlignment?: Maybe<LibraryTextPresetFontAlignment>, fontSize?: Maybe<number>, frameSize?: Maybe<LibraryTextPresetFrameSize>, fontColorId?: Maybe<number>, sortIndex: number, backgroundColor?: Maybe<{ __typename?: 'LibraryBackground', id: number, name?: Maybe<string>, color?: Maybe<string>, categoryId?: Maybe<number>, sortIndex: number, fileId?: Maybe<number>, file?: Maybe<{ __typename?: 'LibraryFile', id: number, ownerId: number, name: string, url: string, previewUrl?: Maybe<string>, mimeType: LibraryFileMimeType, size?: Maybe<number>, width?: Maybe<number>, height?: Maybe<number>, duration?: Maybe<number>, bitrate?: Maybe<number>, ratio?: Maybe<string>, warnings?: Maybe<Array<string>>, errors?: Maybe<Array<string>> }> }>, category?: Maybe<{ __typename?: 'LibraryCategory', id: number, name: string, color?: Maybe<string>, entity: LibraryCategoryEntity, tagId?: Maybe<number>, itemsCount: number }>, fontColor?: Maybe<{ __typename?: 'LibraryColor', id: number, name?: Maybe<string>, sortIndex: number, value: string, categoryId?: Maybe<number> }> } };

export type UpdateTemplateMutationVariables = Exact<{
  id: Scalars['Int'];
  data: TemplateUpdateInput;
}>;


export type UpdateTemplateMutation = { __typename?: 'Mutation', updateTemplate: { __typename?: 'Template', id: number, name: string, categoryId: number, textPresetId?: Maybe<Array<number>>, sortIndex: number, settings?: Maybe<string>, images?: Maybe<{ __typename?: 'TemplateImages', accepted?: Maybe<Array<{ __typename?: 'LibraryFile', id: number, ownerId: number, name: string, url: string, previewUrl?: Maybe<string>, mimeType: LibraryFileMimeType, size?: Maybe<number>, width?: Maybe<number>, height?: Maybe<number>, duration?: Maybe<number>, bitrate?: Maybe<number>, ratio?: Maybe<string>, warnings?: Maybe<Array<string>>, errors?: Maybe<Array<string>> }>>, declined?: Maybe<Array<{ __typename?: 'LibraryFile', id: number, ownerId: number, name: string, url: string, previewUrl?: Maybe<string>, mimeType: LibraryFileMimeType, size?: Maybe<number>, width?: Maybe<number>, height?: Maybe<number>, duration?: Maybe<number>, bitrate?: Maybe<number>, ratio?: Maybe<string>, warnings?: Maybe<Array<string>>, errors?: Maybe<Array<string>> }>> }> } };

export type UpdateTemplateCategoryMutationVariables = Exact<{
  id: Scalars['Int'];
  data: TemplateCategoryUpdateInput;
}>;


export type UpdateTemplateCategoryMutation = { __typename?: 'Mutation', updateTemplateCategory: { __typename?: 'TemplateCategory', id: number, name: string } };

export type UpdateUserProfileMutationVariables = Exact<{
  data: UpdateUserProfileInput;
}>;


export type UpdateUserProfileMutation = { __typename?: 'Mutation', updateUserProfile: { __typename?: 'User', id: number, firstName: string, lastName: string, avatar?: Maybe<string> } };

export type UpdateUserRoleMutationVariables = Exact<{
  id: Scalars['Int'];
  data: UserRoleUpdateInput;
}>;


export type UpdateUserRoleMutation = { __typename?: 'Mutation', updateUserRole: { __typename?: 'UserRole', id: number } };

export type UpdateUserTeamMemberMutationVariables = Exact<{
  id: Scalars['Int'];
  data: UserTeamMemberUpdateInput;
}>;


export type UpdateUserTeamMemberMutation = { __typename?: 'Mutation', updateUserTeamMember: { __typename?: 'UserTeamMember', id: number, roleId: number } };

export type VerifyUserEmailMutationVariables = Exact<{
  key: Scalars['String'];
}>;


export type VerifyUserEmailMutation = { __typename?: 'Mutation', verifyUserEmail: { __typename?: 'User', id: number } };

export type AllLibraryBackgroundsQueryVariables = Exact<{
  query?: Maybe<DefaultQueryInput>;
}>;


export type AllLibraryBackgroundsQuery = { __typename?: 'Query', allLibraryBackgrounds: { __typename?: 'LibraryBackgroundConnection', total: number, edges: Array<{ __typename?: 'LibraryBackground', id: number, name?: Maybe<string>, color?: Maybe<string>, categoryId?: Maybe<number>, sortIndex: number, fileId?: Maybe<number>, file?: Maybe<{ __typename?: 'LibraryFile', id: number, ownerId: number, name: string, url: string, previewUrl?: Maybe<string>, mimeType: LibraryFileMimeType, size?: Maybe<number>, width?: Maybe<number>, height?: Maybe<number>, duration?: Maybe<number>, bitrate?: Maybe<number>, ratio?: Maybe<string>, warnings?: Maybe<Array<string>>, errors?: Maybe<Array<string>> }> }> } };

export type AllLibraryCategoriesQueryVariables = Exact<{
  query?: Maybe<DefaultQueryInput>;
}>;


export type AllLibraryCategoriesQuery = { __typename?: 'Query', allLibraryCategories: { __typename?: 'LibraryCategoryConnection', total: number, edges: Array<{ __typename?: 'LibraryCategory', id: number, name: string, color?: Maybe<string>, entity: LibraryCategoryEntity, tagId?: Maybe<number>, itemsCount: number }> } };

export type AllLibraryColorsQueryVariables = Exact<{
  query?: Maybe<DefaultQueryInput>;
}>;


export type AllLibraryColorsQuery = { __typename?: 'Query', allLibraryColors: { __typename?: 'LibraryColorConnection', total: number, edges: Array<{ __typename?: 'LibraryColor', id: number, name?: Maybe<string>, sortIndex: number, value: string, categoryId?: Maybe<number> }> } };

export type AllLibraryFontsQueryVariables = Exact<{
  query?: Maybe<DefaultQueryInput>;
}>;


export type AllLibraryFontsQuery = { __typename?: 'Query', allLibraryFonts: { __typename?: 'LibraryFontConnection', total: number, edges: Array<{ __typename?: 'LibraryFont', id: number, name: string, ownerId: number, teamId: number, categoryId?: Maybe<number>, sortIndex: number, file?: Maybe<{ __typename?: 'LibraryFile', id: number, ownerId: number, name: string, url: string, previewUrl?: Maybe<string>, mimeType: LibraryFileMimeType, size?: Maybe<number>, width?: Maybe<number>, height?: Maybe<number>, duration?: Maybe<number>, bitrate?: Maybe<number>, ratio?: Maybe<string>, warnings?: Maybe<Array<string>>, errors?: Maybe<Array<string>> }> }> } };

export type AllLibraryFontsFlatQueryVariables = Exact<{
  query?: Maybe<DefaultQueryInput>;
}>;


export type AllLibraryFontsFlatQuery = { __typename?: 'Query', allLibraryFonts: { __typename?: 'LibraryFontConnection', total: number, edges: Array<{ __typename?: 'LibraryFont', id: number, name: string, sortIndex: number, ownerId: number, teamId: number, categoryId?: Maybe<number> }> } };

export type AllLibraryLogosQueryVariables = Exact<{
  query?: Maybe<DefaultQueryInput>;
}>;


export type AllLibraryLogosQuery = { __typename?: 'Query', allLibraryLogos: { __typename?: 'LibraryLogoConnection', total: number, edges: Array<{ __typename?: 'LibraryLogo', id: number, name: string, ownerId: number, teamId: number, categoryId?: Maybe<number>, sortIndex: number, file?: Maybe<{ __typename?: 'LibraryFile', id: number, ownerId: number, name: string, url: string, previewUrl?: Maybe<string>, mimeType: LibraryFileMimeType, size?: Maybe<number>, width?: Maybe<number>, height?: Maybe<number>, duration?: Maybe<number>, bitrate?: Maybe<number>, ratio?: Maybe<string>, warnings?: Maybe<Array<string>>, errors?: Maybe<Array<string>> }> }> } };

export type AllLibrarySoundsQueryVariables = Exact<{
  query?: Maybe<DefaultQueryInput>;
}>;


export type AllLibrarySoundsQuery = { __typename?: 'Query', allLibrarySounds: { __typename?: 'LibrarySoundConnection', total: number, edges: Array<{ __typename?: 'LibrarySound', id: number, name: string, ownerId: number, teamId: number, categoryId?: Maybe<number>, sortIndex: number, file?: Maybe<{ __typename?: 'LibraryFile', id: number, ownerId: number, name: string, url: string, previewUrl?: Maybe<string>, mimeType: LibraryFileMimeType, size?: Maybe<number>, width?: Maybe<number>, height?: Maybe<number>, duration?: Maybe<number>, bitrate?: Maybe<number>, ratio?: Maybe<string>, warnings?: Maybe<Array<string>>, errors?: Maybe<Array<string>> }> }> } };

export type AllLibraryStickersQueryVariables = Exact<{
  query?: Maybe<DefaultQueryInput>;
}>;


export type AllLibraryStickersQuery = { __typename?: 'Query', allLibraryStickers: { __typename?: 'LibraryStickerConnection', total: number, edges: Array<{ __typename?: 'LibrarySticker', id: number, name: string, ownerId: number, teamId: number, categoryId?: Maybe<number>, sortIndex: number, file?: Maybe<{ __typename?: 'LibraryFile', id: number, ownerId: number, name: string, url: string, previewUrl?: Maybe<string>, mimeType: LibraryFileMimeType, size?: Maybe<number>, width?: Maybe<number>, height?: Maybe<number>, duration?: Maybe<number>, bitrate?: Maybe<number>, ratio?: Maybe<string>, warnings?: Maybe<Array<string>>, errors?: Maybe<Array<string>> }> }> } };

export type AllLibraryTextPresetsQueryVariables = Exact<{
  query?: Maybe<DefaultQueryInput>;
}>;


export type AllLibraryTextPresetsQuery = { __typename?: 'Query', allLibraryTextPresets: { __typename?: 'LibraryTextPresetConnection', total: number, limit: number, cursor: number, sortable?: Maybe<Array<string>>, edges: Array<{ __typename?: 'LibraryTextPreset', id: number, ownerId: number, teamId: number, categoryId?: Maybe<number>, name: string, fontId?: Maybe<number>, fontAlignment?: Maybe<LibraryTextPresetFontAlignment>, fontSize?: Maybe<number>, frameSize?: Maybe<LibraryTextPresetFrameSize>, fontColorId?: Maybe<number>, sortIndex: number, backgroundColor?: Maybe<{ __typename?: 'LibraryBackground', id: number, name?: Maybe<string>, color?: Maybe<string>, categoryId?: Maybe<number>, sortIndex: number, fileId?: Maybe<number>, file?: Maybe<{ __typename?: 'LibraryFile', id: number, ownerId: number, name: string, url: string, previewUrl?: Maybe<string>, mimeType: LibraryFileMimeType, size?: Maybe<number>, width?: Maybe<number>, height?: Maybe<number>, duration?: Maybe<number>, bitrate?: Maybe<number>, ratio?: Maybe<string>, warnings?: Maybe<Array<string>>, errors?: Maybe<Array<string>> }> }>, category?: Maybe<{ __typename?: 'LibraryCategory', id: number, name: string, color?: Maybe<string>, entity: LibraryCategoryEntity, tagId?: Maybe<number>, itemsCount: number }>, fontColor?: Maybe<{ __typename?: 'LibraryColor', id: number, name?: Maybe<string>, sortIndex: number, value: string, categoryId?: Maybe<number> }> }> } };

export type AllLibraryTextPresetsFlatQueryVariables = Exact<{
  query?: Maybe<DefaultQueryInput>;
}>;


export type AllLibraryTextPresetsFlatQuery = { __typename?: 'Query', allLibraryTextPresets: { __typename?: 'LibraryTextPresetConnection', total: number, limit: number, cursor: number, sortable?: Maybe<Array<string>>, edges: Array<{ __typename?: 'LibraryTextPreset', id: number, ownerId: number, teamId: number, categoryId?: Maybe<number>, name: string, fontId?: Maybe<number>, fontAlignment?: Maybe<LibraryTextPresetFontAlignment>, fontSize?: Maybe<number>, frameSize?: Maybe<LibraryTextPresetFrameSize>, fontColorId?: Maybe<number>, backgroundColorId?: Maybe<number>, sortIndex: number }> } };

export type AllMyUserTiersQueryVariables = Exact<{
  query?: Maybe<DefaultQueryInput>;
}>;


export type AllMyUserTiersQuery = { __typename?: 'Query', allMyUserTiers: { __typename?: 'UserUserTierConnection', total: number, limit: number, cursor: number, sortable?: Maybe<Array<string>>, edges: Array<{ __typename?: 'UserUserTier', id: number, userId: number, tierId: number, transactionId?: Maybe<string>, state?: Maybe<UserUserTierState>, expiredAt?: Maybe<any>, productId?: Maybe<string>, price?: Maybe<any>, createdAt: any, updatedAt: any, isTrial: boolean, tier: { __typename?: 'SystemTier', id: number, name: string } }> } };

export type AllTemplatesQueryVariables = Exact<{
  query?: Maybe<DefaultQueryInput>;
}>;


export type AllTemplatesQuery = { __typename?: 'Query', allTemplates: { __typename?: 'TemplateConnection', total: number, limit: number, cursor: number, sortable?: Maybe<Array<string>>, edges: Array<{ __typename?: 'Template', id: number, name: string, categoryId: number, textPresetId?: Maybe<Array<number>>, sortIndex: number, settings?: Maybe<string>, images?: Maybe<{ __typename?: 'TemplateImages', accepted?: Maybe<Array<{ __typename?: 'LibraryFile', id: number, ownerId: number, name: string, url: string, previewUrl?: Maybe<string>, mimeType: LibraryFileMimeType, size?: Maybe<number>, width?: Maybe<number>, height?: Maybe<number>, duration?: Maybe<number>, bitrate?: Maybe<number>, ratio?: Maybe<string>, warnings?: Maybe<Array<string>>, errors?: Maybe<Array<string>> }>>, declined?: Maybe<Array<{ __typename?: 'LibraryFile', id: number, ownerId: number, name: string, url: string, previewUrl?: Maybe<string>, mimeType: LibraryFileMimeType, size?: Maybe<number>, width?: Maybe<number>, height?: Maybe<number>, duration?: Maybe<number>, bitrate?: Maybe<number>, ratio?: Maybe<string>, warnings?: Maybe<Array<string>>, errors?: Maybe<Array<string>> }>> }> }> } };

export type AllTemplateCategoriesQueryVariables = Exact<{
  query?: Maybe<DefaultQueryInput>;
}>;


export type AllTemplateCategoriesQuery = { __typename?: 'Query', allTemplateCategories: { __typename?: 'TemplateCategoryConnection', total: number, cursor: number, edges: Array<{ __typename?: 'TemplateCategory', id: number, name: string, sortIndex: number }> } };

export type AllUserTeamMembersQueryVariables = Exact<{
  query?: Maybe<DefaultQueryInput>;
}>;


export type AllUserTeamMembersQuery = { __typename?: 'Query', allUserTeamMembers: { __typename?: 'UserTeamMemberConnection', total: number, edges: Array<{ __typename?: 'UserTeamMember', id: number, userId: number, roleId: number, role: { __typename?: 'UserRole', name: string, isAdmin: boolean }, user: { __typename?: 'User', id: number, uuid: any, state: UserState, firstName: string, lastName: string, email: string, avatar?: Maybe<string> } }> } };

export type AllUserTransactionsQueryVariables = Exact<{
  query?: Maybe<DefaultQueryInput>;
}>;


export type AllUserTransactionsQuery = { __typename?: 'Query', allUserTransactions: { __typename?: 'UserTransactionConnection', total: number, edges: Array<{ __typename?: 'UserTransaction', id: number, state?: Maybe<UserTransactionState>, receipt?: Maybe<any>, receiptProductId?: Maybe<string>, receiptTransactionId?: Maybe<string> }> } };

export type AllUsersQueryVariables = Exact<{
  query?: Maybe<DefaultQueryInput>;
}>;


export type AllUsersQuery = { __typename?: 'Query', allUsers: { __typename?: 'UserConnection', edges: Array<{ __typename?: 'User', id: number, uuid: any, state: UserState, firstName: string, lastName: string, email: string, avatar?: Maybe<string>, teams: Array<{ __typename?: 'UserTeam', id: number, ownerId: number, name?: Maybe<string> }>, teamMembership: Array<{ __typename?: 'UserTeamMember', id: number, userId: number, roleId: number, team: { __typename?: 'UserTeam', id: number, ownerId: number, name?: Maybe<string>, owner: { __typename?: 'User', id: number, firstName: string, lastName: string } }, role: { __typename?: 'UserRole', name: string, isAdmin: boolean, userManagment?: Maybe<Array<string>>, libraryManagement?: Maybe<Array<string>>, templatesManagement?: Maybe<Array<string>>, templatesAccess?: Maybe<Array<number>>, templateCategoryAccess?: Maybe<Array<number>> } }>, tier?: Maybe<{ __typename?: 'UserUserTier', id: number, userId: number, tierId: number, transactionId?: Maybe<string>, state?: Maybe<UserUserTierState>, expiredAt?: Maybe<any>, productId?: Maybe<string>, price?: Maybe<any>, createdAt: any, updatedAt: any, isTrial: boolean, tier: { __typename?: 'SystemTier', id: number, name: string, settings?: Maybe<any> } }> }> } };

export type AllWebTranslationsQueryVariables = Exact<{
  locale: Scalars['String'];
}>;


export type AllWebTranslationsQuery = { __typename?: 'Query', allWebTranslations: { __typename?: 'SystemTranslationConnection', total: number, edges: Array<{ __typename?: 'SystemTranslation', id: number, key: string, value: string, updatedAt: any }> } };

export type LibraryCategoryQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type LibraryCategoryQuery = { __typename?: 'Query', libraryCategory: { __typename?: 'LibraryCategory', id: number, name: string, color?: Maybe<string>, entity: LibraryCategoryEntity, tagId?: Maybe<number>, itemsCount: number } };

export type LibraryTextPresetQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type LibraryTextPresetQuery = { __typename?: 'Query', libraryTextPreset: { __typename?: 'LibraryTextPreset', id: number, ownerId: number, teamId: number, categoryId?: Maybe<number>, name: string, fontId?: Maybe<number>, fontAlignment?: Maybe<LibraryTextPresetFontAlignment>, fontSize?: Maybe<number>, frameSize?: Maybe<LibraryTextPresetFrameSize>, fontColorId?: Maybe<number>, sortIndex: number, backgroundColor?: Maybe<{ __typename?: 'LibraryBackground', id: number, name?: Maybe<string>, color?: Maybe<string>, categoryId?: Maybe<number>, sortIndex: number, fileId?: Maybe<number>, file?: Maybe<{ __typename?: 'LibraryFile', id: number, ownerId: number, name: string, url: string, previewUrl?: Maybe<string>, mimeType: LibraryFileMimeType, size?: Maybe<number>, width?: Maybe<number>, height?: Maybe<number>, duration?: Maybe<number>, bitrate?: Maybe<number>, ratio?: Maybe<string>, warnings?: Maybe<Array<string>>, errors?: Maybe<Array<string>> }> }>, category?: Maybe<{ __typename?: 'LibraryCategory', id: number, name: string, color?: Maybe<string>, entity: LibraryCategoryEntity, tagId?: Maybe<number>, itemsCount: number }>, fontColor?: Maybe<{ __typename?: 'LibraryColor', id: number, name?: Maybe<string>, sortIndex: number, value: string, categoryId?: Maybe<number> }> } };

export type LibraryTextPresetFlatQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type LibraryTextPresetFlatQuery = { __typename?: 'Query', libraryTextPreset: { __typename?: 'LibraryTextPreset', id: number, ownerId: number, teamId: number, categoryId?: Maybe<number>, name: string, fontId?: Maybe<number>, fontAlignment?: Maybe<LibraryTextPresetFontAlignment>, fontSize?: Maybe<number>, frameSize?: Maybe<LibraryTextPresetFrameSize>, fontColorId?: Maybe<number>, backgroundColorId?: Maybe<number>, sortIndex: number } };

export type ProfileQueryVariables = Exact<{ [key: string]: never; }>;


export type ProfileQuery = { __typename?: 'Query', profile: { __typename?: 'User', id: number, uuid: any, state: UserState, firstName: string, lastName: string, email: string, avatar?: Maybe<string>, teams: Array<{ __typename?: 'UserTeam', id: number, ownerId: number, name?: Maybe<string> }>, teamMembership: Array<{ __typename?: 'UserTeamMember', id: number, userId: number, roleId: number, team: { __typename?: 'UserTeam', id: number, ownerId: number, name?: Maybe<string>, owner: { __typename?: 'User', id: number, firstName: string, lastName: string } }, role: { __typename?: 'UserRole', name: string, isAdmin: boolean, userManagment?: Maybe<Array<string>>, libraryManagement?: Maybe<Array<string>>, templatesManagement?: Maybe<Array<string>>, templatesAccess?: Maybe<Array<number>>, templateCategoryAccess?: Maybe<Array<number>> } }>, tier?: Maybe<{ __typename?: 'UserUserTier', id: number, userId: number, tierId: number, transactionId?: Maybe<string>, state?: Maybe<UserUserTierState>, expiredAt?: Maybe<any>, productId?: Maybe<string>, price?: Maybe<any>, createdAt: any, updatedAt: any, isTrial: boolean, tier: { __typename?: 'SystemTier', id: number, name: string, settings?: Maybe<any> } }> } };

export type TemplateQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type TemplateQuery = { __typename?: 'Query', template: { __typename?: 'Template', id: number, name: string, categoryId: number, textPresetId?: Maybe<Array<number>>, sortIndex: number, settings?: Maybe<string>, images?: Maybe<{ __typename?: 'TemplateImages', accepted?: Maybe<Array<{ __typename?: 'LibraryFile', id: number, ownerId: number, name: string, url: string, previewUrl?: Maybe<string>, mimeType: LibraryFileMimeType, size?: Maybe<number>, width?: Maybe<number>, height?: Maybe<number>, duration?: Maybe<number>, bitrate?: Maybe<number>, ratio?: Maybe<string>, warnings?: Maybe<Array<string>>, errors?: Maybe<Array<string>> }>>, declined?: Maybe<Array<{ __typename?: 'LibraryFile', id: number, ownerId: number, name: string, url: string, previewUrl?: Maybe<string>, mimeType: LibraryFileMimeType, size?: Maybe<number>, width?: Maybe<number>, height?: Maybe<number>, duration?: Maybe<number>, bitrate?: Maybe<number>, ratio?: Maybe<string>, warnings?: Maybe<Array<string>>, errors?: Maybe<Array<string>> }>> }> } };

export type TemplateFullQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type TemplateFullQuery = { __typename?: 'Query', template: { __typename?: 'Template', id: number, name: string, categoryId: number, sortIndex: number, settings?: Maybe<string>, textPresets?: Maybe<Array<{ __typename?: 'LibraryTextPreset', id: number, ownerId: number, teamId: number, categoryId?: Maybe<number>, name: string, fontId?: Maybe<number>, fontAlignment?: Maybe<LibraryTextPresetFontAlignment>, fontSize?: Maybe<number>, frameSize?: Maybe<LibraryTextPresetFrameSize>, fontColorId?: Maybe<number>, sortIndex: number, backgroundColor?: Maybe<{ __typename?: 'LibraryBackground', id: number, name?: Maybe<string>, color?: Maybe<string>, categoryId?: Maybe<number>, sortIndex: number, fileId?: Maybe<number>, file?: Maybe<{ __typename?: 'LibraryFile', id: number, ownerId: number, name: string, url: string, previewUrl?: Maybe<string>, mimeType: LibraryFileMimeType, size?: Maybe<number>, width?: Maybe<number>, height?: Maybe<number>, duration?: Maybe<number>, bitrate?: Maybe<number>, ratio?: Maybe<string>, warnings?: Maybe<Array<string>>, errors?: Maybe<Array<string>> }> }>, category?: Maybe<{ __typename?: 'LibraryCategory', id: number, name: string, color?: Maybe<string>, entity: LibraryCategoryEntity, tagId?: Maybe<number>, itemsCount: number }>, fontColor?: Maybe<{ __typename?: 'LibraryColor', id: number, name?: Maybe<string>, sortIndex: number, value: string, categoryId?: Maybe<number> }> }>>, images?: Maybe<{ __typename?: 'TemplateImages', accepted?: Maybe<Array<{ __typename?: 'LibraryFile', id: number, ownerId: number, name: string, url: string, previewUrl?: Maybe<string>, mimeType: LibraryFileMimeType, size?: Maybe<number>, width?: Maybe<number>, height?: Maybe<number>, duration?: Maybe<number>, bitrate?: Maybe<number>, ratio?: Maybe<string>, warnings?: Maybe<Array<string>>, errors?: Maybe<Array<string>> }>>, declined?: Maybe<Array<{ __typename?: 'LibraryFile', id: number, ownerId: number, name: string, url: string, previewUrl?: Maybe<string>, mimeType: LibraryFileMimeType, size?: Maybe<number>, width?: Maybe<number>, height?: Maybe<number>, duration?: Maybe<number>, bitrate?: Maybe<number>, ratio?: Maybe<string>, warnings?: Maybe<Array<string>>, errors?: Maybe<Array<string>> }>> }> } };

export type TemplateCategoryQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type TemplateCategoryQuery = { __typename?: 'Query', templateCategory: { __typename?: 'TemplateCategory', id: number, name: string, sortIndex: number } };

export type UserRoleQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type UserRoleQuery = { __typename?: 'Query', userRole: { __typename?: 'UserRole', id: number, name: string, isAdmin: boolean, teamId: number, userManagment?: Maybe<Array<string>>, libraryManagement?: Maybe<Array<string>>, templatesManagement?: Maybe<Array<string>>, templateCategoryAccess?: Maybe<Array<number>>, templatesAccess?: Maybe<Array<number>>, isOwner?: Maybe<boolean>, team: { __typename?: 'UserTeam', id: number, ownerId: number, name?: Maybe<string> } } };

export type UserRolesQueryVariables = Exact<{
  query?: Maybe<DefaultQueryInput>;
}>;


export type UserRolesQuery = { __typename?: 'Query', userRoles: Array<{ __typename?: 'UserRole', id: number, name: string, isAdmin: boolean, teamId: number, userManagment?: Maybe<Array<string>>, libraryManagement?: Maybe<Array<string>>, templatesManagement?: Maybe<Array<string>>, templateCategoryAccess?: Maybe<Array<number>>, templatesAccess?: Maybe<Array<number>>, isOwner?: Maybe<boolean>, team: { __typename?: 'UserTeam', id: number, ownerId: number, name?: Maybe<string> } }> };

export type UserUserTierQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type UserUserTierQuery = { __typename?: 'Query', userUserTier: { __typename?: 'UserUserTier', id: number, userId: number, tierId: number, transactionId?: Maybe<string>, state?: Maybe<UserUserTierState>, expiredAt?: Maybe<any>, productId?: Maybe<string>, price?: Maybe<any>, createdAt: any, updatedAt: any, isTrial: boolean, tier: { __typename?: 'SystemTier', id: number, name: string } } };

export type WebTranslationsUpdatedAtQueryVariables = Exact<{
  locale: Scalars['String'];
}>;


export type WebTranslationsUpdatedAtQuery = { __typename?: 'Query', webTranslationsUpdatedAt: any };

export const UserTeamFragmentDoc = gql`
    fragment userTeam on UserTeam {
  id
  ownerId
  name
}
    `;
export const UserTeamMemberProfileFragmentDoc = gql`
    fragment userTeamMemberProfile on UserTeamMember {
  id
  userId
  roleId
  team {
    id
    ownerId
    name
    owner {
      id
      firstName
      lastName
    }
  }
  role {
    name
    isAdmin
    userManagment
    libraryManagement
    templatesManagement
    templatesAccess
    templateCategoryAccess
  }
}
    `;
export const ProfileUserUserTierFragmentDoc = gql`
    fragment profileUserUserTier on UserUserTier {
  id
  userId
  tierId
  transactionId
  state
  expiredAt
  productId
  price
  createdAt
  updatedAt
  isTrial
  tier {
    id
    name
    settings
  }
}
    `;
export const UserFragmentDoc = gql`
    fragment user on User {
  id
  uuid
  state
  firstName
  lastName
  email
  avatar
  teams {
    ...userTeam
  }
  teamMembership {
    ...userTeamMemberProfile
  }
  tier {
    ...profileUserUserTier
  }
}
    ${UserTeamFragmentDoc}
${UserTeamMemberProfileFragmentDoc}
${ProfileUserUserTierFragmentDoc}`;
export const AuthResponseFragmentDoc = gql`
    fragment authResponse on AuthResponse {
  user {
    ...user
  }
  refreshToken
  accessToken
}
    ${UserFragmentDoc}`;
export const LibraryFileFragmentDoc = gql`
    fragment libraryFile on LibraryFile {
  id
  ownerId
  name
  url
  previewUrl
  mimeType
  size
  width
  height
  duration
  bitrate
  ratio
  warnings
  errors
}
    `;
export const LibraryFontFragmentDoc = gql`
    fragment libraryFont on LibraryFont {
  id
  name
  ownerId
  teamId
  categoryId
  sortIndex
  file {
    ...libraryFile
  }
}
    ${LibraryFileFragmentDoc}`;
export const LibraryFontFlatFragmentDoc = gql`
    fragment libraryFontFlat on LibraryFont {
  id
  name
  sortIndex
  ownerId
  teamId
  categoryId
}
    `;
export const LibraryLogoFragmentDoc = gql`
    fragment libraryLogo on LibraryLogo {
  id
  name
  ownerId
  teamId
  categoryId
  sortIndex
  file {
    ...libraryFile
  }
}
    ${LibraryFileFragmentDoc}`;
export const LibrarySoundFragmentDoc = gql`
    fragment librarySound on LibrarySound {
  id
  name
  ownerId
  teamId
  categoryId
  sortIndex
  file {
    ...libraryFile
  }
}
    ${LibraryFileFragmentDoc}`;
export const LibraryStickerFragmentDoc = gql`
    fragment librarySticker on LibrarySticker {
  id
  name
  ownerId
  teamId
  categoryId
  sortIndex
  file {
    ...libraryFile
  }
}
    ${LibraryFileFragmentDoc}`;
export const LibraryBackgroundFragmentDoc = gql`
    fragment libraryBackground on LibraryBackground {
  id
  name
  color
  categoryId
  sortIndex
  fileId
  file {
    ...libraryFile
  }
}
    ${LibraryFileFragmentDoc}`;
export const LibraryCategoryFragmentDoc = gql`
    fragment libraryCategory on LibraryCategory {
  id
  name
  color
  entity
  tagId
  itemsCount
}
    `;
export const LibraryColorFragmentDoc = gql`
    fragment libraryColor on LibraryColor {
  id
  name
  sortIndex
  value
  categoryId
}
    `;
export const LibraryTextPresetFragmentDoc = gql`
    fragment libraryTextPreset on LibraryTextPreset {
  id
  ownerId
  teamId
  categoryId
  name
  fontId
  fontAlignment
  fontSize
  frameSize
  fontColorId
  sortIndex
  backgroundColor {
    ...libraryBackground
  }
  category {
    ...libraryCategory
  }
  fontColor {
    ...libraryColor
  }
}
    ${LibraryBackgroundFragmentDoc}
${LibraryCategoryFragmentDoc}
${LibraryColorFragmentDoc}`;
export const LibraryTextPresetConnectionFragmentDoc = gql`
    fragment libraryTextPresetConnection on LibraryTextPresetConnection {
  total
  limit
  cursor
  sortable
  edges {
    ...libraryTextPreset
  }
}
    ${LibraryTextPresetFragmentDoc}`;
export const LibraryTextPresetFlatFragmentDoc = gql`
    fragment libraryTextPresetFlat on LibraryTextPreset {
  id
  ownerId
  teamId
  categoryId
  name
  fontId
  fontAlignment
  fontSize
  frameSize
  fontColorId
  backgroundColorId
  sortIndex
}
    `;
export const LibraryTextPresetFlatConnectionFragmentDoc = gql`
    fragment libraryTextPresetFlatConnection on LibraryTextPresetConnection {
  total
  limit
  cursor
  sortable
  edges {
    ...libraryTextPresetFlat
  }
}
    ${LibraryTextPresetFlatFragmentDoc}`;
export const SystemTranslationFragmentDoc = gql`
    fragment systemTranslation on SystemTranslation {
  id
  key
  value
  updatedAt
}
    `;
export const SystemTranslationConnectionFragmentDoc = gql`
    fragment systemTranslationConnection on SystemTranslationConnection {
  total
  edges {
    ...systemTranslation
  }
}
    ${SystemTranslationFragmentDoc}`;
export const TemplateFullFragmentDoc = gql`
    fragment templateFull on Template {
  id
  name
  categoryId
  sortIndex
  settings
  textPresets {
    ...libraryTextPreset
  }
  images {
    accepted {
      ...libraryFile
    }
    declined {
      ...libraryFile
    }
  }
}
    ${LibraryTextPresetFragmentDoc}
${LibraryFileFragmentDoc}`;
export const TemplateCategoryFragmentDoc = gql`
    fragment templateCategory on TemplateCategory {
  id
  name
  sortIndex
}
    `;
export const TemplateFragmentDoc = gql`
    fragment template on Template {
  id
  name
  categoryId
  textPresetId
  sortIndex
  settings
  images {
    accepted {
      ...libraryFile
    }
    declined {
      ...libraryFile
    }
  }
}
    ${LibraryFileFragmentDoc}`;
export const TemplateConnectionFragmentDoc = gql`
    fragment templateConnection on TemplateConnection {
  total
  limit
  cursor
  sortable
  edges {
    ...template
  }
}
    ${TemplateFragmentDoc}`;
export const UserRoleFragmentDoc = gql`
    fragment userRole on UserRole {
  id
  name
  isAdmin
  teamId
  userManagment
  libraryManagement
  templatesManagement
  templateCategoryAccess
  templatesAccess
  isOwner
  team {
    ...userTeam
  }
}
    ${UserTeamFragmentDoc}`;
export const UserFlatFragmentDoc = gql`
    fragment userFlat on User {
  id
  uuid
  state
  firstName
  lastName
  email
  avatar
}
    `;
export const UserTeamMemberSmallFragmentDoc = gql`
    fragment userTeamMemberSmall on UserTeamMember {
  id
  userId
  roleId
  role {
    name
    isAdmin
  }
  user {
    ...userFlat
  }
}
    ${UserFlatFragmentDoc}`;
export const UserTransactionFragmentDoc = gql`
    fragment userTransaction on UserTransaction {
  id
  state
  receipt
  receiptProductId
  receiptTransactionId
}
    `;
export const UserUserTierFragmentDoc = gql`
    fragment userUserTier on UserUserTier {
  id
  userId
  tierId
  transactionId
  state
  expiredAt
  productId
  price
  createdAt
  updatedAt
  isTrial
  tier {
    id
    name
  }
}
    `;
export const UserUserTierConnectionFragmentDoc = gql`
    fragment userUserTierConnection on UserUserTierConnection {
  total
  limit
  cursor
  sortable
  edges {
    ...userUserTier
  }
}
    ${UserUserTierFragmentDoc}`;
export const AcceptUserInviteDocument = gql`
    mutation acceptUserInvite($key: String!) {
  acceptUserInvite(key: $key) {
    id
  }
}
    `;
export type AcceptUserInviteMutationFn = Apollo.MutationFunction<AcceptUserInviteMutation, AcceptUserInviteMutationVariables>;

/**
 * __useAcceptUserInviteMutation__
 *
 * To run a mutation, you first call `useAcceptUserInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptUserInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptUserInviteMutation, { data, loading, error }] = useAcceptUserInviteMutation({
 *   variables: {
 *      key: // value for 'key'
 *   },
 * });
 */
export function useAcceptUserInviteMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AcceptUserInviteMutation, AcceptUserInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AcceptUserInviteMutation, AcceptUserInviteMutationVariables>(AcceptUserInviteDocument, options);
      }
export type AcceptUserInviteMutationHookResult = ReturnType<typeof useAcceptUserInviteMutation>;
export type AcceptUserInviteMutationResult = Apollo.MutationResult<AcceptUserInviteMutation>;
export type AcceptUserInviteMutationOptions = Apollo.BaseMutationOptions<AcceptUserInviteMutation, AcceptUserInviteMutationVariables>;
export const CreateLibraryBackgroundDocument = gql`
    mutation createLibraryBackground($data: LibraryBackgroundCreateInput!) {
  createLibraryBackground(data: $data) {
    ...libraryBackground
  }
}
    ${LibraryBackgroundFragmentDoc}`;
export type CreateLibraryBackgroundMutationFn = Apollo.MutationFunction<CreateLibraryBackgroundMutation, CreateLibraryBackgroundMutationVariables>;

/**
 * __useCreateLibraryBackgroundMutation__
 *
 * To run a mutation, you first call `useCreateLibraryBackgroundMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLibraryBackgroundMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLibraryBackgroundMutation, { data, loading, error }] = useCreateLibraryBackgroundMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateLibraryBackgroundMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateLibraryBackgroundMutation, CreateLibraryBackgroundMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateLibraryBackgroundMutation, CreateLibraryBackgroundMutationVariables>(CreateLibraryBackgroundDocument, options);
      }
export type CreateLibraryBackgroundMutationHookResult = ReturnType<typeof useCreateLibraryBackgroundMutation>;
export type CreateLibraryBackgroundMutationResult = Apollo.MutationResult<CreateLibraryBackgroundMutation>;
export type CreateLibraryBackgroundMutationOptions = Apollo.BaseMutationOptions<CreateLibraryBackgroundMutation, CreateLibraryBackgroundMutationVariables>;
export const CreateLibraryCategoryDocument = gql`
    mutation createLibraryCategory($data: LibraryCategoryCreateInput!) {
  createLibraryCategory(data: $data) {
    id
    name
  }
}
    `;
export type CreateLibraryCategoryMutationFn = Apollo.MutationFunction<CreateLibraryCategoryMutation, CreateLibraryCategoryMutationVariables>;

/**
 * __useCreateLibraryCategoryMutation__
 *
 * To run a mutation, you first call `useCreateLibraryCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLibraryCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLibraryCategoryMutation, { data, loading, error }] = useCreateLibraryCategoryMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateLibraryCategoryMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateLibraryCategoryMutation, CreateLibraryCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateLibraryCategoryMutation, CreateLibraryCategoryMutationVariables>(CreateLibraryCategoryDocument, options);
      }
export type CreateLibraryCategoryMutationHookResult = ReturnType<typeof useCreateLibraryCategoryMutation>;
export type CreateLibraryCategoryMutationResult = Apollo.MutationResult<CreateLibraryCategoryMutation>;
export type CreateLibraryCategoryMutationOptions = Apollo.BaseMutationOptions<CreateLibraryCategoryMutation, CreateLibraryCategoryMutationVariables>;
export const CreateLibraryColorDocument = gql`
    mutation createLibraryColor($data: LibraryColorCreateInput!) {
  createLibraryColor(data: $data) {
    ...libraryColor
  }
}
    ${LibraryColorFragmentDoc}`;
export type CreateLibraryColorMutationFn = Apollo.MutationFunction<CreateLibraryColorMutation, CreateLibraryColorMutationVariables>;

/**
 * __useCreateLibraryColorMutation__
 *
 * To run a mutation, you first call `useCreateLibraryColorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLibraryColorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLibraryColorMutation, { data, loading, error }] = useCreateLibraryColorMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateLibraryColorMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateLibraryColorMutation, CreateLibraryColorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateLibraryColorMutation, CreateLibraryColorMutationVariables>(CreateLibraryColorDocument, options);
      }
export type CreateLibraryColorMutationHookResult = ReturnType<typeof useCreateLibraryColorMutation>;
export type CreateLibraryColorMutationResult = Apollo.MutationResult<CreateLibraryColorMutation>;
export type CreateLibraryColorMutationOptions = Apollo.BaseMutationOptions<CreateLibraryColorMutation, CreateLibraryColorMutationVariables>;
export const CreateLibraryFileDocument = gql`
    mutation createLibraryFile($data: LibraryFileCreateInput!) {
  createLibraryFile(data: $data) {
    id
    ownerId
    name
    url
    previewUrl
    mimeType
    size
    width
    height
    duration
    bitrate
  }
}
    `;
export type CreateLibraryFileMutationFn = Apollo.MutationFunction<CreateLibraryFileMutation, CreateLibraryFileMutationVariables>;

/**
 * __useCreateLibraryFileMutation__
 *
 * To run a mutation, you first call `useCreateLibraryFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLibraryFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLibraryFileMutation, { data, loading, error }] = useCreateLibraryFileMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateLibraryFileMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateLibraryFileMutation, CreateLibraryFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateLibraryFileMutation, CreateLibraryFileMutationVariables>(CreateLibraryFileDocument, options);
      }
export type CreateLibraryFileMutationHookResult = ReturnType<typeof useCreateLibraryFileMutation>;
export type CreateLibraryFileMutationResult = Apollo.MutationResult<CreateLibraryFileMutation>;
export type CreateLibraryFileMutationOptions = Apollo.BaseMutationOptions<CreateLibraryFileMutation, CreateLibraryFileMutationVariables>;
export const CreateLibraryFontDocument = gql`
    mutation createLibraryFont($data: LibraryFontCreateInput!) {
  createLibraryFont(data: $data) {
    id
    name
    fileId
    categoryId
  }
}
    `;
export type CreateLibraryFontMutationFn = Apollo.MutationFunction<CreateLibraryFontMutation, CreateLibraryFontMutationVariables>;

/**
 * __useCreateLibraryFontMutation__
 *
 * To run a mutation, you first call `useCreateLibraryFontMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLibraryFontMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLibraryFontMutation, { data, loading, error }] = useCreateLibraryFontMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateLibraryFontMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateLibraryFontMutation, CreateLibraryFontMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateLibraryFontMutation, CreateLibraryFontMutationVariables>(CreateLibraryFontDocument, options);
      }
export type CreateLibraryFontMutationHookResult = ReturnType<typeof useCreateLibraryFontMutation>;
export type CreateLibraryFontMutationResult = Apollo.MutationResult<CreateLibraryFontMutation>;
export type CreateLibraryFontMutationOptions = Apollo.BaseMutationOptions<CreateLibraryFontMutation, CreateLibraryFontMutationVariables>;
export const CreateLibraryLogoDocument = gql`
    mutation createLibraryLogo($data: LibraryLogoCreateInput!) {
  createLibraryLogo(data: $data) {
    id
    name
    fileId
    categoryId
  }
}
    `;
export type CreateLibraryLogoMutationFn = Apollo.MutationFunction<CreateLibraryLogoMutation, CreateLibraryLogoMutationVariables>;

/**
 * __useCreateLibraryLogoMutation__
 *
 * To run a mutation, you first call `useCreateLibraryLogoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLibraryLogoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLibraryLogoMutation, { data, loading, error }] = useCreateLibraryLogoMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateLibraryLogoMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateLibraryLogoMutation, CreateLibraryLogoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateLibraryLogoMutation, CreateLibraryLogoMutationVariables>(CreateLibraryLogoDocument, options);
      }
export type CreateLibraryLogoMutationHookResult = ReturnType<typeof useCreateLibraryLogoMutation>;
export type CreateLibraryLogoMutationResult = Apollo.MutationResult<CreateLibraryLogoMutation>;
export type CreateLibraryLogoMutationOptions = Apollo.BaseMutationOptions<CreateLibraryLogoMutation, CreateLibraryLogoMutationVariables>;
export const CreateLibrarySoundDocument = gql`
    mutation createLibrarySound($data: LibrarySoundCreateInput!) {
  createLibrarySound(data: $data) {
    id
    name
    fileId
    categoryId
  }
}
    `;
export type CreateLibrarySoundMutationFn = Apollo.MutationFunction<CreateLibrarySoundMutation, CreateLibrarySoundMutationVariables>;

/**
 * __useCreateLibrarySoundMutation__
 *
 * To run a mutation, you first call `useCreateLibrarySoundMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLibrarySoundMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLibrarySoundMutation, { data, loading, error }] = useCreateLibrarySoundMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateLibrarySoundMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateLibrarySoundMutation, CreateLibrarySoundMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateLibrarySoundMutation, CreateLibrarySoundMutationVariables>(CreateLibrarySoundDocument, options);
      }
export type CreateLibrarySoundMutationHookResult = ReturnType<typeof useCreateLibrarySoundMutation>;
export type CreateLibrarySoundMutationResult = Apollo.MutationResult<CreateLibrarySoundMutation>;
export type CreateLibrarySoundMutationOptions = Apollo.BaseMutationOptions<CreateLibrarySoundMutation, CreateLibrarySoundMutationVariables>;
export const CreateLibraryStickerDocument = gql`
    mutation createLibrarySticker($data: LibraryStickerCreateInput!) {
  createLibrarySticker(data: $data) {
    id
    name
    fileId
    categoryId
  }
}
    `;
export type CreateLibraryStickerMutationFn = Apollo.MutationFunction<CreateLibraryStickerMutation, CreateLibraryStickerMutationVariables>;

/**
 * __useCreateLibraryStickerMutation__
 *
 * To run a mutation, you first call `useCreateLibraryStickerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLibraryStickerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLibraryStickerMutation, { data, loading, error }] = useCreateLibraryStickerMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateLibraryStickerMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateLibraryStickerMutation, CreateLibraryStickerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateLibraryStickerMutation, CreateLibraryStickerMutationVariables>(CreateLibraryStickerDocument, options);
      }
export type CreateLibraryStickerMutationHookResult = ReturnType<typeof useCreateLibraryStickerMutation>;
export type CreateLibraryStickerMutationResult = Apollo.MutationResult<CreateLibraryStickerMutation>;
export type CreateLibraryStickerMutationOptions = Apollo.BaseMutationOptions<CreateLibraryStickerMutation, CreateLibraryStickerMutationVariables>;
export const CreateLibraryTextPresetDocument = gql`
    mutation createLibraryTextPreset($data: LibraryTextPresetCreateInput!) {
  createLibraryTextPreset(data: $data) {
    ...libraryTextPreset
  }
}
    ${LibraryTextPresetFragmentDoc}`;
export type CreateLibraryTextPresetMutationFn = Apollo.MutationFunction<CreateLibraryTextPresetMutation, CreateLibraryTextPresetMutationVariables>;

/**
 * __useCreateLibraryTextPresetMutation__
 *
 * To run a mutation, you first call `useCreateLibraryTextPresetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLibraryTextPresetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLibraryTextPresetMutation, { data, loading, error }] = useCreateLibraryTextPresetMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateLibraryTextPresetMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateLibraryTextPresetMutation, CreateLibraryTextPresetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateLibraryTextPresetMutation, CreateLibraryTextPresetMutationVariables>(CreateLibraryTextPresetDocument, options);
      }
export type CreateLibraryTextPresetMutationHookResult = ReturnType<typeof useCreateLibraryTextPresetMutation>;
export type CreateLibraryTextPresetMutationResult = Apollo.MutationResult<CreateLibraryTextPresetMutation>;
export type CreateLibraryTextPresetMutationOptions = Apollo.BaseMutationOptions<CreateLibraryTextPresetMutation, CreateLibraryTextPresetMutationVariables>;
export const CreateTemplateDocument = gql`
    mutation createTemplate($data: TemplateCreateInput!) {
  createTemplate(data: $data) {
    ...template
  }
}
    ${TemplateFragmentDoc}`;
export type CreateTemplateMutationFn = Apollo.MutationFunction<CreateTemplateMutation, CreateTemplateMutationVariables>;

/**
 * __useCreateTemplateMutation__
 *
 * To run a mutation, you first call `useCreateTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTemplateMutation, { data, loading, error }] = useCreateTemplateMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateTemplateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateTemplateMutation, CreateTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateTemplateMutation, CreateTemplateMutationVariables>(CreateTemplateDocument, options);
      }
export type CreateTemplateMutationHookResult = ReturnType<typeof useCreateTemplateMutation>;
export type CreateTemplateMutationResult = Apollo.MutationResult<CreateTemplateMutation>;
export type CreateTemplateMutationOptions = Apollo.BaseMutationOptions<CreateTemplateMutation, CreateTemplateMutationVariables>;
export const CreateTemplateCategoryDocument = gql`
    mutation createTemplateCategory($data: TemplateCategoryCreateInput!) {
  createTemplateCategory(data: $data) {
    id
    name
  }
}
    `;
export type CreateTemplateCategoryMutationFn = Apollo.MutationFunction<CreateTemplateCategoryMutation, CreateTemplateCategoryMutationVariables>;

/**
 * __useCreateTemplateCategoryMutation__
 *
 * To run a mutation, you first call `useCreateTemplateCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTemplateCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTemplateCategoryMutation, { data, loading, error }] = useCreateTemplateCategoryMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateTemplateCategoryMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateTemplateCategoryMutation, CreateTemplateCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateTemplateCategoryMutation, CreateTemplateCategoryMutationVariables>(CreateTemplateCategoryDocument, options);
      }
export type CreateTemplateCategoryMutationHookResult = ReturnType<typeof useCreateTemplateCategoryMutation>;
export type CreateTemplateCategoryMutationResult = Apollo.MutationResult<CreateTemplateCategoryMutation>;
export type CreateTemplateCategoryMutationOptions = Apollo.BaseMutationOptions<CreateTemplateCategoryMutation, CreateTemplateCategoryMutationVariables>;
export const CreateUserInviteDocument = gql`
    mutation createUserInvite($data: UserInviteCreateInput!) {
  createUserInvite(data: $data) {
    id
  }
}
    `;
export type CreateUserInviteMutationFn = Apollo.MutationFunction<CreateUserInviteMutation, CreateUserInviteMutationVariables>;

/**
 * __useCreateUserInviteMutation__
 *
 * To run a mutation, you first call `useCreateUserInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserInviteMutation, { data, loading, error }] = useCreateUserInviteMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateUserInviteMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateUserInviteMutation, CreateUserInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateUserInviteMutation, CreateUserInviteMutationVariables>(CreateUserInviteDocument, options);
      }
export type CreateUserInviteMutationHookResult = ReturnType<typeof useCreateUserInviteMutation>;
export type CreateUserInviteMutationResult = Apollo.MutationResult<CreateUserInviteMutation>;
export type CreateUserInviteMutationOptions = Apollo.BaseMutationOptions<CreateUserInviteMutation, CreateUserInviteMutationVariables>;
export const CreateUserRoleDocument = gql`
    mutation createUserRole($data: UserRoleCreateInput!) {
  createUserRole(data: $data) {
    id
  }
}
    `;
export type CreateUserRoleMutationFn = Apollo.MutationFunction<CreateUserRoleMutation, CreateUserRoleMutationVariables>;

/**
 * __useCreateUserRoleMutation__
 *
 * To run a mutation, you first call `useCreateUserRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserRoleMutation, { data, loading, error }] = useCreateUserRoleMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateUserRoleMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateUserRoleMutation, CreateUserRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateUserRoleMutation, CreateUserRoleMutationVariables>(CreateUserRoleDocument, options);
      }
export type CreateUserRoleMutationHookResult = ReturnType<typeof useCreateUserRoleMutation>;
export type CreateUserRoleMutationResult = Apollo.MutationResult<CreateUserRoleMutation>;
export type CreateUserRoleMutationOptions = Apollo.BaseMutationOptions<CreateUserRoleMutation, CreateUserRoleMutationVariables>;
export const DeclineUserInviteDocument = gql`
    mutation declineUserInvite($key: String!) {
  declineUserInvite(key: $key) {
    id
  }
}
    `;
export type DeclineUserInviteMutationFn = Apollo.MutationFunction<DeclineUserInviteMutation, DeclineUserInviteMutationVariables>;

/**
 * __useDeclineUserInviteMutation__
 *
 * To run a mutation, you first call `useDeclineUserInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeclineUserInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [declineUserInviteMutation, { data, loading, error }] = useDeclineUserInviteMutation({
 *   variables: {
 *      key: // value for 'key'
 *   },
 * });
 */
export function useDeclineUserInviteMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeclineUserInviteMutation, DeclineUserInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeclineUserInviteMutation, DeclineUserInviteMutationVariables>(DeclineUserInviteDocument, options);
      }
export type DeclineUserInviteMutationHookResult = ReturnType<typeof useDeclineUserInviteMutation>;
export type DeclineUserInviteMutationResult = Apollo.MutationResult<DeclineUserInviteMutation>;
export type DeclineUserInviteMutationOptions = Apollo.BaseMutationOptions<DeclineUserInviteMutation, DeclineUserInviteMutationVariables>;
export const DeleteLibraryBackgroundDocument = gql`
    mutation deleteLibraryBackground($id: Int!) {
  deleteLibraryBackground(id: $id) {
    id
    categoryId
    name
  }
}
    `;
export type DeleteLibraryBackgroundMutationFn = Apollo.MutationFunction<DeleteLibraryBackgroundMutation, DeleteLibraryBackgroundMutationVariables>;

/**
 * __useDeleteLibraryBackgroundMutation__
 *
 * To run a mutation, you first call `useDeleteLibraryBackgroundMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLibraryBackgroundMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLibraryBackgroundMutation, { data, loading, error }] = useDeleteLibraryBackgroundMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteLibraryBackgroundMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteLibraryBackgroundMutation, DeleteLibraryBackgroundMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteLibraryBackgroundMutation, DeleteLibraryBackgroundMutationVariables>(DeleteLibraryBackgroundDocument, options);
      }
export type DeleteLibraryBackgroundMutationHookResult = ReturnType<typeof useDeleteLibraryBackgroundMutation>;
export type DeleteLibraryBackgroundMutationResult = Apollo.MutationResult<DeleteLibraryBackgroundMutation>;
export type DeleteLibraryBackgroundMutationOptions = Apollo.BaseMutationOptions<DeleteLibraryBackgroundMutation, DeleteLibraryBackgroundMutationVariables>;
export const DeleteLibraryCategoryDocument = gql`
    mutation deleteLibraryCategory($id: Int!, $destinationCatgoryId: Int) {
  deleteLibraryCategory(id: $id, destinationCatgoryId: $destinationCatgoryId) {
    id
  }
}
    `;
export type DeleteLibraryCategoryMutationFn = Apollo.MutationFunction<DeleteLibraryCategoryMutation, DeleteLibraryCategoryMutationVariables>;

/**
 * __useDeleteLibraryCategoryMutation__
 *
 * To run a mutation, you first call `useDeleteLibraryCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLibraryCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLibraryCategoryMutation, { data, loading, error }] = useDeleteLibraryCategoryMutation({
 *   variables: {
 *      id: // value for 'id'
 *      destinationCatgoryId: // value for 'destinationCatgoryId'
 *   },
 * });
 */
export function useDeleteLibraryCategoryMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteLibraryCategoryMutation, DeleteLibraryCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteLibraryCategoryMutation, DeleteLibraryCategoryMutationVariables>(DeleteLibraryCategoryDocument, options);
      }
export type DeleteLibraryCategoryMutationHookResult = ReturnType<typeof useDeleteLibraryCategoryMutation>;
export type DeleteLibraryCategoryMutationResult = Apollo.MutationResult<DeleteLibraryCategoryMutation>;
export type DeleteLibraryCategoryMutationOptions = Apollo.BaseMutationOptions<DeleteLibraryCategoryMutation, DeleteLibraryCategoryMutationVariables>;
export const DeleteLibraryColorDocument = gql`
    mutation deleteLibraryColor($id: Int!) {
  deleteLibraryColor(id: $id) {
    ...libraryColor
  }
}
    ${LibraryColorFragmentDoc}`;
export type DeleteLibraryColorMutationFn = Apollo.MutationFunction<DeleteLibraryColorMutation, DeleteLibraryColorMutationVariables>;

/**
 * __useDeleteLibraryColorMutation__
 *
 * To run a mutation, you first call `useDeleteLibraryColorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLibraryColorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLibraryColorMutation, { data, loading, error }] = useDeleteLibraryColorMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteLibraryColorMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteLibraryColorMutation, DeleteLibraryColorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteLibraryColorMutation, DeleteLibraryColorMutationVariables>(DeleteLibraryColorDocument, options);
      }
export type DeleteLibraryColorMutationHookResult = ReturnType<typeof useDeleteLibraryColorMutation>;
export type DeleteLibraryColorMutationResult = Apollo.MutationResult<DeleteLibraryColorMutation>;
export type DeleteLibraryColorMutationOptions = Apollo.BaseMutationOptions<DeleteLibraryColorMutation, DeleteLibraryColorMutationVariables>;
export const DeleteLibraryFontDocument = gql`
    mutation deleteLibraryFont($id: Int!) {
  deleteLibraryFont(id: $id) {
    id
    categoryId
    name
  }
}
    `;
export type DeleteLibraryFontMutationFn = Apollo.MutationFunction<DeleteLibraryFontMutation, DeleteLibraryFontMutationVariables>;

/**
 * __useDeleteLibraryFontMutation__
 *
 * To run a mutation, you first call `useDeleteLibraryFontMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLibraryFontMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLibraryFontMutation, { data, loading, error }] = useDeleteLibraryFontMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteLibraryFontMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteLibraryFontMutation, DeleteLibraryFontMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteLibraryFontMutation, DeleteLibraryFontMutationVariables>(DeleteLibraryFontDocument, options);
      }
export type DeleteLibraryFontMutationHookResult = ReturnType<typeof useDeleteLibraryFontMutation>;
export type DeleteLibraryFontMutationResult = Apollo.MutationResult<DeleteLibraryFontMutation>;
export type DeleteLibraryFontMutationOptions = Apollo.BaseMutationOptions<DeleteLibraryFontMutation, DeleteLibraryFontMutationVariables>;
export const DeleteLibraryLogoDocument = gql`
    mutation deleteLibraryLogo($id: Int!) {
  deleteLibraryLogo(id: $id) {
    id
    categoryId
    name
  }
}
    `;
export type DeleteLibraryLogoMutationFn = Apollo.MutationFunction<DeleteLibraryLogoMutation, DeleteLibraryLogoMutationVariables>;

/**
 * __useDeleteLibraryLogoMutation__
 *
 * To run a mutation, you first call `useDeleteLibraryLogoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLibraryLogoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLibraryLogoMutation, { data, loading, error }] = useDeleteLibraryLogoMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteLibraryLogoMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteLibraryLogoMutation, DeleteLibraryLogoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteLibraryLogoMutation, DeleteLibraryLogoMutationVariables>(DeleteLibraryLogoDocument, options);
      }
export type DeleteLibraryLogoMutationHookResult = ReturnType<typeof useDeleteLibraryLogoMutation>;
export type DeleteLibraryLogoMutationResult = Apollo.MutationResult<DeleteLibraryLogoMutation>;
export type DeleteLibraryLogoMutationOptions = Apollo.BaseMutationOptions<DeleteLibraryLogoMutation, DeleteLibraryLogoMutationVariables>;
export const DeleteLibrarySoundDocument = gql`
    mutation deleteLibrarySound($id: Int!) {
  deleteLibrarySound(id: $id) {
    id
    categoryId
    name
  }
}
    `;
export type DeleteLibrarySoundMutationFn = Apollo.MutationFunction<DeleteLibrarySoundMutation, DeleteLibrarySoundMutationVariables>;

/**
 * __useDeleteLibrarySoundMutation__
 *
 * To run a mutation, you first call `useDeleteLibrarySoundMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLibrarySoundMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLibrarySoundMutation, { data, loading, error }] = useDeleteLibrarySoundMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteLibrarySoundMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteLibrarySoundMutation, DeleteLibrarySoundMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteLibrarySoundMutation, DeleteLibrarySoundMutationVariables>(DeleteLibrarySoundDocument, options);
      }
export type DeleteLibrarySoundMutationHookResult = ReturnType<typeof useDeleteLibrarySoundMutation>;
export type DeleteLibrarySoundMutationResult = Apollo.MutationResult<DeleteLibrarySoundMutation>;
export type DeleteLibrarySoundMutationOptions = Apollo.BaseMutationOptions<DeleteLibrarySoundMutation, DeleteLibrarySoundMutationVariables>;
export const DeleteLibraryStickerDocument = gql`
    mutation deleteLibrarySticker($id: Int!) {
  deleteLibrarySticker(id: $id) {
    id
    categoryId
    name
  }
}
    `;
export type DeleteLibraryStickerMutationFn = Apollo.MutationFunction<DeleteLibraryStickerMutation, DeleteLibraryStickerMutationVariables>;

/**
 * __useDeleteLibraryStickerMutation__
 *
 * To run a mutation, you first call `useDeleteLibraryStickerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLibraryStickerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLibraryStickerMutation, { data, loading, error }] = useDeleteLibraryStickerMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteLibraryStickerMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteLibraryStickerMutation, DeleteLibraryStickerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteLibraryStickerMutation, DeleteLibraryStickerMutationVariables>(DeleteLibraryStickerDocument, options);
      }
export type DeleteLibraryStickerMutationHookResult = ReturnType<typeof useDeleteLibraryStickerMutation>;
export type DeleteLibraryStickerMutationResult = Apollo.MutationResult<DeleteLibraryStickerMutation>;
export type DeleteLibraryStickerMutationOptions = Apollo.BaseMutationOptions<DeleteLibraryStickerMutation, DeleteLibraryStickerMutationVariables>;
export const DeleteLibraryTextPresetDocument = gql`
    mutation deleteLibraryTextPreset($id: Int!) {
  deleteLibraryTextPreset(id: $id) {
    id
  }
}
    `;
export type DeleteLibraryTextPresetMutationFn = Apollo.MutationFunction<DeleteLibraryTextPresetMutation, DeleteLibraryTextPresetMutationVariables>;

/**
 * __useDeleteLibraryTextPresetMutation__
 *
 * To run a mutation, you first call `useDeleteLibraryTextPresetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLibraryTextPresetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLibraryTextPresetMutation, { data, loading, error }] = useDeleteLibraryTextPresetMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteLibraryTextPresetMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteLibraryTextPresetMutation, DeleteLibraryTextPresetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteLibraryTextPresetMutation, DeleteLibraryTextPresetMutationVariables>(DeleteLibraryTextPresetDocument, options);
      }
export type DeleteLibraryTextPresetMutationHookResult = ReturnType<typeof useDeleteLibraryTextPresetMutation>;
export type DeleteLibraryTextPresetMutationResult = Apollo.MutationResult<DeleteLibraryTextPresetMutation>;
export type DeleteLibraryTextPresetMutationOptions = Apollo.BaseMutationOptions<DeleteLibraryTextPresetMutation, DeleteLibraryTextPresetMutationVariables>;
export const DeleteTemplateDocument = gql`
    mutation deleteTemplate($id: Int!) {
  deleteTemplate(id: $id) {
    ...template
  }
}
    ${TemplateFragmentDoc}`;
export type DeleteTemplateMutationFn = Apollo.MutationFunction<DeleteTemplateMutation, DeleteTemplateMutationVariables>;

/**
 * __useDeleteTemplateMutation__
 *
 * To run a mutation, you first call `useDeleteTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTemplateMutation, { data, loading, error }] = useDeleteTemplateMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteTemplateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteTemplateMutation, DeleteTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteTemplateMutation, DeleteTemplateMutationVariables>(DeleteTemplateDocument, options);
      }
export type DeleteTemplateMutationHookResult = ReturnType<typeof useDeleteTemplateMutation>;
export type DeleteTemplateMutationResult = Apollo.MutationResult<DeleteTemplateMutation>;
export type DeleteTemplateMutationOptions = Apollo.BaseMutationOptions<DeleteTemplateMutation, DeleteTemplateMutationVariables>;
export const DeleteTemplateCategoryDocument = gql`
    mutation deleteTemplateCategory($id: Int!) {
  deleteTemplateCategory(id: $id) {
    id
    name
  }
}
    `;
export type DeleteTemplateCategoryMutationFn = Apollo.MutationFunction<DeleteTemplateCategoryMutation, DeleteTemplateCategoryMutationVariables>;

/**
 * __useDeleteTemplateCategoryMutation__
 *
 * To run a mutation, you first call `useDeleteTemplateCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTemplateCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTemplateCategoryMutation, { data, loading, error }] = useDeleteTemplateCategoryMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteTemplateCategoryMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteTemplateCategoryMutation, DeleteTemplateCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteTemplateCategoryMutation, DeleteTemplateCategoryMutationVariables>(DeleteTemplateCategoryDocument, options);
      }
export type DeleteTemplateCategoryMutationHookResult = ReturnType<typeof useDeleteTemplateCategoryMutation>;
export type DeleteTemplateCategoryMutationResult = Apollo.MutationResult<DeleteTemplateCategoryMutation>;
export type DeleteTemplateCategoryMutationOptions = Apollo.BaseMutationOptions<DeleteTemplateCategoryMutation, DeleteTemplateCategoryMutationVariables>;
export const DeleteUserRoleDocument = gql`
    mutation deleteUserRole($id: Int!) {
  deleteUserRole(id: $id) {
    id
  }
}
    `;
export type DeleteUserRoleMutationFn = Apollo.MutationFunction<DeleteUserRoleMutation, DeleteUserRoleMutationVariables>;

/**
 * __useDeleteUserRoleMutation__
 *
 * To run a mutation, you first call `useDeleteUserRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserRoleMutation, { data, loading, error }] = useDeleteUserRoleMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteUserRoleMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteUserRoleMutation, DeleteUserRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteUserRoleMutation, DeleteUserRoleMutationVariables>(DeleteUserRoleDocument, options);
      }
export type DeleteUserRoleMutationHookResult = ReturnType<typeof useDeleteUserRoleMutation>;
export type DeleteUserRoleMutationResult = Apollo.MutationResult<DeleteUserRoleMutation>;
export type DeleteUserRoleMutationOptions = Apollo.BaseMutationOptions<DeleteUserRoleMutation, DeleteUserRoleMutationVariables>;
export const DeleteUserTeamDocument = gql`
    mutation deleteUserTeam($id: Int!) {
  deleteUserTeam(id: $id) {
    id
  }
}
    `;
export type DeleteUserTeamMutationFn = Apollo.MutationFunction<DeleteUserTeamMutation, DeleteUserTeamMutationVariables>;

/**
 * __useDeleteUserTeamMutation__
 *
 * To run a mutation, you first call `useDeleteUserTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserTeamMutation, { data, loading, error }] = useDeleteUserTeamMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteUserTeamMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteUserTeamMutation, DeleteUserTeamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteUserTeamMutation, DeleteUserTeamMutationVariables>(DeleteUserTeamDocument, options);
      }
export type DeleteUserTeamMutationHookResult = ReturnType<typeof useDeleteUserTeamMutation>;
export type DeleteUserTeamMutationResult = Apollo.MutationResult<DeleteUserTeamMutation>;
export type DeleteUserTeamMutationOptions = Apollo.BaseMutationOptions<DeleteUserTeamMutation, DeleteUserTeamMutationVariables>;
export const DeleteUserTeamMemberDocument = gql`
    mutation deleteUserTeamMember($id: Int!) {
  deleteUserTeamMember(id: $id) {
    id
  }
}
    `;
export type DeleteUserTeamMemberMutationFn = Apollo.MutationFunction<DeleteUserTeamMemberMutation, DeleteUserTeamMemberMutationVariables>;

/**
 * __useDeleteUserTeamMemberMutation__
 *
 * To run a mutation, you first call `useDeleteUserTeamMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserTeamMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserTeamMemberMutation, { data, loading, error }] = useDeleteUserTeamMemberMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteUserTeamMemberMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteUserTeamMemberMutation, DeleteUserTeamMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteUserTeamMemberMutation, DeleteUserTeamMemberMutationVariables>(DeleteUserTeamMemberDocument, options);
      }
export type DeleteUserTeamMemberMutationHookResult = ReturnType<typeof useDeleteUserTeamMemberMutation>;
export type DeleteUserTeamMemberMutationResult = Apollo.MutationResult<DeleteUserTeamMemberMutation>;
export type DeleteUserTeamMemberMutationOptions = Apollo.BaseMutationOptions<DeleteUserTeamMemberMutation, DeleteUserTeamMemberMutationVariables>;
export const LoginDocument = gql`
    mutation login($data: LoginInput!) {
  login(data: $data) {
    ...authResponse
  }
}
    ${AuthResponseFragmentDoc}`;
export type LoginMutationFn = Apollo.MutationFunction<LoginMutation, LoginMutationVariables>;

/**
 * __useLoginMutation__
 *
 * To run a mutation, you first call `useLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginMutation, { data, loading, error }] = useLoginMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useLoginMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<LoginMutation, LoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<LoginMutation, LoginMutationVariables>(LoginDocument, options);
      }
export type LoginMutationHookResult = ReturnType<typeof useLoginMutation>;
export type LoginMutationResult = Apollo.MutationResult<LoginMutation>;
export type LoginMutationOptions = Apollo.BaseMutationOptions<LoginMutation, LoginMutationVariables>;
export const RegisterDocument = gql`
    mutation register($data: RegisterInput!) {
  register(data: $data) {
    ...authResponse
  }
}
    ${AuthResponseFragmentDoc}`;
export type RegisterMutationFn = Apollo.MutationFunction<RegisterMutation, RegisterMutationVariables>;

/**
 * __useRegisterMutation__
 *
 * To run a mutation, you first call `useRegisterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerMutation, { data, loading, error }] = useRegisterMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useRegisterMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RegisterMutation, RegisterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RegisterMutation, RegisterMutationVariables>(RegisterDocument, options);
      }
export type RegisterMutationHookResult = ReturnType<typeof useRegisterMutation>;
export type RegisterMutationResult = Apollo.MutationResult<RegisterMutation>;
export type RegisterMutationOptions = Apollo.BaseMutationOptions<RegisterMutation, RegisterMutationVariables>;
export const ResetUserPasswordDocument = gql`
    mutation resetUserPassword($email: String!) {
  resetUserPassword(email: $email)
}
    `;
export type ResetUserPasswordMutationFn = Apollo.MutationFunction<ResetUserPasswordMutation, ResetUserPasswordMutationVariables>;

/**
 * __useResetUserPasswordMutation__
 *
 * To run a mutation, you first call `useResetUserPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetUserPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetUserPasswordMutation, { data, loading, error }] = useResetUserPasswordMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useResetUserPasswordMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ResetUserPasswordMutation, ResetUserPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ResetUserPasswordMutation, ResetUserPasswordMutationVariables>(ResetUserPasswordDocument, options);
      }
export type ResetUserPasswordMutationHookResult = ReturnType<typeof useResetUserPasswordMutation>;
export type ResetUserPasswordMutationResult = Apollo.MutationResult<ResetUserPasswordMutation>;
export type ResetUserPasswordMutationOptions = Apollo.BaseMutationOptions<ResetUserPasswordMutation, ResetUserPasswordMutationVariables>;
export const SortLibraryBackgroundsDocument = gql`
    mutation sortLibraryBackgrounds($data: [SortInput!]!) {
  sortLibraryBackgrounds(data: $data)
}
    `;
export type SortLibraryBackgroundsMutationFn = Apollo.MutationFunction<SortLibraryBackgroundsMutation, SortLibraryBackgroundsMutationVariables>;

/**
 * __useSortLibraryBackgroundsMutation__
 *
 * To run a mutation, you first call `useSortLibraryBackgroundsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSortLibraryBackgroundsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sortLibraryBackgroundsMutation, { data, loading, error }] = useSortLibraryBackgroundsMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useSortLibraryBackgroundsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SortLibraryBackgroundsMutation, SortLibraryBackgroundsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SortLibraryBackgroundsMutation, SortLibraryBackgroundsMutationVariables>(SortLibraryBackgroundsDocument, options);
      }
export type SortLibraryBackgroundsMutationHookResult = ReturnType<typeof useSortLibraryBackgroundsMutation>;
export type SortLibraryBackgroundsMutationResult = Apollo.MutationResult<SortLibraryBackgroundsMutation>;
export type SortLibraryBackgroundsMutationOptions = Apollo.BaseMutationOptions<SortLibraryBackgroundsMutation, SortLibraryBackgroundsMutationVariables>;
export const SortLibraryColorsDocument = gql`
    mutation sortLibraryColors($data: [SortInput!]!) {
  sortLibraryColors(data: $data)
}
    `;
export type SortLibraryColorsMutationFn = Apollo.MutationFunction<SortLibraryColorsMutation, SortLibraryColorsMutationVariables>;

/**
 * __useSortLibraryColorsMutation__
 *
 * To run a mutation, you first call `useSortLibraryColorsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSortLibraryColorsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sortLibraryColorsMutation, { data, loading, error }] = useSortLibraryColorsMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useSortLibraryColorsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SortLibraryColorsMutation, SortLibraryColorsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SortLibraryColorsMutation, SortLibraryColorsMutationVariables>(SortLibraryColorsDocument, options);
      }
export type SortLibraryColorsMutationHookResult = ReturnType<typeof useSortLibraryColorsMutation>;
export type SortLibraryColorsMutationResult = Apollo.MutationResult<SortLibraryColorsMutation>;
export type SortLibraryColorsMutationOptions = Apollo.BaseMutationOptions<SortLibraryColorsMutation, SortLibraryColorsMutationVariables>;
export const SortLibraryFontsDocument = gql`
    mutation sortLibraryFonts($data: [SortInput!]!) {
  sortLibraryFonts(data: $data)
}
    `;
export type SortLibraryFontsMutationFn = Apollo.MutationFunction<SortLibraryFontsMutation, SortLibraryFontsMutationVariables>;

/**
 * __useSortLibraryFontsMutation__
 *
 * To run a mutation, you first call `useSortLibraryFontsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSortLibraryFontsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sortLibraryFontsMutation, { data, loading, error }] = useSortLibraryFontsMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useSortLibraryFontsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SortLibraryFontsMutation, SortLibraryFontsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SortLibraryFontsMutation, SortLibraryFontsMutationVariables>(SortLibraryFontsDocument, options);
      }
export type SortLibraryFontsMutationHookResult = ReturnType<typeof useSortLibraryFontsMutation>;
export type SortLibraryFontsMutationResult = Apollo.MutationResult<SortLibraryFontsMutation>;
export type SortLibraryFontsMutationOptions = Apollo.BaseMutationOptions<SortLibraryFontsMutation, SortLibraryFontsMutationVariables>;
export const SortLibraryLogosDocument = gql`
    mutation sortLibraryLogos($data: [SortInput!]!) {
  sortLibraryLogos(data: $data)
}
    `;
export type SortLibraryLogosMutationFn = Apollo.MutationFunction<SortLibraryLogosMutation, SortLibraryLogosMutationVariables>;

/**
 * __useSortLibraryLogosMutation__
 *
 * To run a mutation, you first call `useSortLibraryLogosMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSortLibraryLogosMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sortLibraryLogosMutation, { data, loading, error }] = useSortLibraryLogosMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useSortLibraryLogosMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SortLibraryLogosMutation, SortLibraryLogosMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SortLibraryLogosMutation, SortLibraryLogosMutationVariables>(SortLibraryLogosDocument, options);
      }
export type SortLibraryLogosMutationHookResult = ReturnType<typeof useSortLibraryLogosMutation>;
export type SortLibraryLogosMutationResult = Apollo.MutationResult<SortLibraryLogosMutation>;
export type SortLibraryLogosMutationOptions = Apollo.BaseMutationOptions<SortLibraryLogosMutation, SortLibraryLogosMutationVariables>;
export const SortLibrarySoundsDocument = gql`
    mutation sortLibrarySounds($data: [SortInput!]!) {
  sortLibrarySounds(data: $data)
}
    `;
export type SortLibrarySoundsMutationFn = Apollo.MutationFunction<SortLibrarySoundsMutation, SortLibrarySoundsMutationVariables>;

/**
 * __useSortLibrarySoundsMutation__
 *
 * To run a mutation, you first call `useSortLibrarySoundsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSortLibrarySoundsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sortLibrarySoundsMutation, { data, loading, error }] = useSortLibrarySoundsMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useSortLibrarySoundsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SortLibrarySoundsMutation, SortLibrarySoundsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SortLibrarySoundsMutation, SortLibrarySoundsMutationVariables>(SortLibrarySoundsDocument, options);
      }
export type SortLibrarySoundsMutationHookResult = ReturnType<typeof useSortLibrarySoundsMutation>;
export type SortLibrarySoundsMutationResult = Apollo.MutationResult<SortLibrarySoundsMutation>;
export type SortLibrarySoundsMutationOptions = Apollo.BaseMutationOptions<SortLibrarySoundsMutation, SortLibrarySoundsMutationVariables>;
export const SortLibraryStickersDocument = gql`
    mutation sortLibraryStickers($data: [SortInput!]!) {
  sortLibraryStickers(data: $data)
}
    `;
export type SortLibraryStickersMutationFn = Apollo.MutationFunction<SortLibraryStickersMutation, SortLibraryStickersMutationVariables>;

/**
 * __useSortLibraryStickersMutation__
 *
 * To run a mutation, you first call `useSortLibraryStickersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSortLibraryStickersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sortLibraryStickersMutation, { data, loading, error }] = useSortLibraryStickersMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useSortLibraryStickersMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SortLibraryStickersMutation, SortLibraryStickersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SortLibraryStickersMutation, SortLibraryStickersMutationVariables>(SortLibraryStickersDocument, options);
      }
export type SortLibraryStickersMutationHookResult = ReturnType<typeof useSortLibraryStickersMutation>;
export type SortLibraryStickersMutationResult = Apollo.MutationResult<SortLibraryStickersMutation>;
export type SortLibraryStickersMutationOptions = Apollo.BaseMutationOptions<SortLibraryStickersMutation, SortLibraryStickersMutationVariables>;
export const SortLibraryTextPresetsDocument = gql`
    mutation sortLibraryTextPresets($data: [SortInput!]!) {
  sortLibraryTextPresets(data: $data)
}
    `;
export type SortLibraryTextPresetsMutationFn = Apollo.MutationFunction<SortLibraryTextPresetsMutation, SortLibraryTextPresetsMutationVariables>;

/**
 * __useSortLibraryTextPresetsMutation__
 *
 * To run a mutation, you first call `useSortLibraryTextPresetsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSortLibraryTextPresetsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sortLibraryTextPresetsMutation, { data, loading, error }] = useSortLibraryTextPresetsMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useSortLibraryTextPresetsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SortLibraryTextPresetsMutation, SortLibraryTextPresetsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SortLibraryTextPresetsMutation, SortLibraryTextPresetsMutationVariables>(SortLibraryTextPresetsDocument, options);
      }
export type SortLibraryTextPresetsMutationHookResult = ReturnType<typeof useSortLibraryTextPresetsMutation>;
export type SortLibraryTextPresetsMutationResult = Apollo.MutationResult<SortLibraryTextPresetsMutation>;
export type SortLibraryTextPresetsMutationOptions = Apollo.BaseMutationOptions<SortLibraryTextPresetsMutation, SortLibraryTextPresetsMutationVariables>;
export const SortTemplateCategoriesDocument = gql`
    mutation sortTemplateCategories($data: [SortInput!]!) {
  sortTemplateCategories(data: $data)
}
    `;
export type SortTemplateCategoriesMutationFn = Apollo.MutationFunction<SortTemplateCategoriesMutation, SortTemplateCategoriesMutationVariables>;

/**
 * __useSortTemplateCategoriesMutation__
 *
 * To run a mutation, you first call `useSortTemplateCategoriesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSortTemplateCategoriesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sortTemplateCategoriesMutation, { data, loading, error }] = useSortTemplateCategoriesMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useSortTemplateCategoriesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SortTemplateCategoriesMutation, SortTemplateCategoriesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SortTemplateCategoriesMutation, SortTemplateCategoriesMutationVariables>(SortTemplateCategoriesDocument, options);
      }
export type SortTemplateCategoriesMutationHookResult = ReturnType<typeof useSortTemplateCategoriesMutation>;
export type SortTemplateCategoriesMutationResult = Apollo.MutationResult<SortTemplateCategoriesMutation>;
export type SortTemplateCategoriesMutationOptions = Apollo.BaseMutationOptions<SortTemplateCategoriesMutation, SortTemplateCategoriesMutationVariables>;
export const SortTemplatesDocument = gql`
    mutation sortTemplates($data: [SortInput!]!) {
  sortTemplates(data: $data)
}
    `;
export type SortTemplatesMutationFn = Apollo.MutationFunction<SortTemplatesMutation, SortTemplatesMutationVariables>;

/**
 * __useSortTemplatesMutation__
 *
 * To run a mutation, you first call `useSortTemplatesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSortTemplatesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sortTemplatesMutation, { data, loading, error }] = useSortTemplatesMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useSortTemplatesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SortTemplatesMutation, SortTemplatesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SortTemplatesMutation, SortTemplatesMutationVariables>(SortTemplatesDocument, options);
      }
export type SortTemplatesMutationHookResult = ReturnType<typeof useSortTemplatesMutation>;
export type SortTemplatesMutationResult = Apollo.MutationResult<SortTemplatesMutation>;
export type SortTemplatesMutationOptions = Apollo.BaseMutationOptions<SortTemplatesMutation, SortTemplatesMutationVariables>;
export const UpdateLibraryCategoryDocument = gql`
    mutation updateLibraryCategory($id: Int!, $data: LibraryCategoryUpdateInput!) {
  updateLibraryCategory(id: $id, data: $data) {
    ...libraryCategory
  }
}
    ${LibraryCategoryFragmentDoc}`;
export type UpdateLibraryCategoryMutationFn = Apollo.MutationFunction<UpdateLibraryCategoryMutation, UpdateLibraryCategoryMutationVariables>;

/**
 * __useUpdateLibraryCategoryMutation__
 *
 * To run a mutation, you first call `useUpdateLibraryCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLibraryCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLibraryCategoryMutation, { data, loading, error }] = useUpdateLibraryCategoryMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateLibraryCategoryMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateLibraryCategoryMutation, UpdateLibraryCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateLibraryCategoryMutation, UpdateLibraryCategoryMutationVariables>(UpdateLibraryCategoryDocument, options);
      }
export type UpdateLibraryCategoryMutationHookResult = ReturnType<typeof useUpdateLibraryCategoryMutation>;
export type UpdateLibraryCategoryMutationResult = Apollo.MutationResult<UpdateLibraryCategoryMutation>;
export type UpdateLibraryCategoryMutationOptions = Apollo.BaseMutationOptions<UpdateLibraryCategoryMutation, UpdateLibraryCategoryMutationVariables>;
export const UpdateLibraryLogoDocument = gql`
    mutation updateLibraryLogo($id: Int!, $data: LibraryLogoUpdateInput!) {
  updateLibraryLogo(id: $id, data: $data) {
    ...libraryLogo
  }
}
    ${LibraryLogoFragmentDoc}`;
export type UpdateLibraryLogoMutationFn = Apollo.MutationFunction<UpdateLibraryLogoMutation, UpdateLibraryLogoMutationVariables>;

/**
 * __useUpdateLibraryLogoMutation__
 *
 * To run a mutation, you first call `useUpdateLibraryLogoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLibraryLogoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLibraryLogoMutation, { data, loading, error }] = useUpdateLibraryLogoMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateLibraryLogoMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateLibraryLogoMutation, UpdateLibraryLogoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateLibraryLogoMutation, UpdateLibraryLogoMutationVariables>(UpdateLibraryLogoDocument, options);
      }
export type UpdateLibraryLogoMutationHookResult = ReturnType<typeof useUpdateLibraryLogoMutation>;
export type UpdateLibraryLogoMutationResult = Apollo.MutationResult<UpdateLibraryLogoMutation>;
export type UpdateLibraryLogoMutationOptions = Apollo.BaseMutationOptions<UpdateLibraryLogoMutation, UpdateLibraryLogoMutationVariables>;
export const UpdateLibraryStickerDocument = gql`
    mutation updateLibrarySticker($id: Int!, $data: LibraryStickerUpdateInput!) {
  updateLibrarySticker(id: $id, data: $data) {
    ...librarySticker
  }
}
    ${LibraryStickerFragmentDoc}`;
export type UpdateLibraryStickerMutationFn = Apollo.MutationFunction<UpdateLibraryStickerMutation, UpdateLibraryStickerMutationVariables>;

/**
 * __useUpdateLibraryStickerMutation__
 *
 * To run a mutation, you first call `useUpdateLibraryStickerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLibraryStickerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLibraryStickerMutation, { data, loading, error }] = useUpdateLibraryStickerMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateLibraryStickerMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateLibraryStickerMutation, UpdateLibraryStickerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateLibraryStickerMutation, UpdateLibraryStickerMutationVariables>(UpdateLibraryStickerDocument, options);
      }
export type UpdateLibraryStickerMutationHookResult = ReturnType<typeof useUpdateLibraryStickerMutation>;
export type UpdateLibraryStickerMutationResult = Apollo.MutationResult<UpdateLibraryStickerMutation>;
export type UpdateLibraryStickerMutationOptions = Apollo.BaseMutationOptions<UpdateLibraryStickerMutation, UpdateLibraryStickerMutationVariables>;
export const UpdateLibraryTextPresetDocument = gql`
    mutation updateLibraryTextPreset($id: Int!, $data: LibraryTextPresetUpdateInput!) {
  updateLibraryTextPreset(id: $id, data: $data) {
    ...libraryTextPreset
  }
}
    ${LibraryTextPresetFragmentDoc}`;
export type UpdateLibraryTextPresetMutationFn = Apollo.MutationFunction<UpdateLibraryTextPresetMutation, UpdateLibraryTextPresetMutationVariables>;

/**
 * __useUpdateLibraryTextPresetMutation__
 *
 * To run a mutation, you first call `useUpdateLibraryTextPresetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLibraryTextPresetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLibraryTextPresetMutation, { data, loading, error }] = useUpdateLibraryTextPresetMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateLibraryTextPresetMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateLibraryTextPresetMutation, UpdateLibraryTextPresetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateLibraryTextPresetMutation, UpdateLibraryTextPresetMutationVariables>(UpdateLibraryTextPresetDocument, options);
      }
export type UpdateLibraryTextPresetMutationHookResult = ReturnType<typeof useUpdateLibraryTextPresetMutation>;
export type UpdateLibraryTextPresetMutationResult = Apollo.MutationResult<UpdateLibraryTextPresetMutation>;
export type UpdateLibraryTextPresetMutationOptions = Apollo.BaseMutationOptions<UpdateLibraryTextPresetMutation, UpdateLibraryTextPresetMutationVariables>;
export const UpdateTemplateDocument = gql`
    mutation updateTemplate($id: Int!, $data: TemplateUpdateInput!) {
  updateTemplate(id: $id, data: $data) {
    ...template
  }
}
    ${TemplateFragmentDoc}`;
export type UpdateTemplateMutationFn = Apollo.MutationFunction<UpdateTemplateMutation, UpdateTemplateMutationVariables>;

/**
 * __useUpdateTemplateMutation__
 *
 * To run a mutation, you first call `useUpdateTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTemplateMutation, { data, loading, error }] = useUpdateTemplateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateTemplateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateTemplateMutation, UpdateTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateTemplateMutation, UpdateTemplateMutationVariables>(UpdateTemplateDocument, options);
      }
export type UpdateTemplateMutationHookResult = ReturnType<typeof useUpdateTemplateMutation>;
export type UpdateTemplateMutationResult = Apollo.MutationResult<UpdateTemplateMutation>;
export type UpdateTemplateMutationOptions = Apollo.BaseMutationOptions<UpdateTemplateMutation, UpdateTemplateMutationVariables>;
export const UpdateTemplateCategoryDocument = gql`
    mutation updateTemplateCategory($id: Int!, $data: TemplateCategoryUpdateInput!) {
  updateTemplateCategory(id: $id, data: $data) {
    id
    name
  }
}
    `;
export type UpdateTemplateCategoryMutationFn = Apollo.MutationFunction<UpdateTemplateCategoryMutation, UpdateTemplateCategoryMutationVariables>;

/**
 * __useUpdateTemplateCategoryMutation__
 *
 * To run a mutation, you first call `useUpdateTemplateCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTemplateCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTemplateCategoryMutation, { data, loading, error }] = useUpdateTemplateCategoryMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateTemplateCategoryMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateTemplateCategoryMutation, UpdateTemplateCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateTemplateCategoryMutation, UpdateTemplateCategoryMutationVariables>(UpdateTemplateCategoryDocument, options);
      }
export type UpdateTemplateCategoryMutationHookResult = ReturnType<typeof useUpdateTemplateCategoryMutation>;
export type UpdateTemplateCategoryMutationResult = Apollo.MutationResult<UpdateTemplateCategoryMutation>;
export type UpdateTemplateCategoryMutationOptions = Apollo.BaseMutationOptions<UpdateTemplateCategoryMutation, UpdateTemplateCategoryMutationVariables>;
export const UpdateUserProfileDocument = gql`
    mutation updateUserProfile($data: UpdateUserProfileInput!) {
  updateUserProfile(data: $data) {
    id
    firstName
    lastName
    avatar
  }
}
    `;
export type UpdateUserProfileMutationFn = Apollo.MutationFunction<UpdateUserProfileMutation, UpdateUserProfileMutationVariables>;

/**
 * __useUpdateUserProfileMutation__
 *
 * To run a mutation, you first call `useUpdateUserProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserProfileMutation, { data, loading, error }] = useUpdateUserProfileMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateUserProfileMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateUserProfileMutation, UpdateUserProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateUserProfileMutation, UpdateUserProfileMutationVariables>(UpdateUserProfileDocument, options);
      }
export type UpdateUserProfileMutationHookResult = ReturnType<typeof useUpdateUserProfileMutation>;
export type UpdateUserProfileMutationResult = Apollo.MutationResult<UpdateUserProfileMutation>;
export type UpdateUserProfileMutationOptions = Apollo.BaseMutationOptions<UpdateUserProfileMutation, UpdateUserProfileMutationVariables>;
export const UpdateUserRoleDocument = gql`
    mutation updateUserRole($id: Int!, $data: UserRoleUpdateInput!) {
  updateUserRole(id: $id, data: $data) {
    id
  }
}
    `;
export type UpdateUserRoleMutationFn = Apollo.MutationFunction<UpdateUserRoleMutation, UpdateUserRoleMutationVariables>;

/**
 * __useUpdateUserRoleMutation__
 *
 * To run a mutation, you first call `useUpdateUserRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserRoleMutation, { data, loading, error }] = useUpdateUserRoleMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateUserRoleMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateUserRoleMutation, UpdateUserRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateUserRoleMutation, UpdateUserRoleMutationVariables>(UpdateUserRoleDocument, options);
      }
export type UpdateUserRoleMutationHookResult = ReturnType<typeof useUpdateUserRoleMutation>;
export type UpdateUserRoleMutationResult = Apollo.MutationResult<UpdateUserRoleMutation>;
export type UpdateUserRoleMutationOptions = Apollo.BaseMutationOptions<UpdateUserRoleMutation, UpdateUserRoleMutationVariables>;
export const UpdateUserTeamMemberDocument = gql`
    mutation updateUserTeamMember($id: Int!, $data: UserTeamMemberUpdateInput!) {
  updateUserTeamMember(id: $id, data: $data) {
    id
    roleId
  }
}
    `;
export type UpdateUserTeamMemberMutationFn = Apollo.MutationFunction<UpdateUserTeamMemberMutation, UpdateUserTeamMemberMutationVariables>;

/**
 * __useUpdateUserTeamMemberMutation__
 *
 * To run a mutation, you first call `useUpdateUserTeamMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserTeamMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserTeamMemberMutation, { data, loading, error }] = useUpdateUserTeamMemberMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateUserTeamMemberMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateUserTeamMemberMutation, UpdateUserTeamMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateUserTeamMemberMutation, UpdateUserTeamMemberMutationVariables>(UpdateUserTeamMemberDocument, options);
      }
export type UpdateUserTeamMemberMutationHookResult = ReturnType<typeof useUpdateUserTeamMemberMutation>;
export type UpdateUserTeamMemberMutationResult = Apollo.MutationResult<UpdateUserTeamMemberMutation>;
export type UpdateUserTeamMemberMutationOptions = Apollo.BaseMutationOptions<UpdateUserTeamMemberMutation, UpdateUserTeamMemberMutationVariables>;
export const VerifyUserEmailDocument = gql`
    mutation verifyUserEmail($key: String!) {
  verifyUserEmail(key: $key) {
    id
  }
}
    `;
export type VerifyUserEmailMutationFn = Apollo.MutationFunction<VerifyUserEmailMutation, VerifyUserEmailMutationVariables>;

/**
 * __useVerifyUserEmailMutation__
 *
 * To run a mutation, you first call `useVerifyUserEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyUserEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyUserEmailMutation, { data, loading, error }] = useVerifyUserEmailMutation({
 *   variables: {
 *      key: // value for 'key'
 *   },
 * });
 */
export function useVerifyUserEmailMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<VerifyUserEmailMutation, VerifyUserEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<VerifyUserEmailMutation, VerifyUserEmailMutationVariables>(VerifyUserEmailDocument, options);
      }
export type VerifyUserEmailMutationHookResult = ReturnType<typeof useVerifyUserEmailMutation>;
export type VerifyUserEmailMutationResult = Apollo.MutationResult<VerifyUserEmailMutation>;
export type VerifyUserEmailMutationOptions = Apollo.BaseMutationOptions<VerifyUserEmailMutation, VerifyUserEmailMutationVariables>;
export const AllLibraryBackgroundsDocument = gql`
    query allLibraryBackgrounds($query: DefaultQueryInput) {
  allLibraryBackgrounds(query: $query) {
    total
    edges {
      ...libraryBackground
    }
  }
}
    ${LibraryBackgroundFragmentDoc}`;

/**
 * __useAllLibraryBackgroundsQuery__
 *
 * To run a query within a React component, call `useAllLibraryBackgroundsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllLibraryBackgroundsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllLibraryBackgroundsQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useAllLibraryBackgroundsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AllLibraryBackgroundsQuery, AllLibraryBackgroundsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AllLibraryBackgroundsQuery, AllLibraryBackgroundsQueryVariables>(AllLibraryBackgroundsDocument, options);
      }
export function useAllLibraryBackgroundsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AllLibraryBackgroundsQuery, AllLibraryBackgroundsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AllLibraryBackgroundsQuery, AllLibraryBackgroundsQueryVariables>(AllLibraryBackgroundsDocument, options);
        }
export type AllLibraryBackgroundsQueryHookResult = ReturnType<typeof useAllLibraryBackgroundsQuery>;
export type AllLibraryBackgroundsLazyQueryHookResult = ReturnType<typeof useAllLibraryBackgroundsLazyQuery>;
export type AllLibraryBackgroundsQueryResult = Apollo.QueryResult<AllLibraryBackgroundsQuery, AllLibraryBackgroundsQueryVariables>;
export const AllLibraryCategoriesDocument = gql`
    query allLibraryCategories($query: DefaultQueryInput) {
  allLibraryCategories(query: $query) {
    total
    edges {
      ...libraryCategory
    }
  }
}
    ${LibraryCategoryFragmentDoc}`;

/**
 * __useAllLibraryCategoriesQuery__
 *
 * To run a query within a React component, call `useAllLibraryCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllLibraryCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllLibraryCategoriesQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useAllLibraryCategoriesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AllLibraryCategoriesQuery, AllLibraryCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AllLibraryCategoriesQuery, AllLibraryCategoriesQueryVariables>(AllLibraryCategoriesDocument, options);
      }
export function useAllLibraryCategoriesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AllLibraryCategoriesQuery, AllLibraryCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AllLibraryCategoriesQuery, AllLibraryCategoriesQueryVariables>(AllLibraryCategoriesDocument, options);
        }
export type AllLibraryCategoriesQueryHookResult = ReturnType<typeof useAllLibraryCategoriesQuery>;
export type AllLibraryCategoriesLazyQueryHookResult = ReturnType<typeof useAllLibraryCategoriesLazyQuery>;
export type AllLibraryCategoriesQueryResult = Apollo.QueryResult<AllLibraryCategoriesQuery, AllLibraryCategoriesQueryVariables>;
export const AllLibraryColorsDocument = gql`
    query allLibraryColors($query: DefaultQueryInput) {
  allLibraryColors(query: $query) {
    total
    edges {
      ...libraryColor
    }
  }
}
    ${LibraryColorFragmentDoc}`;

/**
 * __useAllLibraryColorsQuery__
 *
 * To run a query within a React component, call `useAllLibraryColorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllLibraryColorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllLibraryColorsQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useAllLibraryColorsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AllLibraryColorsQuery, AllLibraryColorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AllLibraryColorsQuery, AllLibraryColorsQueryVariables>(AllLibraryColorsDocument, options);
      }
export function useAllLibraryColorsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AllLibraryColorsQuery, AllLibraryColorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AllLibraryColorsQuery, AllLibraryColorsQueryVariables>(AllLibraryColorsDocument, options);
        }
export type AllLibraryColorsQueryHookResult = ReturnType<typeof useAllLibraryColorsQuery>;
export type AllLibraryColorsLazyQueryHookResult = ReturnType<typeof useAllLibraryColorsLazyQuery>;
export type AllLibraryColorsQueryResult = Apollo.QueryResult<AllLibraryColorsQuery, AllLibraryColorsQueryVariables>;
export const AllLibraryFontsDocument = gql`
    query allLibraryFonts($query: DefaultQueryInput) {
  allLibraryFonts(query: $query) {
    total
    edges {
      ...libraryFont
    }
  }
}
    ${LibraryFontFragmentDoc}`;

/**
 * __useAllLibraryFontsQuery__
 *
 * To run a query within a React component, call `useAllLibraryFontsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllLibraryFontsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllLibraryFontsQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useAllLibraryFontsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AllLibraryFontsQuery, AllLibraryFontsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AllLibraryFontsQuery, AllLibraryFontsQueryVariables>(AllLibraryFontsDocument, options);
      }
export function useAllLibraryFontsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AllLibraryFontsQuery, AllLibraryFontsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AllLibraryFontsQuery, AllLibraryFontsQueryVariables>(AllLibraryFontsDocument, options);
        }
export type AllLibraryFontsQueryHookResult = ReturnType<typeof useAllLibraryFontsQuery>;
export type AllLibraryFontsLazyQueryHookResult = ReturnType<typeof useAllLibraryFontsLazyQuery>;
export type AllLibraryFontsQueryResult = Apollo.QueryResult<AllLibraryFontsQuery, AllLibraryFontsQueryVariables>;
export const AllLibraryFontsFlatDocument = gql`
    query allLibraryFontsFlat($query: DefaultQueryInput) {
  allLibraryFonts(query: $query) {
    total
    edges {
      ...libraryFontFlat
    }
  }
}
    ${LibraryFontFlatFragmentDoc}`;

/**
 * __useAllLibraryFontsFlatQuery__
 *
 * To run a query within a React component, call `useAllLibraryFontsFlatQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllLibraryFontsFlatQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllLibraryFontsFlatQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useAllLibraryFontsFlatQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AllLibraryFontsFlatQuery, AllLibraryFontsFlatQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AllLibraryFontsFlatQuery, AllLibraryFontsFlatQueryVariables>(AllLibraryFontsFlatDocument, options);
      }
export function useAllLibraryFontsFlatLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AllLibraryFontsFlatQuery, AllLibraryFontsFlatQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AllLibraryFontsFlatQuery, AllLibraryFontsFlatQueryVariables>(AllLibraryFontsFlatDocument, options);
        }
export type AllLibraryFontsFlatQueryHookResult = ReturnType<typeof useAllLibraryFontsFlatQuery>;
export type AllLibraryFontsFlatLazyQueryHookResult = ReturnType<typeof useAllLibraryFontsFlatLazyQuery>;
export type AllLibraryFontsFlatQueryResult = Apollo.QueryResult<AllLibraryFontsFlatQuery, AllLibraryFontsFlatQueryVariables>;
export const AllLibraryLogosDocument = gql`
    query allLibraryLogos($query: DefaultQueryInput) {
  allLibraryLogos(query: $query) {
    total
    edges {
      ...libraryLogo
    }
  }
}
    ${LibraryLogoFragmentDoc}`;

/**
 * __useAllLibraryLogosQuery__
 *
 * To run a query within a React component, call `useAllLibraryLogosQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllLibraryLogosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllLibraryLogosQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useAllLibraryLogosQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AllLibraryLogosQuery, AllLibraryLogosQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AllLibraryLogosQuery, AllLibraryLogosQueryVariables>(AllLibraryLogosDocument, options);
      }
export function useAllLibraryLogosLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AllLibraryLogosQuery, AllLibraryLogosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AllLibraryLogosQuery, AllLibraryLogosQueryVariables>(AllLibraryLogosDocument, options);
        }
export type AllLibraryLogosQueryHookResult = ReturnType<typeof useAllLibraryLogosQuery>;
export type AllLibraryLogosLazyQueryHookResult = ReturnType<typeof useAllLibraryLogosLazyQuery>;
export type AllLibraryLogosQueryResult = Apollo.QueryResult<AllLibraryLogosQuery, AllLibraryLogosQueryVariables>;
export const AllLibrarySoundsDocument = gql`
    query allLibrarySounds($query: DefaultQueryInput) {
  allLibrarySounds(query: $query) {
    total
    edges {
      ...librarySound
    }
  }
}
    ${LibrarySoundFragmentDoc}`;

/**
 * __useAllLibrarySoundsQuery__
 *
 * To run a query within a React component, call `useAllLibrarySoundsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllLibrarySoundsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllLibrarySoundsQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useAllLibrarySoundsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AllLibrarySoundsQuery, AllLibrarySoundsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AllLibrarySoundsQuery, AllLibrarySoundsQueryVariables>(AllLibrarySoundsDocument, options);
      }
export function useAllLibrarySoundsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AllLibrarySoundsQuery, AllLibrarySoundsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AllLibrarySoundsQuery, AllLibrarySoundsQueryVariables>(AllLibrarySoundsDocument, options);
        }
export type AllLibrarySoundsQueryHookResult = ReturnType<typeof useAllLibrarySoundsQuery>;
export type AllLibrarySoundsLazyQueryHookResult = ReturnType<typeof useAllLibrarySoundsLazyQuery>;
export type AllLibrarySoundsQueryResult = Apollo.QueryResult<AllLibrarySoundsQuery, AllLibrarySoundsQueryVariables>;
export const AllLibraryStickersDocument = gql`
    query allLibraryStickers($query: DefaultQueryInput) {
  allLibraryStickers(query: $query) {
    total
    edges {
      ...librarySticker
    }
  }
}
    ${LibraryStickerFragmentDoc}`;

/**
 * __useAllLibraryStickersQuery__
 *
 * To run a query within a React component, call `useAllLibraryStickersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllLibraryStickersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllLibraryStickersQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useAllLibraryStickersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AllLibraryStickersQuery, AllLibraryStickersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AllLibraryStickersQuery, AllLibraryStickersQueryVariables>(AllLibraryStickersDocument, options);
      }
export function useAllLibraryStickersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AllLibraryStickersQuery, AllLibraryStickersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AllLibraryStickersQuery, AllLibraryStickersQueryVariables>(AllLibraryStickersDocument, options);
        }
export type AllLibraryStickersQueryHookResult = ReturnType<typeof useAllLibraryStickersQuery>;
export type AllLibraryStickersLazyQueryHookResult = ReturnType<typeof useAllLibraryStickersLazyQuery>;
export type AllLibraryStickersQueryResult = Apollo.QueryResult<AllLibraryStickersQuery, AllLibraryStickersQueryVariables>;
export const AllLibraryTextPresetsDocument = gql`
    query allLibraryTextPresets($query: DefaultQueryInput) {
  allLibraryTextPresets(query: $query) {
    ...libraryTextPresetConnection
  }
}
    ${LibraryTextPresetConnectionFragmentDoc}`;

/**
 * __useAllLibraryTextPresetsQuery__
 *
 * To run a query within a React component, call `useAllLibraryTextPresetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllLibraryTextPresetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllLibraryTextPresetsQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useAllLibraryTextPresetsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AllLibraryTextPresetsQuery, AllLibraryTextPresetsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AllLibraryTextPresetsQuery, AllLibraryTextPresetsQueryVariables>(AllLibraryTextPresetsDocument, options);
      }
export function useAllLibraryTextPresetsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AllLibraryTextPresetsQuery, AllLibraryTextPresetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AllLibraryTextPresetsQuery, AllLibraryTextPresetsQueryVariables>(AllLibraryTextPresetsDocument, options);
        }
export type AllLibraryTextPresetsQueryHookResult = ReturnType<typeof useAllLibraryTextPresetsQuery>;
export type AllLibraryTextPresetsLazyQueryHookResult = ReturnType<typeof useAllLibraryTextPresetsLazyQuery>;
export type AllLibraryTextPresetsQueryResult = Apollo.QueryResult<AllLibraryTextPresetsQuery, AllLibraryTextPresetsQueryVariables>;
export const AllLibraryTextPresetsFlatDocument = gql`
    query allLibraryTextPresetsFlat($query: DefaultQueryInput) {
  allLibraryTextPresets(query: $query) {
    ...libraryTextPresetFlatConnection
  }
}
    ${LibraryTextPresetFlatConnectionFragmentDoc}`;

/**
 * __useAllLibraryTextPresetsFlatQuery__
 *
 * To run a query within a React component, call `useAllLibraryTextPresetsFlatQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllLibraryTextPresetsFlatQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllLibraryTextPresetsFlatQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useAllLibraryTextPresetsFlatQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AllLibraryTextPresetsFlatQuery, AllLibraryTextPresetsFlatQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AllLibraryTextPresetsFlatQuery, AllLibraryTextPresetsFlatQueryVariables>(AllLibraryTextPresetsFlatDocument, options);
      }
export function useAllLibraryTextPresetsFlatLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AllLibraryTextPresetsFlatQuery, AllLibraryTextPresetsFlatQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AllLibraryTextPresetsFlatQuery, AllLibraryTextPresetsFlatQueryVariables>(AllLibraryTextPresetsFlatDocument, options);
        }
export type AllLibraryTextPresetsFlatQueryHookResult = ReturnType<typeof useAllLibraryTextPresetsFlatQuery>;
export type AllLibraryTextPresetsFlatLazyQueryHookResult = ReturnType<typeof useAllLibraryTextPresetsFlatLazyQuery>;
export type AllLibraryTextPresetsFlatQueryResult = Apollo.QueryResult<AllLibraryTextPresetsFlatQuery, AllLibraryTextPresetsFlatQueryVariables>;
export const AllMyUserTiersDocument = gql`
    query allMyUserTiers($query: DefaultQueryInput) {
  allMyUserTiers(query: $query) {
    ...userUserTierConnection
  }
}
    ${UserUserTierConnectionFragmentDoc}`;

/**
 * __useAllMyUserTiersQuery__
 *
 * To run a query within a React component, call `useAllMyUserTiersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllMyUserTiersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllMyUserTiersQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useAllMyUserTiersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AllMyUserTiersQuery, AllMyUserTiersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AllMyUserTiersQuery, AllMyUserTiersQueryVariables>(AllMyUserTiersDocument, options);
      }
export function useAllMyUserTiersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AllMyUserTiersQuery, AllMyUserTiersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AllMyUserTiersQuery, AllMyUserTiersQueryVariables>(AllMyUserTiersDocument, options);
        }
export type AllMyUserTiersQueryHookResult = ReturnType<typeof useAllMyUserTiersQuery>;
export type AllMyUserTiersLazyQueryHookResult = ReturnType<typeof useAllMyUserTiersLazyQuery>;
export type AllMyUserTiersQueryResult = Apollo.QueryResult<AllMyUserTiersQuery, AllMyUserTiersQueryVariables>;
export const AllTemplatesDocument = gql`
    query allTemplates($query: DefaultQueryInput) {
  allTemplates(query: $query) {
    ...templateConnection
  }
}
    ${TemplateConnectionFragmentDoc}`;

/**
 * __useAllTemplatesQuery__
 *
 * To run a query within a React component, call `useAllTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllTemplatesQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useAllTemplatesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AllTemplatesQuery, AllTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AllTemplatesQuery, AllTemplatesQueryVariables>(AllTemplatesDocument, options);
      }
export function useAllTemplatesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AllTemplatesQuery, AllTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AllTemplatesQuery, AllTemplatesQueryVariables>(AllTemplatesDocument, options);
        }
export type AllTemplatesQueryHookResult = ReturnType<typeof useAllTemplatesQuery>;
export type AllTemplatesLazyQueryHookResult = ReturnType<typeof useAllTemplatesLazyQuery>;
export type AllTemplatesQueryResult = Apollo.QueryResult<AllTemplatesQuery, AllTemplatesQueryVariables>;
export const AllTemplateCategoriesDocument = gql`
    query allTemplateCategories($query: DefaultQueryInput) {
  allTemplateCategories(query: $query) {
    total
    cursor
    edges {
      ...templateCategory
    }
  }
}
    ${TemplateCategoryFragmentDoc}`;

/**
 * __useAllTemplateCategoriesQuery__
 *
 * To run a query within a React component, call `useAllTemplateCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllTemplateCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllTemplateCategoriesQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useAllTemplateCategoriesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AllTemplateCategoriesQuery, AllTemplateCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AllTemplateCategoriesQuery, AllTemplateCategoriesQueryVariables>(AllTemplateCategoriesDocument, options);
      }
export function useAllTemplateCategoriesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AllTemplateCategoriesQuery, AllTemplateCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AllTemplateCategoriesQuery, AllTemplateCategoriesQueryVariables>(AllTemplateCategoriesDocument, options);
        }
export type AllTemplateCategoriesQueryHookResult = ReturnType<typeof useAllTemplateCategoriesQuery>;
export type AllTemplateCategoriesLazyQueryHookResult = ReturnType<typeof useAllTemplateCategoriesLazyQuery>;
export type AllTemplateCategoriesQueryResult = Apollo.QueryResult<AllTemplateCategoriesQuery, AllTemplateCategoriesQueryVariables>;
export const AllUserTeamMembersDocument = gql`
    query allUserTeamMembers($query: DefaultQueryInput) {
  allUserTeamMembers(query: $query) {
    total
    edges {
      ...userTeamMemberSmall
    }
  }
}
    ${UserTeamMemberSmallFragmentDoc}`;

/**
 * __useAllUserTeamMembersQuery__
 *
 * To run a query within a React component, call `useAllUserTeamMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllUserTeamMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllUserTeamMembersQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useAllUserTeamMembersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AllUserTeamMembersQuery, AllUserTeamMembersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AllUserTeamMembersQuery, AllUserTeamMembersQueryVariables>(AllUserTeamMembersDocument, options);
      }
export function useAllUserTeamMembersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AllUserTeamMembersQuery, AllUserTeamMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AllUserTeamMembersQuery, AllUserTeamMembersQueryVariables>(AllUserTeamMembersDocument, options);
        }
export type AllUserTeamMembersQueryHookResult = ReturnType<typeof useAllUserTeamMembersQuery>;
export type AllUserTeamMembersLazyQueryHookResult = ReturnType<typeof useAllUserTeamMembersLazyQuery>;
export type AllUserTeamMembersQueryResult = Apollo.QueryResult<AllUserTeamMembersQuery, AllUserTeamMembersQueryVariables>;
export const AllUserTransactionsDocument = gql`
    query allUserTransactions($query: DefaultQueryInput) {
  allUserTransactions(query: $query) {
    total
    edges {
      ...userTransaction
    }
  }
}
    ${UserTransactionFragmentDoc}`;

/**
 * __useAllUserTransactionsQuery__
 *
 * To run a query within a React component, call `useAllUserTransactionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllUserTransactionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllUserTransactionsQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useAllUserTransactionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AllUserTransactionsQuery, AllUserTransactionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AllUserTransactionsQuery, AllUserTransactionsQueryVariables>(AllUserTransactionsDocument, options);
      }
export function useAllUserTransactionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AllUserTransactionsQuery, AllUserTransactionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AllUserTransactionsQuery, AllUserTransactionsQueryVariables>(AllUserTransactionsDocument, options);
        }
export type AllUserTransactionsQueryHookResult = ReturnType<typeof useAllUserTransactionsQuery>;
export type AllUserTransactionsLazyQueryHookResult = ReturnType<typeof useAllUserTransactionsLazyQuery>;
export type AllUserTransactionsQueryResult = Apollo.QueryResult<AllUserTransactionsQuery, AllUserTransactionsQueryVariables>;
export const AllUsersDocument = gql`
    query allUsers($query: DefaultQueryInput) {
  allUsers(query: $query) {
    edges {
      ...user
    }
  }
}
    ${UserFragmentDoc}`;

/**
 * __useAllUsersQuery__
 *
 * To run a query within a React component, call `useAllUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllUsersQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useAllUsersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AllUsersQuery, AllUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AllUsersQuery, AllUsersQueryVariables>(AllUsersDocument, options);
      }
export function useAllUsersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AllUsersQuery, AllUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AllUsersQuery, AllUsersQueryVariables>(AllUsersDocument, options);
        }
export type AllUsersQueryHookResult = ReturnType<typeof useAllUsersQuery>;
export type AllUsersLazyQueryHookResult = ReturnType<typeof useAllUsersLazyQuery>;
export type AllUsersQueryResult = Apollo.QueryResult<AllUsersQuery, AllUsersQueryVariables>;
export const AllWebTranslationsDocument = gql`
    query allWebTranslations($locale: String!) {
  allWebTranslations(locale: $locale) {
    ...systemTranslationConnection
  }
}
    ${SystemTranslationConnectionFragmentDoc}`;

/**
 * __useAllWebTranslationsQuery__
 *
 * To run a query within a React component, call `useAllWebTranslationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllWebTranslationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllWebTranslationsQuery({
 *   variables: {
 *      locale: // value for 'locale'
 *   },
 * });
 */
export function useAllWebTranslationsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AllWebTranslationsQuery, AllWebTranslationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AllWebTranslationsQuery, AllWebTranslationsQueryVariables>(AllWebTranslationsDocument, options);
      }
export function useAllWebTranslationsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AllWebTranslationsQuery, AllWebTranslationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AllWebTranslationsQuery, AllWebTranslationsQueryVariables>(AllWebTranslationsDocument, options);
        }
export type AllWebTranslationsQueryHookResult = ReturnType<typeof useAllWebTranslationsQuery>;
export type AllWebTranslationsLazyQueryHookResult = ReturnType<typeof useAllWebTranslationsLazyQuery>;
export type AllWebTranslationsQueryResult = Apollo.QueryResult<AllWebTranslationsQuery, AllWebTranslationsQueryVariables>;
export const LibraryCategoryDocument = gql`
    query libraryCategory($id: Int!) {
  libraryCategory(id: $id) {
    ...libraryCategory
  }
}
    ${LibraryCategoryFragmentDoc}`;

/**
 * __useLibraryCategoryQuery__
 *
 * To run a query within a React component, call `useLibraryCategoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useLibraryCategoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLibraryCategoryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLibraryCategoryQuery(baseOptions: ApolloReactHooks.QueryHookOptions<LibraryCategoryQuery, LibraryCategoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<LibraryCategoryQuery, LibraryCategoryQueryVariables>(LibraryCategoryDocument, options);
      }
export function useLibraryCategoryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<LibraryCategoryQuery, LibraryCategoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<LibraryCategoryQuery, LibraryCategoryQueryVariables>(LibraryCategoryDocument, options);
        }
export type LibraryCategoryQueryHookResult = ReturnType<typeof useLibraryCategoryQuery>;
export type LibraryCategoryLazyQueryHookResult = ReturnType<typeof useLibraryCategoryLazyQuery>;
export type LibraryCategoryQueryResult = Apollo.QueryResult<LibraryCategoryQuery, LibraryCategoryQueryVariables>;
export const LibraryTextPresetDocument = gql`
    query libraryTextPreset($id: Int!) {
  libraryTextPreset(id: $id) {
    ...libraryTextPreset
  }
}
    ${LibraryTextPresetFragmentDoc}`;

/**
 * __useLibraryTextPresetQuery__
 *
 * To run a query within a React component, call `useLibraryTextPresetQuery` and pass it any options that fit your needs.
 * When your component renders, `useLibraryTextPresetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLibraryTextPresetQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLibraryTextPresetQuery(baseOptions: ApolloReactHooks.QueryHookOptions<LibraryTextPresetQuery, LibraryTextPresetQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<LibraryTextPresetQuery, LibraryTextPresetQueryVariables>(LibraryTextPresetDocument, options);
      }
export function useLibraryTextPresetLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<LibraryTextPresetQuery, LibraryTextPresetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<LibraryTextPresetQuery, LibraryTextPresetQueryVariables>(LibraryTextPresetDocument, options);
        }
export type LibraryTextPresetQueryHookResult = ReturnType<typeof useLibraryTextPresetQuery>;
export type LibraryTextPresetLazyQueryHookResult = ReturnType<typeof useLibraryTextPresetLazyQuery>;
export type LibraryTextPresetQueryResult = Apollo.QueryResult<LibraryTextPresetQuery, LibraryTextPresetQueryVariables>;
export const LibraryTextPresetFlatDocument = gql`
    query libraryTextPresetFlat($id: Int!) {
  libraryTextPreset(id: $id) {
    ...libraryTextPresetFlat
  }
}
    ${LibraryTextPresetFlatFragmentDoc}`;

/**
 * __useLibraryTextPresetFlatQuery__
 *
 * To run a query within a React component, call `useLibraryTextPresetFlatQuery` and pass it any options that fit your needs.
 * When your component renders, `useLibraryTextPresetFlatQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLibraryTextPresetFlatQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLibraryTextPresetFlatQuery(baseOptions: ApolloReactHooks.QueryHookOptions<LibraryTextPresetFlatQuery, LibraryTextPresetFlatQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<LibraryTextPresetFlatQuery, LibraryTextPresetFlatQueryVariables>(LibraryTextPresetFlatDocument, options);
      }
export function useLibraryTextPresetFlatLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<LibraryTextPresetFlatQuery, LibraryTextPresetFlatQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<LibraryTextPresetFlatQuery, LibraryTextPresetFlatQueryVariables>(LibraryTextPresetFlatDocument, options);
        }
export type LibraryTextPresetFlatQueryHookResult = ReturnType<typeof useLibraryTextPresetFlatQuery>;
export type LibraryTextPresetFlatLazyQueryHookResult = ReturnType<typeof useLibraryTextPresetFlatLazyQuery>;
export type LibraryTextPresetFlatQueryResult = Apollo.QueryResult<LibraryTextPresetFlatQuery, LibraryTextPresetFlatQueryVariables>;
export const ProfileDocument = gql`
    query profile {
  profile {
    ...user
  }
}
    ${UserFragmentDoc}`;

/**
 * __useProfileQuery__
 *
 * To run a query within a React component, call `useProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProfileQuery({
 *   variables: {
 *   },
 * });
 */
export function useProfileQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ProfileQuery, ProfileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProfileQuery, ProfileQueryVariables>(ProfileDocument, options);
      }
export function useProfileLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProfileQuery, ProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProfileQuery, ProfileQueryVariables>(ProfileDocument, options);
        }
export type ProfileQueryHookResult = ReturnType<typeof useProfileQuery>;
export type ProfileLazyQueryHookResult = ReturnType<typeof useProfileLazyQuery>;
export type ProfileQueryResult = Apollo.QueryResult<ProfileQuery, ProfileQueryVariables>;
export const TemplateDocument = gql`
    query template($id: Int!) {
  template(id: $id) {
    ...template
  }
}
    ${TemplateFragmentDoc}`;

/**
 * __useTemplateQuery__
 *
 * To run a query within a React component, call `useTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTemplateQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTemplateQuery(baseOptions: ApolloReactHooks.QueryHookOptions<TemplateQuery, TemplateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TemplateQuery, TemplateQueryVariables>(TemplateDocument, options);
      }
export function useTemplateLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TemplateQuery, TemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TemplateQuery, TemplateQueryVariables>(TemplateDocument, options);
        }
export type TemplateQueryHookResult = ReturnType<typeof useTemplateQuery>;
export type TemplateLazyQueryHookResult = ReturnType<typeof useTemplateLazyQuery>;
export type TemplateQueryResult = Apollo.QueryResult<TemplateQuery, TemplateQueryVariables>;
export const TemplateFullDocument = gql`
    query templateFull($id: Int!) {
  template(id: $id) {
    ...templateFull
  }
}
    ${TemplateFullFragmentDoc}`;

/**
 * __useTemplateFullQuery__
 *
 * To run a query within a React component, call `useTemplateFullQuery` and pass it any options that fit your needs.
 * When your component renders, `useTemplateFullQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTemplateFullQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTemplateFullQuery(baseOptions: ApolloReactHooks.QueryHookOptions<TemplateFullQuery, TemplateFullQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TemplateFullQuery, TemplateFullQueryVariables>(TemplateFullDocument, options);
      }
export function useTemplateFullLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TemplateFullQuery, TemplateFullQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TemplateFullQuery, TemplateFullQueryVariables>(TemplateFullDocument, options);
        }
export type TemplateFullQueryHookResult = ReturnType<typeof useTemplateFullQuery>;
export type TemplateFullLazyQueryHookResult = ReturnType<typeof useTemplateFullLazyQuery>;
export type TemplateFullQueryResult = Apollo.QueryResult<TemplateFullQuery, TemplateFullQueryVariables>;
export const TemplateCategoryDocument = gql`
    query templateCategory($id: Int!) {
  templateCategory(id: $id) {
    ...templateCategory
  }
}
    ${TemplateCategoryFragmentDoc}`;

/**
 * __useTemplateCategoryQuery__
 *
 * To run a query within a React component, call `useTemplateCategoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useTemplateCategoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTemplateCategoryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTemplateCategoryQuery(baseOptions: ApolloReactHooks.QueryHookOptions<TemplateCategoryQuery, TemplateCategoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TemplateCategoryQuery, TemplateCategoryQueryVariables>(TemplateCategoryDocument, options);
      }
export function useTemplateCategoryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TemplateCategoryQuery, TemplateCategoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TemplateCategoryQuery, TemplateCategoryQueryVariables>(TemplateCategoryDocument, options);
        }
export type TemplateCategoryQueryHookResult = ReturnType<typeof useTemplateCategoryQuery>;
export type TemplateCategoryLazyQueryHookResult = ReturnType<typeof useTemplateCategoryLazyQuery>;
export type TemplateCategoryQueryResult = Apollo.QueryResult<TemplateCategoryQuery, TemplateCategoryQueryVariables>;
export const UserRoleDocument = gql`
    query userRole($id: Int!) {
  userRole(id: $id) {
    ...userRole
  }
}
    ${UserRoleFragmentDoc}`;

/**
 * __useUserRoleQuery__
 *
 * To run a query within a React component, call `useUserRoleQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserRoleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserRoleQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserRoleQuery(baseOptions: ApolloReactHooks.QueryHookOptions<UserRoleQuery, UserRoleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<UserRoleQuery, UserRoleQueryVariables>(UserRoleDocument, options);
      }
export function useUserRoleLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UserRoleQuery, UserRoleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<UserRoleQuery, UserRoleQueryVariables>(UserRoleDocument, options);
        }
export type UserRoleQueryHookResult = ReturnType<typeof useUserRoleQuery>;
export type UserRoleLazyQueryHookResult = ReturnType<typeof useUserRoleLazyQuery>;
export type UserRoleQueryResult = Apollo.QueryResult<UserRoleQuery, UserRoleQueryVariables>;
export const UserRolesDocument = gql`
    query userRoles($query: DefaultQueryInput) {
  userRoles(query: $query) {
    ...userRole
  }
}
    ${UserRoleFragmentDoc}`;

/**
 * __useUserRolesQuery__
 *
 * To run a query within a React component, call `useUserRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserRolesQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useUserRolesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<UserRolesQuery, UserRolesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<UserRolesQuery, UserRolesQueryVariables>(UserRolesDocument, options);
      }
export function useUserRolesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UserRolesQuery, UserRolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<UserRolesQuery, UserRolesQueryVariables>(UserRolesDocument, options);
        }
export type UserRolesQueryHookResult = ReturnType<typeof useUserRolesQuery>;
export type UserRolesLazyQueryHookResult = ReturnType<typeof useUserRolesLazyQuery>;
export type UserRolesQueryResult = Apollo.QueryResult<UserRolesQuery, UserRolesQueryVariables>;
export const UserUserTierDocument = gql`
    query userUserTier($id: Int!) {
  userUserTier(id: $id) {
    ...userUserTier
  }
}
    ${UserUserTierFragmentDoc}`;

/**
 * __useUserUserTierQuery__
 *
 * To run a query within a React component, call `useUserUserTierQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserUserTierQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserUserTierQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserUserTierQuery(baseOptions: ApolloReactHooks.QueryHookOptions<UserUserTierQuery, UserUserTierQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<UserUserTierQuery, UserUserTierQueryVariables>(UserUserTierDocument, options);
      }
export function useUserUserTierLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UserUserTierQuery, UserUserTierQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<UserUserTierQuery, UserUserTierQueryVariables>(UserUserTierDocument, options);
        }
export type UserUserTierQueryHookResult = ReturnType<typeof useUserUserTierQuery>;
export type UserUserTierLazyQueryHookResult = ReturnType<typeof useUserUserTierLazyQuery>;
export type UserUserTierQueryResult = Apollo.QueryResult<UserUserTierQuery, UserUserTierQueryVariables>;
export const WebTranslationsUpdatedAtDocument = gql`
    query webTranslationsUpdatedAt($locale: String!) {
  webTranslationsUpdatedAt(locale: $locale)
}
    `;

/**
 * __useWebTranslationsUpdatedAtQuery__
 *
 * To run a query within a React component, call `useWebTranslationsUpdatedAtQuery` and pass it any options that fit your needs.
 * When your component renders, `useWebTranslationsUpdatedAtQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWebTranslationsUpdatedAtQuery({
 *   variables: {
 *      locale: // value for 'locale'
 *   },
 * });
 */
export function useWebTranslationsUpdatedAtQuery(baseOptions: ApolloReactHooks.QueryHookOptions<WebTranslationsUpdatedAtQuery, WebTranslationsUpdatedAtQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<WebTranslationsUpdatedAtQuery, WebTranslationsUpdatedAtQueryVariables>(WebTranslationsUpdatedAtDocument, options);
      }
export function useWebTranslationsUpdatedAtLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<WebTranslationsUpdatedAtQuery, WebTranslationsUpdatedAtQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<WebTranslationsUpdatedAtQuery, WebTranslationsUpdatedAtQueryVariables>(WebTranslationsUpdatedAtDocument, options);
        }
export type WebTranslationsUpdatedAtQueryHookResult = ReturnType<typeof useWebTranslationsUpdatedAtQuery>;
export type WebTranslationsUpdatedAtLazyQueryHookResult = ReturnType<typeof useWebTranslationsUpdatedAtLazyQuery>;
export type WebTranslationsUpdatedAtQueryResult = Apollo.QueryResult<WebTranslationsUpdatedAtQuery, WebTranslationsUpdatedAtQueryVariables>;